var dc = Object.defineProperty;
var hc = (n, e, t) => e in n ? dc(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var F = (n, e, t) => hc(n, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as T, jsx as h, Fragment as je } from "react/jsx-runtime";
import * as Os from "react";
import jt, { forwardRef as le, createElement as tn, useState as Z, useRef as Ie, useMemo as He, useEffect as ve, Fragment as gr, createContext as ze, useId as Tt, useContext as ce, useInsertionEffect as Oo, useCallback as Pt, Children as fc, isValidElement as In, useLayoutEffect as rr, Component as pc, cloneElement as Fo } from "react";
import * as mt from "@radix-ui/react-alert-dialog";
import { Slot as Ro } from "@radix-ui/react-slot";
import * as Ze from "@radix-ui/react-popover";
import * as Le from "@radix-ui/react-dialog";
import * as Hn from "@radix-ui/react-tabs";
import * as nt from "@radix-ui/react-select";
import { createPortal as mc } from "react-dom";
function Io(n) {
  var e, t, r = "";
  if (typeof n == "string" || typeof n == "number") r += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var s = n.length;
    for (e = 0; e < s; e++) n[e] && (t = Io(n[e])) && (r && (r += " "), r += t);
  } else for (t in n) n[t] && (r && (r += " "), r += t);
  return r;
}
function Vo() {
  for (var n, e, t = 0, r = "", s = arguments.length; t < s; t++) (n = arguments[t]) && (e = Io(n)) && (r && (r += " "), r += e);
  return r;
}
const Fs = "-", gc = (n) => {
  const e = yc(n), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: r
  } = n;
  return {
    getClassGroupId: (a) => {
      const o = a.split(Fs);
      return o[0] === "" && o.length !== 1 && o.shift(), Bo(o, e) || vc(a);
    },
    getConflictingClassGroupIds: (a, o) => {
      const l = t[a] || [];
      return o && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, Bo = (n, e) => {
  var a;
  if (n.length === 0)
    return e.classGroupId;
  const t = n[0], r = e.nextPart.get(t), s = r ? Bo(n.slice(1), r) : void 0;
  if (s)
    return s;
  if (e.validators.length === 0)
    return;
  const i = n.join(Fs);
  return (a = e.validators.find(({
    validator: o
  }) => o(i))) == null ? void 0 : a.classGroupId;
}, Wi = /^\[(.+)\]$/, vc = (n) => {
  if (Wi.test(n)) {
    const e = Wi.exec(n)[1], t = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}, yc = (n) => {
  const {
    theme: e,
    prefix: t
  } = n, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return kc(Object.entries(n.classGroups), t).forEach(([i, a]) => {
    us(a, r, i, e);
  }), r;
}, us = (n, e, t, r) => {
  n.forEach((s) => {
    if (typeof s == "string") {
      const i = s === "" ? e : Yi(e, s);
      i.classGroupId = t;
      return;
    }
    if (typeof s == "function") {
      if (bc(s)) {
        us(s(r), e, t, r);
        return;
      }
      e.validators.push({
        validator: s,
        classGroupId: t
      });
      return;
    }
    Object.entries(s).forEach(([i, a]) => {
      us(a, Yi(e, i), t, r);
    });
  });
}, Yi = (n, e) => {
  let t = n;
  return e.split(Fs).forEach((r) => {
    t.nextPart.has(r) || t.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(r);
  }), t;
}, bc = (n) => n.isThemeGetter, kc = (n, e) => e ? n.map(([t, r]) => {
  const s = r.map((i) => typeof i == "string" ? e + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, o]) => [e + a, o])) : i);
  return [t, s];
}) : n, wc = (n) => {
  if (n < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const s = (i, a) => {
    t.set(i, a), e++, e > n && (e = 0, r = t, t = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = t.get(i);
      if (a !== void 0)
        return a;
      if ((a = r.get(i)) !== void 0)
        return s(i, a), a;
    },
    set(i, a) {
      t.has(i) ? t.set(i, a) : s(i, a);
    }
  };
}, Lo = "!", _c = (n) => {
  const {
    separator: e,
    experimentalParseClassName: t
  } = n, r = e.length === 1, s = e[0], i = e.length, a = (o) => {
    const l = [];
    let u = 0, c = 0, d;
    for (let b = 0; b < o.length; b++) {
      let k = o[b];
      if (u === 0) {
        if (k === s && (r || o.slice(b, b + i) === e)) {
          l.push(o.slice(c, b)), c = b + i;
          continue;
        }
        if (k === "/") {
          d = b;
          continue;
        }
      }
      k === "[" ? u++ : k === "]" && u--;
    }
    const f = l.length === 0 ? o : o.substring(c), p = f.startsWith(Lo), g = p ? f.substring(1) : f, y = d && d > c ? d - c : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: y
    };
  };
  return t ? (o) => t({
    className: o,
    parseClassName: a
  }) : a;
}, xc = (n) => {
  if (n.length <= 1)
    return n;
  const e = [];
  let t = [];
  return n.forEach((r) => {
    r[0] === "[" ? (e.push(...t.sort(), r), t = []) : t.push(r);
  }), e.push(...t.sort()), e;
}, Tc = (n) => ({
  cache: wc(n.cacheSize),
  parseClassName: _c(n),
  ...gc(n)
}), Cc = /\s+/, Mc = (n, e) => {
  const {
    parseClassName: t,
    getClassGroupId: r,
    getConflictingClassGroupIds: s
  } = e, i = [], a = n.trim().split(Cc);
  let o = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const u = a[l], {
      modifiers: c,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: p
    } = t(u);
    let g = !!p, y = r(g ? f.substring(0, p) : f);
    if (!y) {
      if (!g) {
        o = u + (o.length > 0 ? " " + o : o);
        continue;
      }
      if (y = r(f), !y) {
        o = u + (o.length > 0 ? " " + o : o);
        continue;
      }
      g = !1;
    }
    const b = xc(c).join(":"), k = d ? b + Lo : b, w = k + y;
    if (i.includes(w))
      continue;
    i.push(w);
    const m = s(y, g);
    for (let _ = 0; _ < m.length; ++_) {
      const v = m[_];
      i.push(k + v);
    }
    o = u + (o.length > 0 ? " " + o : o);
  }
  return o;
};
function Dc() {
  let n = 0, e, t, r = "";
  for (; n < arguments.length; )
    (e = arguments[n++]) && (t = jo(e)) && (r && (r += " "), r += t);
  return r;
}
const jo = (n) => {
  if (typeof n == "string")
    return n;
  let e, t = "";
  for (let r = 0; r < n.length; r++)
    n[r] && (e = jo(n[r])) && (t && (t += " "), t += e);
  return t;
};
function Ec(n, ...e) {
  let t, r, s, i = a;
  function a(l) {
    const u = e.reduce((c, d) => d(c), n());
    return t = Tc(u), r = t.cache.get, s = t.cache.set, i = o, o(l);
  }
  function o(l) {
    const u = r(l);
    if (u)
      return u;
    const c = Mc(l, t);
    return s(l, c), c;
  }
  return function() {
    return i(Dc.apply(null, arguments));
  };
}
const fe = (n) => {
  const e = (t) => t[n] || [];
  return e.isThemeGetter = !0, e;
}, Wo = /^\[(?:([a-z-]+):)?(.+)\]$/i, Ac = /^\d+\/\d+$/, Pc = /* @__PURE__ */ new Set(["px", "full", "screen"]), Sc = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Nc = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Oc = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Fc = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Rc = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, gt = (n) => Jt(n) || Pc.has(n) || Ac.test(n), Ct = (n) => dn(n, "length", $c), Jt = (n) => !!n && !Number.isNaN(Number(n)), Ir = (n) => dn(n, "number", Jt), gn = (n) => !!n && Number.isInteger(Number(n)), Ic = (n) => n.endsWith("%") && Jt(n.slice(0, -1)), H = (n) => Wo.test(n), Mt = (n) => Sc.test(n), Vc = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Bc = (n) => dn(n, Vc, Yo), Lc = (n) => dn(n, "position", Yo), jc = /* @__PURE__ */ new Set(["image", "url"]), Wc = (n) => dn(n, jc, Uc), Yc = (n) => dn(n, "", zc), vn = () => !0, dn = (n, e, t) => {
  const r = Wo.exec(n);
  return r ? r[1] ? typeof e == "string" ? r[1] === e : e.has(r[1]) : t(r[2]) : !1;
}, $c = (n) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Nc.test(n) && !Oc.test(n)
), Yo = () => !1, zc = (n) => Fc.test(n), Uc = (n) => Rc.test(n), Hc = () => {
  const n = fe("colors"), e = fe("spacing"), t = fe("blur"), r = fe("brightness"), s = fe("borderColor"), i = fe("borderRadius"), a = fe("borderSpacing"), o = fe("borderWidth"), l = fe("contrast"), u = fe("grayscale"), c = fe("hueRotate"), d = fe("invert"), f = fe("gap"), p = fe("gradientColorStops"), g = fe("gradientColorStopPositions"), y = fe("inset"), b = fe("margin"), k = fe("opacity"), w = fe("padding"), m = fe("saturate"), _ = fe("scale"), v = fe("sepia"), x = fe("skew"), P = fe("space"), R = fe("translate"), B = () => ["auto", "contain", "none"], ue = () => ["auto", "hidden", "clip", "visible", "scroll"], ae = () => ["auto", H, e], $ = () => [H, e], Te = () => ["", gt, Ct], ke = () => ["auto", Jt, H], Se = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], we = () => ["solid", "dashed", "dotted", "double", "none"], E = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], A = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Ee = () => ["", "0", H], M = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], D = () => [Jt, H];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [vn],
      spacing: [gt, Ct],
      blur: ["none", "", Mt, H],
      brightness: D(),
      borderColor: [n],
      borderRadius: ["none", "", "full", Mt, H],
      borderSpacing: $(),
      borderWidth: Te(),
      contrast: D(),
      grayscale: Ee(),
      hueRotate: D(),
      invert: Ee(),
      gap: $(),
      gradientColorStops: [n],
      gradientColorStopPositions: [Ic, Ct],
      inset: ae(),
      margin: ae(),
      opacity: D(),
      padding: $(),
      saturate: D(),
      scale: D(),
      sepia: Ee(),
      skew: D(),
      space: $(),
      translate: $()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", H]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Mt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": M()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": M()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Se(), H]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: ue()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": ue()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": ue()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [y]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [y]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [y]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [y]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [y]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [y]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [y]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [y]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [y]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", gn, H]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: ae()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", H]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Ee()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Ee()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", gn, H]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [vn]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", gn, H]
        }, H]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ke()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ke()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [vn]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [gn, H]
        }, H]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ke()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ke()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...A()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...A(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...A(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", H, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [H, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [H, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Mt]
        }, Mt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [H, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [H, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [H, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [H, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Mt, Ct]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ir]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [vn]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", H]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Jt, Ir]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", gt, H]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", H]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", H]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [n]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [k]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [n]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [k]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...we(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", gt, Ct]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", gt, H]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [n]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: $()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", H]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", H]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [k]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Se(), Lc]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Bc]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Wc]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [n]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [o]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [o]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [o]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [o]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [o]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [o]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [o]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [o]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [o]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [k]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...we(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [o]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [o]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [k]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: we()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [s]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [s]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [s]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [s]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [s]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [s]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [s]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [s]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [s]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [s]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...we()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [gt, H]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [gt, Ct]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [n]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: Te()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [n]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [k]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [gt, Ct]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [n]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Mt, Yc]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [vn]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [k]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...E(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": E()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Mt, H]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [m]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [v]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [k]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [m]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [v]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", H]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: D()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", H]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: D()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", H]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [_]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [_]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [_]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [gn, H]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [x]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [x]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", H]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", n]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", H]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [n]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": $()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": $()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": $()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": $()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": $()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": $()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": $()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": $()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": $()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": $()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": $()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": $()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": $()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": $()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": $()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": $()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": $()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": $()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", H]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [n, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [gt, Ct, Ir]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [n, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, qc = /* @__PURE__ */ Ec(Hc);
function S(...n) {
  return qc(Vo(n));
}
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gc = (n) => n.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), $o = (...n) => n.filter((e, t, r) => !!e && e.trim() !== "" && r.indexOf(e) === t).join(" ").trim();
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Kc = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xc = le(
  ({
    color: n = "currentColor",
    size: e = 24,
    strokeWidth: t = 2,
    absoluteStrokeWidth: r,
    className: s = "",
    children: i,
    iconNode: a,
    ...o
  }, l) => tn(
    "svg",
    {
      ref: l,
      ...Kc,
      width: e,
      height: e,
      stroke: n,
      strokeWidth: r ? Number(t) * 24 / Number(e) : t,
      className: $o("lucide", s),
      ...o
    },
    [
      ...a.map(([u, c]) => tn(u, c)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pe = (n, e) => {
  const t = le(
    ({ className: r, ...s }, i) => tn(Xc, {
      ref: i,
      iconNode: e,
      className: $o(`lucide-${Gc(n)}`, r),
      ...s
    })
  );
  return t.displayName = `${n}`, t;
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qc = Pe("CalendarDays", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vr = Pe("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sr = Pe("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zc = Pe("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jc = Pe("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ed = Pe("ChevronsUpDown", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const td = Pe("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nd = Pe("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rd = Pe("Columns3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sd = Pe("EllipsisVertical", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const id = Pe("Filter", [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ad = Pe("GripVertical", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const od = Pe("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ld = Pe("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ud = Pe("Palette", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zo = Pe("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cd = Pe("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yr = Pe("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), dd = {
  info: od,
  success: nd,
  warning: cd,
  danger: td
};
function hk({ children: n, className: e, closeLabel: t, onClose: r, title: s, variant: i = "info", ...a }) {
  const o = dd[i];
  return /* @__PURE__ */ T("div", { className: S("akuna-alert", e), "data-variant": i, role: "alert", ...a, children: [
    /* @__PURE__ */ h(o, { "aria-hidden": "true", className: "akuna-alert__icon", size: 18 }),
    /* @__PURE__ */ T("div", { className: "akuna-alert__body", children: [
      s ? /* @__PURE__ */ h("strong", { className: "akuna-alert__title", children: s }) : null,
      n ? /* @__PURE__ */ h("div", { className: "akuna-alert__content", children: n }) : null
    ] }),
    r ? /* @__PURE__ */ h("button", { type: "button", className: "akuna-alert__close", "aria-label": t ?? "Close alert", onClick: r, children: /* @__PURE__ */ h(yr, { "aria-hidden": "true", size: 16 }) }) : null
  ] });
}
function fk({ children: n, className: e, ...t }) {
  return /* @__PURE__ */ h("strong", { className: S("akuna-alert__title", e), ...t, children: n });
}
function pk({ children: n, className: e, ...t }) {
  return /* @__PURE__ */ h("div", { className: S("akuna-alert__content", e), ...t, children: n });
}
const $i = (n) => typeof n == "boolean" ? `${n}` : n === 0 ? "0" : n, zi = Vo, hd = (n, e) => (t) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null) return zi(n, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
  const { variants: s, defaultVariants: i } = e, a = Object.keys(s).map((u) => {
    const c = t == null ? void 0 : t[u], d = i == null ? void 0 : i[u];
    if (c === null) return null;
    const f = $i(c) || $i(d);
    return s[u][f];
  }), o = t && Object.entries(t).reduce((u, c) => {
    let [d, f] = c;
    return f === void 0 || (u[d] = f), u;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: d, className: f, ...p } = c;
    return Object.entries(p).every((g) => {
      let [y, b] = g;
      return Array.isArray(b) ? b.includes({
        ...i,
        ...o
      }[y]) : {
        ...i,
        ...o
      }[y] === b;
    }) ? [
      ...u,
      d,
      f
    ] : u;
  }, []);
  return zi(n, a, l, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
}, fd = hd("akuna-button akuna-hit-target", {
  variants: {
    variant: {
      default: "akuna-button--default",
      secondary: "akuna-button--secondary",
      outline: "akuna-button--outline",
      ghost: "akuna-button--ghost",
      destructive: "akuna-button--destructive",
      link: "akuna-button--link"
    },
    size: {
      sm: "akuna-button--sm",
      md: "akuna-button--md",
      lg: "akuna-button--lg",
      /** Alias for md — kept for compatibility with legacy callsites. */
      default: "akuna-button--md",
      /** Square icon button (40 × 40 px, no padding). */
      icon: "akuna-button--icon",
      /** Small square icon button (32 × 32 px, no padding). */
      "icon-sm": "akuna-button--icon-sm"
    },
    fullWidth: {
      true: "akuna-button--full"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
}), ht = le(
  ({ asChild: n = !1, children: e, className: t, disabled: r, fullWidth: s, loading: i = !1, size: a, type: o = "button", variant: l, ...u }, c) => {
    const d = n ? Ro : "button", f = r || i;
    return /* @__PURE__ */ h(
      d,
      {
        ref: c,
        "aria-busy": i || void 0,
        className: S(fd({ fullWidth: s, size: a, variant: l }), t),
        "data-loading": i || void 0,
        "data-size": a ?? "md",
        "data-variant": l ?? "default",
        disabled: f,
        type: n ? void 0 : o,
        ...u,
        children: n ? e : /* @__PURE__ */ T(je, { children: [
          i ? /* @__PURE__ */ h("span", { "aria-hidden": "true", className: "akuna-button__spinner" }) : null,
          /* @__PURE__ */ h("span", { className: "akuna-button__content", children: e })
        ] })
      }
    );
  }
);
ht.displayName = "Button";
function mk({ actionLabel: n, cancelLabel: e, children: t, className: r, defaultOpen: s, onAction: i, onOpenChange: a, open: o, title: l, trigger: u }) {
  return /* @__PURE__ */ T(mt.Root, { defaultOpen: s, onOpenChange: a, open: o, children: [
    u ? /* @__PURE__ */ h(mt.Trigger, { asChild: !0, children: u }) : null,
    /* @__PURE__ */ T(mt.Portal, { children: [
      /* @__PURE__ */ h(mt.Overlay, { className: "akuna-overlay" }),
      /* @__PURE__ */ T(mt.Content, { className: S("akuna-dialog akuna-alert-dialog", r), children: [
        /* @__PURE__ */ h(mt.Title, { className: "akuna-dialog__title", children: l }),
        /* @__PURE__ */ h(mt.Description, { className: "akuna-dialog__description", children: t }),
        /* @__PURE__ */ T("div", { className: "akuna-dialog__footer", children: [
          /* @__PURE__ */ h(mt.Cancel, { asChild: !0, children: /* @__PURE__ */ h(ht, { variant: "outline", children: e }) }),
          /* @__PURE__ */ h(mt.Action, { asChild: !0, children: /* @__PURE__ */ h(ht, { onClick: i, variant: "destructive", children: n }) })
        ] })
      ] })
    ] })
  ] });
}
function gk({ className: n, fallback: e, name: t, src: r, ...s }) {
  return /* @__PURE__ */ h("div", { "aria-label": t, className: S("akuna-avatar", n), role: "img", ...s, children: r ? /* @__PURE__ */ h("img", { alt: "", className: "akuna-avatar__image", src: r }) : /* @__PURE__ */ h("span", { className: "akuna-avatar__fallback", children: e }) });
}
function pd({ className: n, variant: e = "default", ...t }) {
  return /* @__PURE__ */ h("span", { className: S("akuna-badge", n), "data-variant": e, ...t });
}
function md({ className: n, items: e, label: t = "Navegação inferior", onValueChange: r, value: s, ...i }) {
  return /* @__PURE__ */ h("nav", { "aria-label": t, className: S("akuna-bottom-nav akuna-safe-bottom", n), ...i, children: e.slice(0, 5).map((a) => /* @__PURE__ */ h(
    "a",
    {
      "aria-current": a.value === s ? "page" : void 0,
      className: "akuna-bottom-nav__link",
      href: a.href,
      onClick: () => r == null ? void 0 : r(a.value),
      children: a.label
    },
    a.value
  )) });
}
function vk({ className: n, items: e, label: t = "Breadcrumb", ...r }) {
  return /* @__PURE__ */ h("nav", { "aria-label": t, className: S("akuna-breadcrumb", n), ...r, children: /* @__PURE__ */ h("ol", { children: e.map((s, i) => /* @__PURE__ */ h("li", { children: s.current ? /* @__PURE__ */ h("span", { "aria-current": "page", children: s.label }) : /* @__PURE__ */ h("a", { href: s.href ?? "#", children: s.label }) }, i)) }) });
}
const Uo = le(({ className: n, ...e }, t) => /* @__PURE__ */ h("article", { ref: t, className: S("akuna-card", n), ...e }));
Uo.displayName = "Card";
function gd({ className: n, labels: e, onPageChange: t, page: r, totalPages: s, ...i }) {
  const a = (e == null ? void 0 : e.previous) ?? "Página anterior", o = (e == null ? void 0 : e.next) ?? "Próxima página";
  return /* @__PURE__ */ T("nav", { "aria-label": "Paginação", className: S("akuna-pagination", n), ...i, children: [
    /* @__PURE__ */ h(ht, { "aria-label": a, disabled: r <= 1, onClick: () => t == null ? void 0 : t(r - 1), size: "sm", variant: "outline", children: "‹" }),
    /* @__PURE__ */ T("span", { className: "akuna-pagination__status", children: [
      r,
      " / ",
      s
    ] }),
    /* @__PURE__ */ h(ht, { "aria-label": o, disabled: r >= s, onClick: () => t == null ? void 0 : t(r + 1), size: "sm", variant: "outline", children: "›" })
  ] });
}
function vd({ content: n, trigger: e }) {
  return /* @__PURE__ */ T(Ze.Root, { children: [
    /* @__PURE__ */ h(Ze.Trigger, { asChild: !0, children: e }),
    /* @__PURE__ */ h(Ze.Portal, { children: /* @__PURE__ */ h(Ze.Content, { className: "akuna-popover", sideOffset: 8, collisionPadding: 8, children: n }) })
  ] });
}
const Ui = 140, yd = 64, yn = 44;
function Hi(n, e) {
  const t = new Set(n), r = e.filter((a) => t.has(a)), s = new Set(r), i = [...r];
  return n.forEach((a, o) => {
    if (s.has(a)) return;
    const l = n.slice(o + 1).find((c) => s.has(c)), u = l ? i.indexOf(l) : -1;
    u >= 0 ? i.splice(u, 0, a) : i.push(a);
  }), i;
}
const bd = {
  columnsButton: "Colunas",
  reset: "Restaurar",
  columnsTitle: "Exibir colunas",
  densityComfortable: "Confortável",
  densityCompact: "Compacto",
  empty: "Nenhum resultado"
};
function yk(n) {
  const {
    className: e,
    columns: t,
    data: r,
    defaultDensity: s = "comfortable",
    defaultSort: i,
    density: a,
    expandLabel: o = "Ver detalhes",
    getRowId: l,
    hideHorizontalScroll: u,
    isRowExpandable: c,
    onPageChange: d,
    onRowClick: f,
    onSortChange: p,
    onWidthsChange: g,
    page: y,
    pageSize: b,
    paginationLabels: k,
    renderExpandedRow: w,
    persistKey: m,
    showColumnToggle: _,
    showDensityToggle: v,
    toolbar: x,
    totalItems: P
  } = n, R = { ...bd, ...n.labels }, [B, ue] = Z(i ?? null), [ae, $] = Z(() => {
    const C = {};
    return t.forEach((O) => {
      C[O.id] = !O.defaultHidden;
    }), C;
  }), [Te, ke] = Z(() => t.map((C) => C.id)), [Se, we] = Z(() => {
    const C = {};
    return t.forEach((O) => {
      C[O.id] = O.width ?? Ui;
    }), C;
  }), [E, A] = Z(s), [Ee, M] = Z(1), [D, Q] = Z([]), [q, Y] = Z(null), [ee, U] = Z(null), z = Ie(null), X = a ?? E, te = y ?? Ee, J = He(() => t.map((C) => C.id), [t]), me = He(() => Hi(J, Te), [J, Te]);
  ve(() => {
    if (m)
      try {
        const C = localStorage.getItem(m);
        if (!C) return;
        const O = JSON.parse(C);
        Array.isArray(O.order) && O.order.length && ke(Hi(J, O.order)), n.visibility === void 0 && O.visible && $((re) => ({ ...re, ...O.visible })), O.widths && we((re) => ({ ...re, ...O.widths })), O.density && A(O.density), O.sort && ue(O.sort);
      } catch {
      }
  }, [m]), ve(() => {
    me.length === Te.length && me.every((C, O) => C === Te[O]) || ke(me);
  }, [me, Te]), ve(() => {
    if (m)
      try {
        const C = localStorage.getItem(m), re = {
          ...C ? JSON.parse(C) : {},
          order: me,
          widths: Se,
          density: X,
          sort: B,
          // when visibility is controlled externally, don't clobber the caller's persisted value
          ...n.visibility === void 0 ? { visible: ae } : {}
        };
        localStorage.setItem(m, JSON.stringify(re));
      } catch {
      }
  }, [m, me, ae, Se, X, B, n.visibility]), ve(() => {
    const C = (re) => {
      const _e = z.current;
      if (!_e) return;
      const Ae = Math.max(_e.min, Math.round(_e.startW + (re.clientX - _e.startX)));
      we((Ht) => ({ ...Ht, [_e.id]: Ae }));
    }, O = () => {
      z.current && (z.current = null, we((re) => (g == null || g(re), re)));
    };
    return document.addEventListener("mousemove", C), document.addEventListener("mouseup", O), () => {
      document.removeEventListener("mousemove", C), document.removeEventListener("mouseup", O);
    };
  }, [g]);
  const N = (C) => t.find((O) => O.id === C), Ke = n.visibility ?? ae, ft = me.map(N).filter((C) => !!C && Ke[C.id] !== !1), pt = (C) => Se[C.id] ?? C.width ?? Ui, Ii = (C) => C.grow ? `1 1 ${pt(C)}px` : `0 0 ${pt(C)}px`, nc = (C) => !!w && (c ? c(C) : !0), Fr = !!w, Vi = ft.reduce((C, O) => C + pt(O), 0) + (Fr ? yn : 0), rc = (C) => {
    Q((O) => O.includes(C) ? O.filter((re) => re !== C) : [...O, C]);
  }, Bi = (C) => {
    C.sortAccessor && ue((O) => {
      const re = (O == null ? void 0 : O.columnId) === C.id && O.direction === "asc" ? "desc" : "asc", _e = { columnId: C.id, direction: re };
      return p == null || p(_e), _e;
    });
  }, sc = (C) => {
    $((O) => {
      var _e;
      const re = { ...O, [C]: O[C] === !1 };
      return Object.values(re).every((Ae) => Ae === !1) ? O : ((_e = n.onVisibilityChange) == null || _e.call(n, re), re);
    });
  }, ic = () => {
    var O;
    const C = {};
    t.forEach((re) => {
      C[re.id] = !re.defaultHidden;
    }), $(C), (O = n.onVisibilityChange) == null || O.call(n, C);
  }, ac = (C, O) => {
    !C || C === O || (ke((re) => {
      var Ae;
      const _e = re.filter((Ht) => Ht !== C);
      return _e.splice(_e.indexOf(O), 0, C), (Ae = n.onOrderChange) == null || Ae.call(n, _e), _e;
    }), Y(null), U(null));
  }, oc = (C, O) => {
    O.preventDefault(), O.stopPropagation(), z.current = { id: C.id, startX: O.clientX, startW: pt(C), min: C.minWidth ?? yd };
  }, Rr = He(() => {
    if (!B) return r;
    const C = t.find((re) => re.id === B.columnId);
    if (!(C != null && C.sortAccessor)) return r;
    const O = B.direction === "asc" ? 1 : -1;
    return r.slice().sort((re, _e) => {
      const Ae = C.sortAccessor(re), Ht = C.sortAccessor(_e);
      return Ae < Ht ? -1 * O : Ae > Ht ? 1 * O : 0;
    });
  }, [t, r, B]), lc = P !== void 0, Li = P ?? Rr.length, ji = b ? Math.max(1, Math.ceil(Li / b)) : 1, mn = Math.min(te, ji), Un = b && !lc ? Rr.slice((mn - 1) * b, mn * b) : Rr, uc = (C) => {
    y === void 0 && M(C), d == null || d(C);
  }, cc = (C) => C.sortAccessor ? (B == null ? void 0 : B.columnId) !== C.id ? /* @__PURE__ */ h(ed, { "aria-hidden": "true", className: "akuna-data-table__sort", size: 14 }) : B.direction === "asc" ? /* @__PURE__ */ h(Jc, { "aria-hidden": "true", className: "akuna-data-table__sort akuna-data-table__sort--active", size: 14 }) : /* @__PURE__ */ h(sr, { "aria-hidden": "true", className: "akuna-data-table__sort akuna-data-table__sort--active", size: 14 }) : null;
  return /* @__PURE__ */ T("div", { className: S("akuna-data-table", e), "data-density": X, children: [
    x || _ || v ? /* @__PURE__ */ T("div", { className: "akuna-data-table__toolbar", children: [
      x ? /* @__PURE__ */ h("div", { className: "akuna-data-table__toolbar-slot", children: x }) : null,
      /* @__PURE__ */ T("div", { className: "akuna-data-table__toolbar-controls", children: [
        v ? /* @__PURE__ */ T("div", { className: "akuna-data-table__density", children: [
          /* @__PURE__ */ h("button", { "data-active": X === "comfortable", onClick: () => A("comfortable"), type: "button", children: R.densityComfortable }),
          /* @__PURE__ */ h("button", { "data-active": X === "compact", onClick: () => A("compact"), type: "button", children: R.densityCompact })
        ] }) : null,
        _ ? /* @__PURE__ */ h(
          vd,
          {
            trigger: /* @__PURE__ */ T(ht, { size: "sm", variant: "outline", children: [
              /* @__PURE__ */ h(rd, { size: 16 }),
              R.columnsButton,
              /* @__PURE__ */ T("span", { className: "akuna-data-table__count", children: [
                ft.length,
                "/",
                t.length
              ] })
            ] }),
            content: /* @__PURE__ */ T("div", { className: "akuna-data-table__col-panel", children: [
              /* @__PURE__ */ T("div", { className: "akuna-data-table__col-panel-head", children: [
                /* @__PURE__ */ h("span", { children: R.columnsTitle }),
                /* @__PURE__ */ h("button", { className: "akuna-data-table__reset", onClick: ic, type: "button", children: R.reset })
              ] }),
              me.map(N).filter((C) => !!C).map((C) => {
                const O = ae[C.id] !== !1;
                return /* @__PURE__ */ T(
                  "button",
                  {
                    className: "akuna-data-table__col-item",
                    onClick: () => sc(C.id),
                    type: "button",
                    children: [
                      /* @__PURE__ */ h("span", { className: "akuna-data-table__check", "data-on": O, children: O ? /* @__PURE__ */ h(vr, { size: 12 }) : null }),
                      /* @__PURE__ */ h("span", { children: C.header })
                    ]
                  },
                  C.id
                );
              })
            ] })
          }
        ) : null
      ] })
    ] }) : null,
    /* @__PURE__ */ h("div", { className: S("akuna-data-table__scroll", u && "akuna-data-table__scroll--no-horizontal-scroll"), children: /* @__PURE__ */ T("div", { className: "akuna-data-table__grid", role: "table", style: { minWidth: Vi }, children: [
      /* @__PURE__ */ T("div", { className: "akuna-data-table__head", role: "row", children: [
        Fr ? /* @__PURE__ */ h(
          "div",
          {
            className: "akuna-data-table__th akuna-data-table__expand-cell",
            role: "columnheader",
            style: { flex: `0 0 ${yn}px`, width: yn }
          }
        ) : null,
        ft.map((C) => /* @__PURE__ */ T(
          "div",
          {
            className: "akuna-data-table__th",
            "data-align": C.align ?? "left",
            "data-dragover": ee === C.id && q !== C.id ? "true" : void 0,
            "data-dragging": q === C.id ? "true" : void 0,
            draggable: !z.current,
            onDragEnd: () => {
              Y(null), U(null);
            },
            onDragOver: (O) => {
              O.preventDefault(), ee !== C.id && U(C.id);
            },
            onDragStart: () => Y(C.id),
            onDrop: (O) => {
              O.preventDefault(), ac(q, C.id);
            },
            role: "columnheader",
            style: { flex: Ii(C), width: pt(C) },
            children: [
              /* @__PURE__ */ h(ad, { "aria-hidden": "true", className: "akuna-data-table__grip", size: 12 }),
              C.sortAccessor ? (
                // Intentionally not a <button>: a nested native button swallows the
                // mousedown that starts the header's native HTML5 drag, which breaks
                // column reordering for every sortable column.
                /* @__PURE__ */ T(
                  "span",
                  {
                    className: "akuna-data-table__sort-btn",
                    onClick: () => Bi(C),
                    onKeyDown: (O) => {
                      (O.key === "Enter" || O.key === " ") && (O.preventDefault(), Bi(C));
                    },
                    role: "button",
                    tabIndex: 0,
                    children: [
                      /* @__PURE__ */ h("span", { className: "akuna-data-table__th-label", children: C.header }),
                      cc(C)
                    ]
                  }
                )
              ) : /* @__PURE__ */ h("span", { className: "akuna-data-table__th-label", children: C.header }),
              /* @__PURE__ */ h(
                "span",
                {
                  "aria-hidden": "true",
                  className: "akuna-data-table__resize",
                  onMouseDown: (O) => oc(C, O)
                }
              )
            ]
          },
          C.id
        ))
      ] }),
      Un.length === 0 ? /* @__PURE__ */ h("div", { className: "akuna-data-table__empty", children: n.empty ?? R.empty }) : Un.map((C) => {
        const O = l(C), re = nc(C), _e = re && D.includes(O);
        return /* @__PURE__ */ T(gr, { children: [
          /* @__PURE__ */ T(
            "div",
            {
              className: "akuna-data-table__row",
              "data-clickable": f ? "true" : void 0,
              onClick: f ? () => f(C) : void 0,
              role: "row",
              children: [
                Fr ? /* @__PURE__ */ h(
                  "div",
                  {
                    className: "akuna-data-table__td akuna-data-table__expand-cell",
                    role: "cell",
                    style: { flex: `0 0 ${yn}px`, width: yn },
                    children: re ? /* @__PURE__ */ h(
                      "button",
                      {
                        "aria-expanded": _e,
                        "aria-label": o,
                        className: "akuna-data-table__expand-trigger",
                        "data-expanded": _e ? "true" : void 0,
                        onClick: (Ae) => {
                          Ae.stopPropagation(), rc(O);
                        },
                        type: "button",
                        children: /* @__PURE__ */ h(sr, { "aria-hidden": "true", size: 16 })
                      }
                    ) : null
                  }
                ) : null,
                ft.map((Ae) => /* @__PURE__ */ h(
                  "div",
                  {
                    className: "akuna-data-table__td",
                    "data-align": Ae.align ?? "left",
                    role: "cell",
                    style: { flex: Ii(Ae), minWidth: Ae.minWidth ?? pt(Ae) },
                    children: Ae.cell(C)
                  },
                  Ae.id
                ))
              ]
            }
          ),
          _e ? /* @__PURE__ */ h("div", { className: "akuna-data-table__expanded", role: "row", children: /* @__PURE__ */ h("div", { role: "cell", style: { width: Vi }, children: w == null ? void 0 : w(C) }) }) : null
        ] }, O);
      })
    ] }) }),
    b ? /* @__PURE__ */ T("div", { className: "akuna-data-table__footer", children: [
      /* @__PURE__ */ T("span", { className: "akuna-data-table__summary", children: [
        Un.length === 0 ? 0 : (mn - 1) * b + 1,
        "–",
        (mn - 1) * b + Un.length,
        " / ",
        Li
      ] }),
      /* @__PURE__ */ h(gd, { labels: k, onPageChange: uc, page: mn, totalPages: ji })
    ] }) : null
  ] });
}
function nn({ className: n, icon: e, size: t = 20, ...r }) {
  return /* @__PURE__ */ h(e, { "aria-hidden": "true", className: S("akuna-icon", n), focusable: "false", size: t, strokeWidth: 2, ...r });
}
function bk({ children: n, className: e, style: t, tone: r = "neutral" }) {
  return /* @__PURE__ */ h("span", { className: S("akuna-table-pill", e), "data-tone": r, style: t, children: n });
}
function kk({ className: n, label: e, style: t, tone: r = "neutral" }) {
  return /* @__PURE__ */ T("span", { className: S("akuna-table-status", n), "data-tone": r, style: t, children: [
    /* @__PURE__ */ h("span", { "aria-hidden": "true", className: "akuna-table-status__dot" }),
    e
  ] });
}
function wk({ children: n, className: e, icon: t, style: r, tone: s = "neutral" }) {
  return /* @__PURE__ */ T("span", { className: S("akuna-table-chip", e), "data-tone": s, style: r, children: [
    t ? /* @__PURE__ */ h(nn, { icon: t, size: 16 }) : null,
    n
  ] });
}
function _k({ children: n, className: e }) {
  return /* @__PURE__ */ h("span", { className: S("akuna-table-tag", e), children: n });
}
function kd(n) {
  return n.replace(/\b(Dra?\.?|Dr\.?)\s*/gi, "").trim().split(/\s+/).map((e) => e[0] ?? "").join("").slice(0, 2).toUpperCase();
}
function xk({ className: n, name: e, tone: t = "neutral" }) {
  return /* @__PURE__ */ h("span", { "aria-hidden": "true", className: S("akuna-table-avatar", n), "data-tone": t, children: kd(e) });
}
const Rs = ze({});
function br(n) {
  const e = Ie(null);
  return e.current === null && (e.current = n()), e.current;
}
const kr = ze(null), En = ze({
  transformPagePoint: (n) => n,
  isStatic: !1,
  reducedMotion: "never"
});
class wd extends Os.Component {
  getSnapshotBeforeUpdate(e) {
    const t = this.props.childRef.current;
    if (t && e.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = t.offsetHeight || 0, r.width = t.offsetWidth || 0, r.top = t.offsetTop, r.left = t.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function _d({ children: n, isPresent: e }) {
  const t = Tt(), r = Ie(null), s = Ie({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: i } = ce(En);
  return Oo(() => {
    const { width: a, height: o, top: l, left: u } = s.current;
    if (e || !r.current || !a || !o)
      return;
    r.current.dataset.motionPopId = t;
    const c = document.createElement("style");
    return i && (c.nonce = i), document.head.appendChild(c), c.sheet && c.sheet.insertRule(`
          [data-motion-pop-id="${t}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${o}px !important;
            top: ${l}px !important;
            left: ${u}px !important;
          }
        `), () => {
      document.head.removeChild(c);
    };
  }, [e]), h(wd, { isPresent: e, childRef: r, sizeRef: s, children: Os.cloneElement(n, { ref: r }) });
}
const xd = ({ children: n, initial: e, isPresent: t, onExitComplete: r, custom: s, presenceAffectsLayout: i, mode: a }) => {
  const o = br(Td), l = Tt(), u = Pt((d) => {
    o.set(d, !0);
    for (const f of o.values())
      if (!f)
        return;
    r && r();
  }, [o, r]), c = He(
    () => ({
      id: l,
      initial: e,
      isPresent: t,
      custom: s,
      onExitComplete: u,
      register: (d) => (o.set(d, !1), () => o.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? [Math.random(), u] : [t, u]
  );
  return He(() => {
    o.forEach((d, f) => o.set(f, !1));
  }, [t]), Os.useEffect(() => {
    !t && !o.size && r && r();
  }, [t]), a === "popLayout" && (n = h(_d, { isPresent: t, children: n })), h(kr.Provider, { value: c, children: n });
};
function Td() {
  return /* @__PURE__ */ new Map();
}
function Ho(n = !0) {
  const e = ce(kr);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: r, register: s } = e, i = Tt();
  ve(() => {
    n && s(i);
  }, [n]);
  const a = Pt(() => n && r && r(i), [i, r, n]);
  return !t && r ? [!1, a] : [!0];
}
const qn = (n) => n.key || "";
function qi(n) {
  const e = [];
  return fc.forEach(n, (t) => {
    In(t) && e.push(t);
  }), e;
}
const Is = typeof window < "u", qo = Is ? rr : ve, Cd = ({ children: n, custom: e, initial: t = !0, onExitComplete: r, presenceAffectsLayout: s = !0, mode: i = "sync", propagate: a = !1 }) => {
  const [o, l] = Ho(a), u = He(() => qi(n), [n]), c = a && !o ? [] : u.map(qn), d = Ie(!0), f = Ie(u), p = br(() => /* @__PURE__ */ new Map()), [g, y] = Z(u), [b, k] = Z(u);
  qo(() => {
    d.current = !1, f.current = u;
    for (let _ = 0; _ < b.length; _++) {
      const v = qn(b[_]);
      c.includes(v) ? p.delete(v) : p.get(v) !== !0 && p.set(v, !1);
    }
  }, [b, c.length, c.join("-")]);
  const w = [];
  if (u !== g) {
    let _ = [...u];
    for (let v = 0; v < b.length; v++) {
      const x = b[v], P = qn(x);
      c.includes(P) || (_.splice(v, 0, x), w.push(x));
    }
    i === "wait" && w.length && (_ = w), k(qi(_)), y(u);
    return;
  }
  process.env.NODE_ENV !== "production" && i === "wait" && b.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: m } = ce(Rs);
  return h(je, { children: b.map((_) => {
    const v = qn(_), x = a && !o ? !1 : u === b || c.includes(v), P = () => {
      if (p.has(v))
        p.set(v, !0);
      else
        return;
      let R = !0;
      p.forEach((B) => {
        B || (R = !1);
      }), R && (m == null || m(), k(f.current), a && (l == null || l()), r && r());
    };
    return h(xd, { isPresent: x, initial: !d.current || t ? void 0 : !1, custom: x ? void 0 : e, presenceAffectsLayout: s, mode: i, onExitComplete: x ? void 0 : P, children: _ }, v);
  }) });
}, Ye = /* @__NO_SIDE_EFFECTS__ */ (n) => n;
let hn = Ye, Nt = Ye;
process.env.NODE_ENV !== "production" && (hn = (n, e) => {
  !n && typeof console < "u" && console.warn(e);
}, Nt = (n, e) => {
  if (!n)
    throw new Error(e);
});
// @__NO_SIDE_EFFECTS__
function Vs(n) {
  let e;
  return () => (e === void 0 && (e = n()), e);
}
const rn = /* @__NO_SIDE_EFFECTS__ */ (n, e, t) => {
  const r = e - n;
  return r === 0 ? 1 : (t - n) / r;
}, ut = /* @__NO_SIDE_EFFECTS__ */ (n) => n * 1e3, bt = /* @__NO_SIDE_EFFECTS__ */ (n) => n / 1e3, Md = {
  useManualTiming: !1
};
function Dd(n) {
  let e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set(), r = !1, s = !1;
  const i = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function o(u) {
    i.has(u) && (l.schedule(u), n()), u(a);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, c = !1, d = !1) => {
      const p = d && r ? e : t;
      return c && i.add(u), p.has(u) || p.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      t.delete(u), i.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (a = u, r) {
        s = !0;
        return;
      }
      r = !0, [e, t] = [t, e], e.forEach(o), e.clear(), r = !1, s && (s = !1, l.process(u));
    }
  };
  return l;
}
const Gn = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Ed = 40;
function Go(n, e) {
  let t = !1, r = !0;
  const s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => t = !0, a = Gn.reduce((k, w) => (k[w] = Dd(i), k), {}), { read: o, resolveKeyframes: l, update: u, preRender: c, render: d, postRender: f } = a, p = () => {
    const k = performance.now();
    t = !1, s.delta = r ? 1e3 / 60 : Math.max(Math.min(k - s.timestamp, Ed), 1), s.timestamp = k, s.isProcessing = !0, o.process(s), l.process(s), u.process(s), c.process(s), d.process(s), f.process(s), s.isProcessing = !1, t && e && (r = !1, n(p));
  }, g = () => {
    t = !0, r = !0, s.isProcessing || n(p);
  };
  return { schedule: Gn.reduce((k, w) => {
    const m = a[w];
    return k[w] = (_, v = !1, x = !1) => (t || g(), m.schedule(_, v, x)), k;
  }, {}), cancel: (k) => {
    for (let w = 0; w < Gn.length; w++)
      a[Gn[w]].cancel(k);
  }, state: s, steps: a };
}
const { schedule: pe, cancel: Ot, state: Ne, steps: Vr } = Go(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Ye, !0), Ko = ze({ strict: !1 }), Gi = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, sn = {};
for (const n in Gi)
  sn[n] = {
    isEnabled: (e) => Gi[n].some((t) => !!e[t])
  };
function Ad(n) {
  for (const e in n)
    sn[e] = {
      ...sn[e],
      ...n[e]
    };
}
const Pd = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function ir(n) {
  return n.startsWith("while") || n.startsWith("drag") && n !== "draggable" || n.startsWith("layout") || n.startsWith("onTap") || n.startsWith("onPan") || n.startsWith("onLayout") || Pd.has(n);
}
let Xo = (n) => !ir(n);
function Qo(n) {
  n && (Xo = (e) => e.startsWith("on") ? !ir(e) : n(e));
}
try {
  Qo(require("@emotion/is-prop-valid").default);
} catch {
}
function Sd(n, e, t) {
  const r = {};
  for (const s in n)
    s === "values" && typeof n.values == "object" || (Xo(s) || t === !0 && ir(s) || !e && !ir(s) || // If trying to use native HTML drag events, forward drag listeners
    n.draggable && s.startsWith("onDrag")) && (r[s] = n[s]);
  return r;
}
function Nd({ children: n, isValidProp: e, ...t }) {
  e && Qo(e), t = { ...ce(En), ...t }, t.isStatic = br(() => t.isStatic);
  const r = He(() => t, [
    JSON.stringify(t.transition),
    t.transformPagePoint,
    t.reducedMotion
  ]);
  return h(En.Provider, { value: r, children: n });
}
const Ki = /* @__PURE__ */ new Set();
function wr(n, e, t) {
  n || Ki.has(e) || (console.warn(e), Ki.add(e));
}
function Od(n) {
  if (typeof Proxy > "u")
    return n;
  const e = /* @__PURE__ */ new Map(), t = (...r) => (process.env.NODE_ENV !== "production" && wr(!1, "motion() is deprecated. Use motion.create() instead."), n(...r));
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, s) => s === "create" ? n : (e.has(s) || e.set(s, n(s)), e.get(s))
  });
}
const _r = ze({});
function An(n) {
  return typeof n == "string" || Array.isArray(n);
}
function xr(n) {
  return n !== null && typeof n == "object" && typeof n.start == "function";
}
const Bs = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Ls = ["initial", ...Bs];
function Tr(n) {
  return xr(n.animate) || Ls.some((e) => An(n[e]));
}
function Zo(n) {
  return !!(Tr(n) || n.variants);
}
function Fd(n, e) {
  if (Tr(n)) {
    const { initial: t, animate: r } = n;
    return {
      initial: t === !1 || An(t) ? t : void 0,
      animate: An(r) ? r : void 0
    };
  }
  return n.inherit !== !1 ? e : {};
}
function Rd(n) {
  const { initial: e, animate: t } = Fd(n, ce(_r));
  return He(() => ({ initial: e, animate: t }), [Xi(e), Xi(t)]);
}
function Xi(n) {
  return Array.isArray(n) ? n.join(" ") : n;
}
const Id = Symbol.for("motionComponentSymbol");
function Gt(n) {
  return n && typeof n == "object" && Object.prototype.hasOwnProperty.call(n, "current");
}
function Vd(n, e, t) {
  return Pt(
    (r) => {
      r && n.onMount && n.onMount(r), e && (r ? e.mount(r) : e.unmount()), t && (typeof t == "function" ? t(r) : Gt(t) && (t.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const js = (n) => n.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Bd = "framerAppearId", Jo = "data-" + js(Bd), { schedule: Ws } = Go(queueMicrotask, !1), el = ze({});
function Ld(n, e, t, r, s) {
  var i, a;
  const { visualElement: o } = ce(_r), l = ce(Ko), u = ce(kr), c = ce(En).reducedMotion, d = Ie(null);
  r = r || l.renderer, !d.current && r && (d.current = r(n, {
    visualState: e,
    parent: o,
    props: t,
    presenceContext: u,
    blockInitialAnimation: u ? u.initial === !1 : !1,
    reducedMotionConfig: c
  }));
  const f = d.current, p = ce(el);
  f && !f.projection && s && (f.type === "html" || f.type === "svg") && jd(d.current, t, s, p);
  const g = Ie(!1);
  Oo(() => {
    f && g.current && f.update(t, u);
  });
  const y = t[Jo], b = Ie(!!y && !(!((i = window.MotionHandoffIsComplete) === null || i === void 0) && i.call(window, y)) && ((a = window.MotionHasOptimisedAnimation) === null || a === void 0 ? void 0 : a.call(window, y)));
  return qo(() => {
    f && (g.current = !0, window.MotionIsMounted = !0, f.updateFeatures(), Ws.render(f.render), b.current && f.animationState && f.animationState.animateChanges());
  }), ve(() => {
    f && (!b.current && f.animationState && f.animationState.animateChanges(), b.current && (queueMicrotask(() => {
      var k;
      (k = window.MotionHandoffMarkAsComplete) === null || k === void 0 || k.call(window, y);
    }), b.current = !1));
  }), f;
}
function jd(n, e, t, r) {
  const { layoutId: s, layout: i, drag: a, dragConstraints: o, layoutScroll: l, layoutRoot: u } = e;
  n.projection = new t(n.latestValues, e["data-framer-portal-id"] ? void 0 : tl(n.parent)), n.projection.setOptions({
    layoutId: s,
    layout: i,
    alwaysMeasureLayout: !!a || o && Gt(o),
    visualElement: n,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: u
  });
}
function tl(n) {
  if (n)
    return n.options.allowProjection !== !1 ? n.projection : tl(n.parent);
}
function Wd({ preloadedFeatures: n, createVisualElement: e, useRender: t, useVisualState: r, Component: s }) {
  var i, a;
  n && Ad(n);
  function o(u, c) {
    let d;
    const f = {
      ...ce(En),
      ...u,
      layoutId: Yd(u)
    }, { isStatic: p } = f, g = Rd(u), y = r(u, p);
    if (!p && Is) {
      $d(f, n);
      const b = zd(f);
      d = b.MeasureLayout, g.visualElement = Ld(s, y, f, e, b.ProjectionNode);
    }
    return T(_r.Provider, { value: g, children: [d && g.visualElement ? h(d, { visualElement: g.visualElement, ...f }) : null, t(s, u, Vd(y, g.visualElement, c), y, p, g.visualElement)] });
  }
  o.displayName = `motion.${typeof s == "string" ? s : `create(${(a = (i = s.displayName) !== null && i !== void 0 ? i : s.name) !== null && a !== void 0 ? a : ""})`}`;
  const l = le(o);
  return l[Id] = s, l;
}
function Yd({ layoutId: n }) {
  const e = ce(Rs).id;
  return e && n !== void 0 ? e + "-" + n : n;
}
function $d(n, e) {
  const t = ce(Ko).strict;
  if (process.env.NODE_ENV !== "production" && e && t) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    n.ignoreStrict ? hn(!1, r) : Nt(!1, r);
  }
}
function zd(n) {
  const { drag: e, layout: t } = sn;
  if (!e && !t)
    return {};
  const r = { ...e, ...t };
  return {
    MeasureLayout: e != null && e.isEnabled(n) || t != null && t.isEnabled(n) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const Ud = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ys(n) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof n != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    n.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Ud.indexOf(n) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(n))
    )
  );
}
function Qi(n) {
  const e = [{}, {}];
  return n == null || n.values.forEach((t, r) => {
    e[0][r] = t.get(), e[1][r] = t.getVelocity();
  }), e;
}
function $s(n, e, t, r) {
  if (typeof e == "function") {
    const [s, i] = Qi(r);
    e = e(t !== void 0 ? t : n.custom, s, i);
  }
  if (typeof e == "string" && (e = n.variants && n.variants[e]), typeof e == "function") {
    const [s, i] = Qi(r);
    e = e(t !== void 0 ? t : n.custom, s, i);
  }
  return e;
}
const cs = (n) => Array.isArray(n), Hd = (n) => !!(n && typeof n == "object" && n.mix && n.toValue), qd = (n) => cs(n) ? n[n.length - 1] || 0 : n, Re = (n) => !!(n && n.getVelocity);
function Zn(n) {
  const e = Re(n) ? n.get() : n;
  return Hd(e) ? e.toValue() : e;
}
function Gd({ scrapeMotionValuesFromProps: n, createRenderState: e, onUpdate: t }, r, s, i) {
  const a = {
    latestValues: Kd(r, s, i, n),
    renderState: e()
  };
  return t && (a.onMount = (o) => t({ props: r, current: o, ...a }), a.onUpdate = (o) => t(o)), a;
}
const nl = (n) => (e, t) => {
  const r = ce(_r), s = ce(kr), i = () => Gd(n, e, r, s);
  return t ? i() : br(i);
};
function Kd(n, e, t, r) {
  const s = {}, i = r(n, {});
  for (const f in i)
    s[f] = Zn(i[f]);
  let { initial: a, animate: o } = n;
  const l = Tr(n), u = Zo(n);
  e && u && !l && n.inherit !== !1 && (a === void 0 && (a = e.initial), o === void 0 && (o = e.animate));
  let c = t ? t.initial === !1 : !1;
  c = c || a === !1;
  const d = c ? o : a;
  if (d && typeof d != "boolean" && !xr(d)) {
    const f = Array.isArray(d) ? d : [d];
    for (let p = 0; p < f.length; p++) {
      const g = $s(n, f[p]);
      if (g) {
        const { transitionEnd: y, transition: b, ...k } = g;
        for (const w in k) {
          let m = k[w];
          if (Array.isArray(m)) {
            const _ = c ? m.length - 1 : 0;
            m = m[_];
          }
          m !== null && (s[w] = m);
        }
        for (const w in y)
          s[w] = y[w];
      }
    }
  }
  return s;
}
const fn = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], zt = new Set(fn), rl = (n) => (e) => typeof e == "string" && e.startsWith(n), sl = /* @__PURE__ */ rl("--"), Xd = /* @__PURE__ */ rl("var(--"), zs = (n) => Xd(n) ? Qd.test(n.split("/*")[0].trim()) : !1, Qd = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, il = (n, e) => e && typeof n == "number" ? e.transform(n) : n, kt = (n, e, t) => t > e ? e : t < n ? n : t, pn = {
  test: (n) => typeof n == "number",
  parse: parseFloat,
  transform: (n) => n
}, Pn = {
  ...pn,
  transform: (n) => kt(0, 1, n)
}, Kn = {
  ...pn,
  default: 1
}, Vn = (n) => ({
  test: (e) => typeof e == "string" && e.endsWith(n) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${n}`
}), Et = /* @__PURE__ */ Vn("deg"), ct = /* @__PURE__ */ Vn("%"), L = /* @__PURE__ */ Vn("px"), Zd = /* @__PURE__ */ Vn("vh"), Jd = /* @__PURE__ */ Vn("vw"), Zi = {
  ...ct,
  parse: (n) => ct.parse(n) / 100,
  transform: (n) => ct.transform(n * 100)
}, eh = {
  // Border props
  borderWidth: L,
  borderTopWidth: L,
  borderRightWidth: L,
  borderBottomWidth: L,
  borderLeftWidth: L,
  borderRadius: L,
  radius: L,
  borderTopLeftRadius: L,
  borderTopRightRadius: L,
  borderBottomRightRadius: L,
  borderBottomLeftRadius: L,
  // Positioning props
  width: L,
  maxWidth: L,
  height: L,
  maxHeight: L,
  top: L,
  right: L,
  bottom: L,
  left: L,
  // Spacing props
  padding: L,
  paddingTop: L,
  paddingRight: L,
  paddingBottom: L,
  paddingLeft: L,
  margin: L,
  marginTop: L,
  marginRight: L,
  marginBottom: L,
  marginLeft: L,
  // Misc
  backgroundPositionX: L,
  backgroundPositionY: L
}, th = {
  rotate: Et,
  rotateX: Et,
  rotateY: Et,
  rotateZ: Et,
  scale: Kn,
  scaleX: Kn,
  scaleY: Kn,
  scaleZ: Kn,
  skew: Et,
  skewX: Et,
  skewY: Et,
  distance: L,
  translateX: L,
  translateY: L,
  translateZ: L,
  x: L,
  y: L,
  z: L,
  perspective: L,
  transformPerspective: L,
  opacity: Pn,
  originX: Zi,
  originY: Zi,
  originZ: L
}, Ji = {
  ...pn,
  transform: Math.round
}, Us = {
  ...eh,
  ...th,
  zIndex: Ji,
  size: L,
  // SVG
  fillOpacity: Pn,
  strokeOpacity: Pn,
  numOctaves: Ji
}, nh = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, rh = fn.length;
function sh(n, e, t) {
  let r = "", s = !0;
  for (let i = 0; i < rh; i++) {
    const a = fn[i], o = n[a];
    if (o === void 0)
      continue;
    let l = !0;
    if (typeof o == "number" ? l = o === (a.startsWith("scale") ? 1 : 0) : l = parseFloat(o) === 0, !l || t) {
      const u = il(o, Us[a]);
      if (!l) {
        s = !1;
        const c = nh[a] || a;
        r += `${c}(${u}) `;
      }
      t && (e[a] = u);
    }
  }
  return r = r.trim(), t ? r = t(e, s ? "" : r) : s && (r = "none"), r;
}
function Hs(n, e, t) {
  const { style: r, vars: s, transformOrigin: i } = n;
  let a = !1, o = !1;
  for (const l in e) {
    const u = e[l];
    if (zt.has(l)) {
      a = !0;
      continue;
    } else if (sl(l)) {
      s[l] = u;
      continue;
    } else {
      const c = il(u, Us[l]);
      l.startsWith("origin") ? (o = !0, i[l] = c) : r[l] = c;
    }
  }
  if (e.transform || (a || t ? r.transform = sh(e, n.transform, t) : r.transform && (r.transform = "none")), o) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = i;
    r.transformOrigin = `${l} ${u} ${c}`;
  }
}
const ih = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, ah = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function oh(n, e, t = 1, r = 0, s = !0) {
  n.pathLength = 1;
  const i = s ? ih : ah;
  n[i.offset] = L.transform(-r);
  const a = L.transform(e), o = L.transform(t);
  n[i.array] = `${a} ${o}`;
}
function ea(n, e, t) {
  return typeof n == "string" ? n : L.transform(e + t * n);
}
function lh(n, e, t) {
  const r = ea(e, n.x, n.width), s = ea(t, n.y, n.height);
  return `${r} ${s}`;
}
function qs(n, {
  attrX: e,
  attrY: t,
  attrScale: r,
  originX: s,
  originY: i,
  pathLength: a,
  pathSpacing: o = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...u
}, c, d) {
  if (Hs(n, u, d), c) {
    n.style.viewBox && (n.attrs.viewBox = n.style.viewBox);
    return;
  }
  n.attrs = n.style, n.style = {};
  const { attrs: f, style: p, dimensions: g } = n;
  f.transform && (g && (p.transform = f.transform), delete f.transform), g && (s !== void 0 || i !== void 0 || p.transform) && (p.transformOrigin = lh(g, s !== void 0 ? s : 0.5, i !== void 0 ? i : 0.5)), e !== void 0 && (f.x = e), t !== void 0 && (f.y = t), r !== void 0 && (f.scale = r), a !== void 0 && oh(f, a, o, l, !1);
}
const Gs = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), al = () => ({
  ...Gs(),
  attrs: {}
}), Ks = (n) => typeof n == "string" && n.toLowerCase() === "svg";
function ol(n, { style: e, vars: t }, r, s) {
  Object.assign(n.style, e, s && s.getProjectionStyles(r));
  for (const i in t)
    n.style.setProperty(i, t[i]);
}
const ll = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function ul(n, e, t, r) {
  ol(n, e, void 0, r);
  for (const s in e.attrs)
    n.setAttribute(ll.has(s) ? s : js(s), e.attrs[s]);
}
const ar = {};
function uh(n) {
  Object.assign(ar, n);
}
function cl(n, { layout: e, layoutId: t }) {
  return zt.has(n) || n.startsWith("origin") || (e || t !== void 0) && (!!ar[n] || n === "opacity");
}
function Xs(n, e, t) {
  var r;
  const { style: s } = n, i = {};
  for (const a in s)
    (Re(s[a]) || e.style && Re(e.style[a]) || cl(a, n) || ((r = t == null ? void 0 : t.getValue(a)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (i[a] = s[a]);
  return i;
}
function dl(n, e, t) {
  const r = Xs(n, e, t);
  for (const s in n)
    if (Re(n[s]) || Re(e[s])) {
      const i = fn.indexOf(s) !== -1 ? "attr" + s.charAt(0).toUpperCase() + s.substring(1) : s;
      r[i] = n[s];
    }
  return r;
}
function ch(n, e) {
  try {
    e.dimensions = typeof n.getBBox == "function" ? n.getBBox() : n.getBoundingClientRect();
  } catch {
    e.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
const ta = ["x", "y", "width", "height", "cx", "cy", "r"], dh = {
  useVisualState: nl({
    scrapeMotionValuesFromProps: dl,
    createRenderState: al,
    onUpdate: ({ props: n, prevProps: e, current: t, renderState: r, latestValues: s }) => {
      if (!t)
        return;
      let i = !!n.drag;
      if (!i) {
        for (const o in s)
          if (zt.has(o)) {
            i = !0;
            break;
          }
      }
      if (!i)
        return;
      let a = !e;
      if (e)
        for (let o = 0; o < ta.length; o++) {
          const l = ta[o];
          n[l] !== e[l] && (a = !0);
        }
      a && pe.read(() => {
        ch(t, r), pe.render(() => {
          qs(r, s, Ks(t.tagName), n.transformTemplate), ul(t, r);
        });
      });
    }
  })
}, hh = {
  useVisualState: nl({
    scrapeMotionValuesFromProps: Xs,
    createRenderState: Gs
  })
};
function hl(n, e, t) {
  for (const r in e)
    !Re(e[r]) && !cl(r, t) && (n[r] = e[r]);
}
function fh({ transformTemplate: n }, e) {
  return He(() => {
    const t = Gs();
    return Hs(t, e, n), Object.assign({}, t.vars, t.style);
  }, [e]);
}
function ph(n, e) {
  const t = n.style || {}, r = {};
  return hl(r, t, n), Object.assign(r, fh(n, e)), r;
}
function mh(n, e) {
  const t = {}, r = ph(n, e);
  return n.drag && n.dragListener !== !1 && (t.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = n.drag === !0 ? "none" : `pan-${n.drag === "x" ? "y" : "x"}`), n.tabIndex === void 0 && (n.onTap || n.onTapStart || n.whileTap) && (t.tabIndex = 0), t.style = r, t;
}
function gh(n, e, t, r) {
  const s = He(() => {
    const i = al();
    return qs(i, e, Ks(r), n.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [e]);
  if (n.style) {
    const i = {};
    hl(i, n.style, n), s.style = { ...i, ...s.style };
  }
  return s;
}
function vh(n = !1) {
  return (t, r, s, { latestValues: i }, a) => {
    const l = (Ys(t) ? gh : mh)(r, i, a, t), u = Sd(r, typeof t == "string", n), c = t !== gr ? { ...u, ...l, ref: s } : {}, { children: d } = r, f = He(() => Re(d) ? d.get() : d, [d]);
    return tn(t, {
      ...c,
      children: f
    });
  };
}
function yh(n, e) {
  return function(r, { forwardMotionProps: s } = { forwardMotionProps: !1 }) {
    const a = {
      ...Ys(r) ? dh : hh,
      preloadedFeatures: n,
      useRender: vh(s),
      createVisualElement: e,
      Component: r
    };
    return Wd(a);
  };
}
function fl(n, e) {
  if (!Array.isArray(e))
    return !1;
  const t = e.length;
  if (t !== n.length)
    return !1;
  for (let r = 0; r < t; r++)
    if (e[r] !== n[r])
      return !1;
  return !0;
}
function Cr(n, e, t) {
  const r = n.getProps();
  return $s(r, e, t !== void 0 ? t : r.custom, n);
}
const bh = /* @__PURE__ */ Vs(() => window.ScrollTimeline !== void 0);
class kh {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => "finished" in e ? e.finished : e));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, t) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][e] = t;
  }
  attachTimeline(e, t) {
    const r = this.animations.map((s) => {
      if (bh() && s.attachTimeline)
        return s.attachTimeline(e);
      if (typeof t == "function")
        return t(s);
    });
    return () => {
      r.forEach((s, i) => {
        s && s(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let t = 0; t < this.animations.length; t++)
      e = Math.max(e, this.animations[t].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((t) => t[e]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class wh extends kh {
  then(e, t) {
    return Promise.all(this.animations).then(e).catch(t);
  }
}
function Qs(n, e) {
  return n ? n[e] || n.default || n : void 0;
}
const ds = 2e4;
function pl(n) {
  let e = 0;
  const t = 50;
  let r = n.next(e);
  for (; !r.done && e < ds; )
    e += t, r = n.next(e);
  return e >= ds ? 1 / 0 : e;
}
function Zs(n) {
  return typeof n == "function";
}
function na(n, e) {
  n.timeline = e, n.onfinish = null;
}
const Js = (n) => Array.isArray(n) && typeof n[0] == "number", _h = {
  linearEasing: void 0
};
function xh(n, e) {
  const t = /* @__PURE__ */ Vs(n);
  return () => {
    var r;
    return (r = _h[e]) !== null && r !== void 0 ? r : t();
  };
}
const or = /* @__PURE__ */ xh(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), ml = (n, e, t = 10) => {
  let r = "";
  const s = Math.max(Math.round(e / t), 2);
  for (let i = 0; i < s; i++)
    r += n(/* @__PURE__ */ rn(0, s - 1, i)) + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
};
function gl(n) {
  return !!(typeof n == "function" && or() || !n || typeof n == "string" && (n in hs || or()) || Js(n) || Array.isArray(n) && n.every(gl));
}
const wn = ([n, e, t, r]) => `cubic-bezier(${n}, ${e}, ${t}, ${r})`, hs = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ wn([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ wn([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ wn([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ wn([0.33, 1.53, 0.69, 0.99])
};
function vl(n, e) {
  if (n)
    return typeof n == "function" && or() ? ml(n, e) : Js(n) ? wn(n) : Array.isArray(n) ? n.map((t) => vl(t, e) || hs.easeOut) : hs[n];
}
const Je = {
  x: !1,
  y: !1
};
function yl() {
  return Je.x || Je.y;
}
function Th(n, e, t) {
  var r;
  if (n instanceof Element)
    return [n];
  if (typeof n == "string") {
    let s = document;
    const i = (r = void 0) !== null && r !== void 0 ? r : s.querySelectorAll(n);
    return i ? Array.from(i) : [];
  }
  return Array.from(n);
}
function bl(n, e) {
  const t = Th(n), r = new AbortController(), s = {
    passive: !0,
    ...e,
    signal: r.signal
  };
  return [t, s, () => r.abort()];
}
function ra(n) {
  return (e) => {
    e.pointerType === "touch" || yl() || n(e);
  };
}
function Ch(n, e, t = {}) {
  const [r, s, i] = bl(n, t), a = ra((o) => {
    const { target: l } = o, u = e(o);
    if (typeof u != "function" || !l)
      return;
    const c = ra((d) => {
      u(d), l.removeEventListener("pointerleave", c);
    });
    l.addEventListener("pointerleave", c, s);
  });
  return r.forEach((o) => {
    o.addEventListener("pointerenter", a, s);
  }), i;
}
const kl = (n, e) => e ? n === e ? !0 : kl(n, e.parentElement) : !1, ei = (n) => n.pointerType === "mouse" ? typeof n.button != "number" || n.button <= 0 : n.isPrimary !== !1, Mh = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Dh(n) {
  return Mh.has(n.tagName) || n.tabIndex !== -1;
}
const _n = /* @__PURE__ */ new WeakSet();
function sa(n) {
  return (e) => {
    e.key === "Enter" && n(e);
  };
}
function Br(n, e) {
  n.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const Eh = (n, e) => {
  const t = n.currentTarget;
  if (!t)
    return;
  const r = sa(() => {
    if (_n.has(t))
      return;
    Br(t, "down");
    const s = sa(() => {
      Br(t, "up");
    }), i = () => Br(t, "cancel");
    t.addEventListener("keyup", s, e), t.addEventListener("blur", i, e);
  });
  t.addEventListener("keydown", r, e), t.addEventListener("blur", () => t.removeEventListener("keydown", r), e);
};
function ia(n) {
  return ei(n) && !yl();
}
function Ah(n, e, t = {}) {
  const [r, s, i] = bl(n, t), a = (o) => {
    const l = o.currentTarget;
    if (!ia(o) || _n.has(l))
      return;
    _n.add(l);
    const u = e(o), c = (p, g) => {
      window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", f), !(!ia(p) || !_n.has(l)) && (_n.delete(l), typeof u == "function" && u(p, { success: g }));
    }, d = (p) => {
      c(p, t.useGlobalTarget || kl(l, p.target));
    }, f = (p) => {
      c(p, !1);
    };
    window.addEventListener("pointerup", d, s), window.addEventListener("pointercancel", f, s);
  };
  return r.forEach((o) => {
    !Dh(o) && o.getAttribute("tabindex") === null && (o.tabIndex = 0), (t.useGlobalTarget ? window : o).addEventListener("pointerdown", a, s), o.addEventListener("focus", (u) => Eh(u, s), s);
  }), i;
}
function Ph(n) {
  return n === "x" || n === "y" ? Je[n] ? null : (Je[n] = !0, () => {
    Je[n] = !1;
  }) : Je.x || Je.y ? null : (Je.x = Je.y = !0, () => {
    Je.x = Je.y = !1;
  });
}
const wl = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...fn
]);
let Jn;
function Sh() {
  Jn = void 0;
}
const dt = {
  now: () => (Jn === void 0 && dt.set(Ne.isProcessing || Md.useManualTiming ? Ne.timestamp : performance.now()), Jn),
  set: (n) => {
    Jn = n, queueMicrotask(Sh);
  }
};
function ti(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function ni(n, e) {
  const t = n.indexOf(e);
  t > -1 && n.splice(t, 1);
}
class ri {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return ti(this.subscriptions, e), () => ni(this.subscriptions, e);
  }
  notify(e, t, r) {
    const s = this.subscriptions.length;
    if (s)
      if (s === 1)
        this.subscriptions[0](e, t, r);
      else
        for (let i = 0; i < s; i++) {
          const a = this.subscriptions[i];
          a && a(e, t, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function _l(n, e) {
  return e ? n * (1e3 / e) : 0;
}
const aa = 30, Nh = (n) => !isNaN(parseFloat(n));
class Oh {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, t = {}) {
    this.version = "11.18.2", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, s = !0) => {
      const i = dt.now();
      this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), s && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = t.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = dt.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Nh(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && wr(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, t) {
    this.events[e] || (this.events[e] = new ri());
    const r = this.events[e].add(t);
    return e === "change" ? () => {
      r(), pe.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, t) {
    this.passiveEffect = e, this.stopPassiveEffect = t;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, t = !0) {
    !t || !this.passiveEffect ? this.updateAndNotify(e, t) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, t, r) {
    this.set(t), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, t = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, t && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = dt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > aa)
      return 0;
    const t = Math.min(this.updatedAt - this.prevUpdatedAt, aa);
    return _l(parseFloat(this.current) - parseFloat(this.prevFrameValue), t);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((t) => {
      this.hasAnimated = !0, this.animation = e(t), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Sn(n, e) {
  return new Oh(n, e);
}
function Fh(n, e, t) {
  n.hasValue(e) ? n.getValue(e).set(t) : n.addValue(e, Sn(t));
}
function Rh(n, e) {
  const t = Cr(n, e);
  let { transitionEnd: r = {}, transition: s = {}, ...i } = t || {};
  i = { ...i, ...r };
  for (const a in i) {
    const o = qd(i[a]);
    Fh(n, a, o);
  }
}
function Ih(n) {
  return !!(Re(n) && n.add);
}
function fs(n, e) {
  const t = n.getValue("willChange");
  if (Ih(t))
    return t.add(e);
}
function xl(n) {
  return n.props[Jo];
}
const Tl = (n, e, t) => (((1 - 3 * t + 3 * e) * n + (3 * t - 6 * e)) * n + 3 * e) * n, Vh = 1e-7, Bh = 12;
function Lh(n, e, t, r, s) {
  let i, a, o = 0;
  do
    a = e + (t - e) / 2, i = Tl(a, r, s) - n, i > 0 ? t = a : e = a;
  while (Math.abs(i) > Vh && ++o < Bh);
  return a;
}
function Bn(n, e, t, r) {
  if (n === e && t === r)
    return Ye;
  const s = (i) => Lh(i, 0, 1, n, t);
  return (i) => i === 0 || i === 1 ? i : Tl(s(i), e, r);
}
const Cl = (n) => (e) => e <= 0.5 ? n(2 * e) / 2 : (2 - n(2 * (1 - e))) / 2, Ml = (n) => (e) => 1 - n(1 - e), Dl = /* @__PURE__ */ Bn(0.33, 1.53, 0.69, 0.99), si = /* @__PURE__ */ Ml(Dl), El = /* @__PURE__ */ Cl(si), Al = (n) => (n *= 2) < 1 ? 0.5 * si(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1))), ii = (n) => 1 - Math.sin(Math.acos(n)), Pl = Ml(ii), Sl = Cl(ii), Nl = (n) => /^0[^.\s]+$/u.test(n);
function jh(n) {
  return typeof n == "number" ? n === 0 : n !== null ? n === "none" || n === "0" || Nl(n) : !0;
}
const Tn = (n) => Math.round(n * 1e5) / 1e5, ai = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Wh(n) {
  return n == null;
}
const Yh = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, oi = (n, e) => (t) => !!(typeof t == "string" && Yh.test(t) && t.startsWith(n) || e && !Wh(t) && Object.prototype.hasOwnProperty.call(t, e)), Ol = (n, e, t) => (r) => {
  if (typeof r != "string")
    return r;
  const [s, i, a, o] = r.match(ai);
  return {
    [n]: parseFloat(s),
    [e]: parseFloat(i),
    [t]: parseFloat(a),
    alpha: o !== void 0 ? parseFloat(o) : 1
  };
}, $h = (n) => kt(0, 255, n), Lr = {
  ...pn,
  transform: (n) => Math.round($h(n))
}, Wt = {
  test: /* @__PURE__ */ oi("rgb", "red"),
  parse: /* @__PURE__ */ Ol("red", "green", "blue"),
  transform: ({ red: n, green: e, blue: t, alpha: r = 1 }) => "rgba(" + Lr.transform(n) + ", " + Lr.transform(e) + ", " + Lr.transform(t) + ", " + Tn(Pn.transform(r)) + ")"
};
function zh(n) {
  let e = "", t = "", r = "", s = "";
  return n.length > 5 ? (e = n.substring(1, 3), t = n.substring(3, 5), r = n.substring(5, 7), s = n.substring(7, 9)) : (e = n.substring(1, 2), t = n.substring(2, 3), r = n.substring(3, 4), s = n.substring(4, 5), e += e, t += t, r += r, s += s), {
    red: parseInt(e, 16),
    green: parseInt(t, 16),
    blue: parseInt(r, 16),
    alpha: s ? parseInt(s, 16) / 255 : 1
  };
}
const ps = {
  test: /* @__PURE__ */ oi("#"),
  parse: zh,
  transform: Wt.transform
}, Kt = {
  test: /* @__PURE__ */ oi("hsl", "hue"),
  parse: /* @__PURE__ */ Ol("hue", "saturation", "lightness"),
  transform: ({ hue: n, saturation: e, lightness: t, alpha: r = 1 }) => "hsla(" + Math.round(n) + ", " + ct.transform(Tn(e)) + ", " + ct.transform(Tn(t)) + ", " + Tn(Pn.transform(r)) + ")"
}, Fe = {
  test: (n) => Wt.test(n) || ps.test(n) || Kt.test(n),
  parse: (n) => Wt.test(n) ? Wt.parse(n) : Kt.test(n) ? Kt.parse(n) : ps.parse(n),
  transform: (n) => typeof n == "string" ? n : n.hasOwnProperty("red") ? Wt.transform(n) : Kt.transform(n)
}, Uh = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Hh(n) {
  var e, t;
  return isNaN(n) && typeof n == "string" && (((e = n.match(ai)) === null || e === void 0 ? void 0 : e.length) || 0) + (((t = n.match(Uh)) === null || t === void 0 ? void 0 : t.length) || 0) > 0;
}
const Fl = "number", Rl = "color", qh = "var", Gh = "var(", oa = "${}", Kh = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Nn(n) {
  const e = n.toString(), t = [], r = {
    color: [],
    number: [],
    var: []
  }, s = [];
  let i = 0;
  const o = e.replace(Kh, (l) => (Fe.test(l) ? (r.color.push(i), s.push(Rl), t.push(Fe.parse(l))) : l.startsWith(Gh) ? (r.var.push(i), s.push(qh), t.push(l)) : (r.number.push(i), s.push(Fl), t.push(parseFloat(l))), ++i, oa)).split(oa);
  return { values: t, split: o, indexes: r, types: s };
}
function Il(n) {
  return Nn(n).values;
}
function Vl(n) {
  const { split: e, types: t } = Nn(n), r = e.length;
  return (s) => {
    let i = "";
    for (let a = 0; a < r; a++)
      if (i += e[a], s[a] !== void 0) {
        const o = t[a];
        o === Fl ? i += Tn(s[a]) : o === Rl ? i += Fe.transform(s[a]) : i += s[a];
      }
    return i;
  };
}
const Xh = (n) => typeof n == "number" ? 0 : n;
function Qh(n) {
  const e = Il(n);
  return Vl(n)(e.map(Xh));
}
const Ft = {
  test: Hh,
  parse: Il,
  createTransformer: Vl,
  getAnimatableNone: Qh
}, Zh = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Jh(n) {
  const [e, t] = n.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return n;
  const [r] = t.match(ai) || [];
  if (!r)
    return n;
  const s = t.replace(r, "");
  let i = Zh.has(e) ? 1 : 0;
  return r !== t && (i *= 100), e + "(" + i + s + ")";
}
const ef = /\b([a-z-]*)\(.*?\)/gu, ms = {
  ...Ft,
  getAnimatableNone: (n) => {
    const e = n.match(ef);
    return e ? e.map(Jh).join(" ") : n;
  }
}, tf = {
  ...Us,
  // Color props
  color: Fe,
  backgroundColor: Fe,
  outlineColor: Fe,
  fill: Fe,
  stroke: Fe,
  // Border props
  borderColor: Fe,
  borderTopColor: Fe,
  borderRightColor: Fe,
  borderBottomColor: Fe,
  borderLeftColor: Fe,
  filter: ms,
  WebkitFilter: ms
}, li = (n) => tf[n];
function Bl(n, e) {
  let t = li(n);
  return t !== ms && (t = Ft), t.getAnimatableNone ? t.getAnimatableNone(e) : void 0;
}
const nf = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function rf(n, e, t) {
  let r = 0, s;
  for (; r < n.length && !s; ) {
    const i = n[r];
    typeof i == "string" && !nf.has(i) && Nn(i).values.length && (s = n[r]), r++;
  }
  if (s && t)
    for (const i of e)
      n[i] = Bl(t, s);
}
const la = (n) => n === pn || n === L, ua = (n, e) => parseFloat(n.split(", ")[e]), ca = (n, e) => (t, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const s = r.match(/^matrix3d\((.+)\)$/u);
  if (s)
    return ua(s[1], e);
  {
    const i = r.match(/^matrix\((.+)\)$/u);
    return i ? ua(i[1], n) : 0;
  }
}, sf = /* @__PURE__ */ new Set(["x", "y", "z"]), af = fn.filter((n) => !sf.has(n));
function of(n) {
  const e = [];
  return af.forEach((t) => {
    const r = n.getValue(t);
    r !== void 0 && (e.push([t, r.get()]), r.set(t.startsWith("scale") ? 1 : 0));
  }), e;
}
const an = {
  // Dimensions
  width: ({ x: n }, { paddingLeft: e = "0", paddingRight: t = "0" }) => n.max - n.min - parseFloat(e) - parseFloat(t),
  height: ({ y: n }, { paddingTop: e = "0", paddingBottom: t = "0" }) => n.max - n.min - parseFloat(e) - parseFloat(t),
  top: (n, { top: e }) => parseFloat(e),
  left: (n, { left: e }) => parseFloat(e),
  bottom: ({ y: n }, { top: e }) => parseFloat(e) + (n.max - n.min),
  right: ({ x: n }, { left: e }) => parseFloat(e) + (n.max - n.min),
  // Transform
  x: ca(4, 13),
  y: ca(5, 14)
};
an.translateX = an.x;
an.translateY = an.y;
const $t = /* @__PURE__ */ new Set();
let gs = !1, vs = !1;
function Ll() {
  if (vs) {
    const n = Array.from($t).filter((r) => r.needsMeasurement), e = new Set(n.map((r) => r.element)), t = /* @__PURE__ */ new Map();
    e.forEach((r) => {
      const s = of(r);
      s.length && (t.set(r, s), r.render());
    }), n.forEach((r) => r.measureInitialState()), e.forEach((r) => {
      r.render();
      const s = t.get(r);
      s && s.forEach(([i, a]) => {
        var o;
        (o = r.getValue(i)) === null || o === void 0 || o.set(a);
      });
    }), n.forEach((r) => r.measureEndState()), n.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  vs = !1, gs = !1, $t.forEach((n) => n.complete()), $t.clear();
}
function jl() {
  $t.forEach((n) => {
    n.readKeyframes(), n.needsMeasurement && (vs = !0);
  });
}
function lf() {
  jl(), Ll();
}
class ui {
  constructor(e, t, r, s, i, a = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = t, this.name = r, this.motionValue = s, this.element = i, this.isAsync = a;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? ($t.add(this), gs || (gs = !0, pe.read(jl), pe.resolveKeyframes(Ll))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: t, element: r, motionValue: s } = this;
    for (let i = 0; i < e.length; i++)
      if (e[i] === null)
        if (i === 0) {
          const a = s == null ? void 0 : s.get(), o = e[e.length - 1];
          if (a !== void 0)
            e[0] = a;
          else if (r && t) {
            const l = r.readValue(t, o);
            l != null && (e[0] = l);
          }
          e[0] === void 0 && (e[0] = o), s && a === void 0 && s.set(e[0]);
        } else
          e[i] = e[i - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), $t.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, $t.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Wl = (n) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(n), uf = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function cf(n) {
  const e = uf.exec(n);
  if (!e)
    return [,];
  const [, t, r, s] = e;
  return [`--${t ?? r}`, s];
}
const df = 4;
function Yl(n, e, t = 1) {
  Nt(t <= df, `Max CSS variable fallback depth detected in property "${n}". This may indicate a circular fallback dependency.`);
  const [r, s] = cf(n);
  if (!r)
    return;
  const i = window.getComputedStyle(e).getPropertyValue(r);
  if (i) {
    const a = i.trim();
    return Wl(a) ? parseFloat(a) : a;
  }
  return zs(s) ? Yl(s, e, t + 1) : s;
}
const $l = (n) => (e) => e.test(n), hf = {
  test: (n) => n === "auto",
  parse: (n) => n
}, zl = [pn, L, ct, Et, Jd, Zd, hf], da = (n) => zl.find($l(n));
class Ul extends ui {
  constructor(e, t, r, s, i) {
    super(e, t, r, s, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: t, name: r } = this;
    if (!t || !t.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let u = e[l];
      if (typeof u == "string" && (u = u.trim(), zs(u))) {
        const c = Yl(u, t.current);
        c !== void 0 && (e[l] = c), l === e.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !wl.has(r) || e.length !== 2)
      return;
    const [s, i] = e, a = da(s), o = da(i);
    if (a !== o)
      if (la(a) && la(o))
        for (let l = 0; l < e.length; l++) {
          const u = e[l];
          typeof u == "string" && (e[l] = parseFloat(u));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: t } = this, r = [];
    for (let s = 0; s < e.length; s++)
      jh(e[s]) && r.push(s);
    r.length && rf(e, r, t);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: t, name: r } = this;
    if (!e || !e.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = an[r](e.measureViewportBox(), window.getComputedStyle(e.current)), t[0] = this.measuredOrigin;
    const s = t[t.length - 1];
    s !== void 0 && e.getValue(r, s).jump(s, !1);
  }
  measureEndState() {
    var e;
    const { element: t, name: r, unresolvedKeyframes: s } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(r);
    i && i.jump(this.measuredOrigin, !1);
    const a = s.length - 1, o = s[a];
    s[a] = an[r](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([l, u]) => {
      t.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
const ha = (n, e) => e === "zIndex" ? !1 : !!(typeof n == "number" || Array.isArray(n) || typeof n == "string" && // It's animatable if we have a string
(Ft.test(n) || n === "0") && // And it contains numbers and/or colors
!n.startsWith("url("));
function ff(n) {
  const e = n[0];
  if (n.length === 1)
    return !0;
  for (let t = 0; t < n.length; t++)
    if (n[t] !== e)
      return !0;
}
function pf(n, e, t, r) {
  const s = n[0];
  if (s === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const i = n[n.length - 1], a = ha(s, e), o = ha(i, e);
  return hn(a === o, `You are trying to animate ${e} from "${s}" to "${i}". ${s} is not an animatable value - to enable this animation set ${s} to a value animatable to ${i} via the \`style\` property.`), !a || !o ? !1 : ff(n) || (t === "spring" || Zs(t)) && r;
}
const mf = (n) => n !== null;
function Mr(n, { repeat: e, repeatType: t = "loop" }, r) {
  const s = n.filter(mf), i = e && t !== "loop" && e % 2 === 1 ? 0 : s.length - 1;
  return !i || r === void 0 ? s[i] : r;
}
const gf = 40;
class Hl {
  constructor({ autoplay: e = !0, delay: t = 0, type: r = "keyframes", repeat: s = 0, repeatDelay: i = 0, repeatType: a = "loop", ...o }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = dt.now(), this.options = {
      autoplay: e,
      delay: t,
      type: r,
      repeat: s,
      repeatDelay: i,
      repeatType: a,
      ...o
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > gf ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && lf(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, t) {
    this.resolvedAt = dt.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: s, velocity: i, delay: a, onComplete: o, onUpdate: l, isGenerator: u } = this.options;
    if (!u && !pf(e, r, s, i))
      if (a)
        this.options.duration = 0;
      else {
        l && l(Mr(e, this.options, t)), o && o(), this.resolveFinishedPromise();
        return;
      }
    const c = this.initPlayback(e, t);
    c !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: t,
      ...c
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, t) {
    return this.currentFinishedPromise.then(e, t);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
const ye = (n, e, t) => n + (e - n) * t;
function jr(n, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? n + (e - n) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? n + (e - n) * (2 / 3 - t) * 6 : n;
}
function vf({ hue: n, saturation: e, lightness: t, alpha: r }) {
  n /= 360, e /= 100, t /= 100;
  let s = 0, i = 0, a = 0;
  if (!e)
    s = i = a = t;
  else {
    const o = t < 0.5 ? t * (1 + e) : t + e - t * e, l = 2 * t - o;
    s = jr(l, o, n + 1 / 3), i = jr(l, o, n), a = jr(l, o, n - 1 / 3);
  }
  return {
    red: Math.round(s * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
function lr(n, e) {
  return (t) => t > 0 ? e : n;
}
const Wr = (n, e, t) => {
  const r = n * n, s = t * (e * e - r) + r;
  return s < 0 ? 0 : Math.sqrt(s);
}, yf = [ps, Wt, Kt], bf = (n) => yf.find((e) => e.test(n));
function fa(n) {
  const e = bf(n);
  if (hn(!!e, `'${n}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let t = e.parse(n);
  return e === Kt && (t = vf(t)), t;
}
const pa = (n, e) => {
  const t = fa(n), r = fa(e);
  if (!t || !r)
    return lr(n, e);
  const s = { ...t };
  return (i) => (s.red = Wr(t.red, r.red, i), s.green = Wr(t.green, r.green, i), s.blue = Wr(t.blue, r.blue, i), s.alpha = ye(t.alpha, r.alpha, i), Wt.transform(s));
}, kf = (n, e) => (t) => e(n(t)), Ln = (...n) => n.reduce(kf), ys = /* @__PURE__ */ new Set(["none", "hidden"]);
function wf(n, e) {
  return ys.has(n) ? (t) => t <= 0 ? n : e : (t) => t >= 1 ? e : n;
}
function _f(n, e) {
  return (t) => ye(n, e, t);
}
function ci(n) {
  return typeof n == "number" ? _f : typeof n == "string" ? zs(n) ? lr : Fe.test(n) ? pa : Cf : Array.isArray(n) ? ql : typeof n == "object" ? Fe.test(n) ? pa : xf : lr;
}
function ql(n, e) {
  const t = [...n], r = t.length, s = n.map((i, a) => ci(i)(i, e[a]));
  return (i) => {
    for (let a = 0; a < r; a++)
      t[a] = s[a](i);
    return t;
  };
}
function xf(n, e) {
  const t = { ...n, ...e }, r = {};
  for (const s in t)
    n[s] !== void 0 && e[s] !== void 0 && (r[s] = ci(n[s])(n[s], e[s]));
  return (s) => {
    for (const i in r)
      t[i] = r[i](s);
    return t;
  };
}
function Tf(n, e) {
  var t;
  const r = [], s = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < e.values.length; i++) {
    const a = e.types[i], o = n.indexes[a][s[a]], l = (t = n.values[o]) !== null && t !== void 0 ? t : 0;
    r[i] = l, s[a]++;
  }
  return r;
}
const Cf = (n, e) => {
  const t = Ft.createTransformer(e), r = Nn(n), s = Nn(e);
  return r.indexes.var.length === s.indexes.var.length && r.indexes.color.length === s.indexes.color.length && r.indexes.number.length >= s.indexes.number.length ? ys.has(n) && !s.values.length || ys.has(e) && !r.values.length ? wf(n, e) : Ln(ql(Tf(r, s), s.values), t) : (hn(!0, `Complex values '${n}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), lr(n, e));
};
function Gl(n, e, t) {
  return typeof n == "number" && typeof e == "number" && typeof t == "number" ? ye(n, e, t) : ci(n)(n, e);
}
const Mf = 5;
function Kl(n, e, t) {
  const r = Math.max(e - Mf, 0);
  return _l(t - n(r), e - r);
}
const ge = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Yr = 1e-3;
function Df({ duration: n = ge.duration, bounce: e = ge.bounce, velocity: t = ge.velocity, mass: r = ge.mass }) {
  let s, i;
  hn(n <= /* @__PURE__ */ ut(ge.maxDuration), "Spring duration must be 10 seconds or less");
  let a = 1 - e;
  a = kt(ge.minDamping, ge.maxDamping, a), n = kt(ge.minDuration, ge.maxDuration, /* @__PURE__ */ bt(n)), a < 1 ? (s = (u) => {
    const c = u * a, d = c * n, f = c - t, p = bs(u, a), g = Math.exp(-d);
    return Yr - f / p * g;
  }, i = (u) => {
    const d = u * a * n, f = d * t + t, p = Math.pow(a, 2) * Math.pow(u, 2) * n, g = Math.exp(-d), y = bs(Math.pow(u, 2), a);
    return (-s(u) + Yr > 0 ? -1 : 1) * ((f - p) * g) / y;
  }) : (s = (u) => {
    const c = Math.exp(-u * n), d = (u - t) * n + 1;
    return -Yr + c * d;
  }, i = (u) => {
    const c = Math.exp(-u * n), d = (t - u) * (n * n);
    return c * d;
  });
  const o = 5 / n, l = Af(s, i, o);
  if (n = /* @__PURE__ */ ut(n), isNaN(l))
    return {
      stiffness: ge.stiffness,
      damping: ge.damping,
      duration: n
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: a * 2 * Math.sqrt(r * u),
      duration: n
    };
  }
}
const Ef = 12;
function Af(n, e, t) {
  let r = t;
  for (let s = 1; s < Ef; s++)
    r = r - n(r) / e(r);
  return r;
}
function bs(n, e) {
  return n * Math.sqrt(1 - e * e);
}
const Pf = ["duration", "bounce"], Sf = ["stiffness", "damping", "mass"];
function ma(n, e) {
  return e.some((t) => n[t] !== void 0);
}
function Nf(n) {
  let e = {
    velocity: ge.velocity,
    stiffness: ge.stiffness,
    damping: ge.damping,
    mass: ge.mass,
    isResolvedFromDuration: !1,
    ...n
  };
  if (!ma(n, Sf) && ma(n, Pf))
    if (n.visualDuration) {
      const t = n.visualDuration, r = 2 * Math.PI / (t * 1.2), s = r * r, i = 2 * kt(0.05, 1, 1 - (n.bounce || 0)) * Math.sqrt(s);
      e = {
        ...e,
        mass: ge.mass,
        stiffness: s,
        damping: i
      };
    } else {
      const t = Df(n);
      e = {
        ...e,
        ...t,
        mass: ge.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function Xl(n = ge.visualDuration, e = ge.bounce) {
  const t = typeof n != "object" ? {
    visualDuration: n,
    keyframes: [0, 1],
    bounce: e
  } : n;
  let { restSpeed: r, restDelta: s } = t;
  const i = t.keyframes[0], a = t.keyframes[t.keyframes.length - 1], o = { done: !1, value: i }, { stiffness: l, damping: u, mass: c, duration: d, velocity: f, isResolvedFromDuration: p } = Nf({
    ...t,
    velocity: -/* @__PURE__ */ bt(t.velocity || 0)
  }), g = f || 0, y = u / (2 * Math.sqrt(l * c)), b = a - i, k = /* @__PURE__ */ bt(Math.sqrt(l / c)), w = Math.abs(b) < 5;
  r || (r = w ? ge.restSpeed.granular : ge.restSpeed.default), s || (s = w ? ge.restDelta.granular : ge.restDelta.default);
  let m;
  if (y < 1) {
    const v = bs(k, y);
    m = (x) => {
      const P = Math.exp(-y * k * x);
      return a - P * ((g + y * k * b) / v * Math.sin(v * x) + b * Math.cos(v * x));
    };
  } else if (y === 1)
    m = (v) => a - Math.exp(-k * v) * (b + (g + k * b) * v);
  else {
    const v = k * Math.sqrt(y * y - 1);
    m = (x) => {
      const P = Math.exp(-y * k * x), R = Math.min(v * x, 300);
      return a - P * ((g + y * k * b) * Math.sinh(R) + v * b * Math.cosh(R)) / v;
    };
  }
  const _ = {
    calculatedDuration: p && d || null,
    next: (v) => {
      const x = m(v);
      if (p)
        o.done = v >= d;
      else {
        let P = 0;
        y < 1 && (P = v === 0 ? /* @__PURE__ */ ut(g) : Kl(m, v, x));
        const R = Math.abs(P) <= r, B = Math.abs(a - x) <= s;
        o.done = R && B;
      }
      return o.value = o.done ? a : x, o;
    },
    toString: () => {
      const v = Math.min(pl(_), ds), x = ml((P) => _.next(v * P).value, v, 30);
      return v + "ms " + x;
    }
  };
  return _;
}
function ga({ keyframes: n, velocity: e = 0, power: t = 0.8, timeConstant: r = 325, bounceDamping: s = 10, bounceStiffness: i = 500, modifyTarget: a, min: o, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const d = n[0], f = {
    done: !1,
    value: d
  }, p = (R) => o !== void 0 && R < o || l !== void 0 && R > l, g = (R) => o === void 0 ? l : l === void 0 || Math.abs(o - R) < Math.abs(l - R) ? o : l;
  let y = t * e;
  const b = d + y, k = a === void 0 ? b : a(b);
  k !== b && (y = k - d);
  const w = (R) => -y * Math.exp(-R / r), m = (R) => k + w(R), _ = (R) => {
    const B = w(R), ue = m(R);
    f.done = Math.abs(B) <= u, f.value = f.done ? k : ue;
  };
  let v, x;
  const P = (R) => {
    p(f.value) && (v = R, x = Xl({
      keyframes: [f.value, g(f.value)],
      velocity: Kl(m, R, f.value),
      // TODO: This should be passing * 1000
      damping: s,
      stiffness: i,
      restDelta: u,
      restSpeed: c
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (R) => {
      let B = !1;
      return !x && v === void 0 && (B = !0, _(R), P(R)), v !== void 0 && R >= v ? x.next(R - v) : (!B && _(R), f);
    }
  };
}
const Of = /* @__PURE__ */ Bn(0.42, 0, 1, 1), Ff = /* @__PURE__ */ Bn(0, 0, 0.58, 1), Ql = /* @__PURE__ */ Bn(0.42, 0, 0.58, 1), Rf = (n) => Array.isArray(n) && typeof n[0] != "number", va = {
  linear: Ye,
  easeIn: Of,
  easeInOut: Ql,
  easeOut: Ff,
  circIn: ii,
  circInOut: Sl,
  circOut: Pl,
  backIn: si,
  backInOut: El,
  backOut: Dl,
  anticipate: Al
}, ya = (n) => {
  if (Js(n)) {
    Nt(n.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, t, r, s] = n;
    return Bn(e, t, r, s);
  } else if (typeof n == "string")
    return Nt(va[n] !== void 0, `Invalid easing type '${n}'`), va[n];
  return n;
};
function If(n, e, t) {
  const r = [], s = t || Gl, i = n.length - 1;
  for (let a = 0; a < i; a++) {
    let o = s(n[a], n[a + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[a] || Ye : e;
      o = Ln(l, o);
    }
    r.push(o);
  }
  return r;
}
function Vf(n, e, { clamp: t = !0, ease: r, mixer: s } = {}) {
  const i = n.length;
  if (Nt(i === e.length, "Both input and output ranges must be the same length"), i === 1)
    return () => e[0];
  if (i === 2 && e[0] === e[1])
    return () => e[1];
  const a = n[0] === n[1];
  n[0] > n[i - 1] && (n = [...n].reverse(), e = [...e].reverse());
  const o = If(e, r, s), l = o.length, u = (c) => {
    if (a && c < n[0])
      return e[0];
    let d = 0;
    if (l > 1)
      for (; d < n.length - 2 && !(c < n[d + 1]); d++)
        ;
    const f = /* @__PURE__ */ rn(n[d], n[d + 1], c);
    return o[d](f);
  };
  return t ? (c) => u(kt(n[0], n[i - 1], c)) : u;
}
function Bf(n, e) {
  const t = n[n.length - 1];
  for (let r = 1; r <= e; r++) {
    const s = /* @__PURE__ */ rn(0, e, r);
    n.push(ye(t, 1, s));
  }
}
function Lf(n) {
  const e = [0];
  return Bf(e, n.length - 1), e;
}
function jf(n, e) {
  return n.map((t) => t * e);
}
function Wf(n, e) {
  return n.map(() => e || Ql).splice(0, n.length - 1);
}
function ur({ duration: n = 300, keyframes: e, times: t, ease: r = "easeInOut" }) {
  const s = Rf(r) ? r.map(ya) : ya(r), i = {
    done: !1,
    value: e[0]
  }, a = jf(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    t && t.length === e.length ? t : Lf(e),
    n
  ), o = Vf(a, e, {
    ease: Array.isArray(s) ? s : Wf(e, s)
  });
  return {
    calculatedDuration: n,
    next: (l) => (i.value = o(l), i.done = l >= n, i)
  };
}
const Yf = (n) => {
  const e = ({ timestamp: t }) => n(t);
  return {
    start: () => pe.update(e, !0),
    stop: () => Ot(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Ne.isProcessing ? Ne.timestamp : dt.now()
  };
}, $f = {
  decay: ga,
  inertia: ga,
  tween: ur,
  keyframes: ur,
  spring: Xl
}, zf = (n) => n / 100;
class di extends Hl {
  constructor(e) {
    super(e), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: t, motionValue: r, element: s, keyframes: i } = this.options, a = (s == null ? void 0 : s.KeyframeResolver) || ui, o = (l, u) => this.onKeyframesResolved(l, u);
    this.resolver = new a(i, o, t, r, s), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(e) {
    const { type: t = "keyframes", repeat: r = 0, repeatDelay: s = 0, repeatType: i, velocity: a = 0 } = this.options, o = Zs(t) ? t : $f[t] || ur;
    let l, u;
    o !== ur && typeof e[0] != "number" && (process.env.NODE_ENV !== "production" && Nt(e.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), l = Ln(zf, Gl(e[0], e[1])), e = [0, 100]);
    const c = o({ ...this.options, keyframes: e });
    i === "mirror" && (u = o({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -a
    })), c.calculatedDuration === null && (c.calculatedDuration = pl(c));
    const { calculatedDuration: d } = c, f = d + s, p = f * (r + 1) - s;
    return {
      generator: c,
      mirroredGenerator: u,
      mapPercentToKeyframes: l,
      calculatedDuration: d,
      resolvedDuration: f,
      totalDuration: p
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, t = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: R } = this.options;
      return { done: !0, value: R[R.length - 1] };
    }
    const { finalKeyframe: s, generator: i, mirroredGenerator: a, mapPercentToKeyframes: o, keyframes: l, calculatedDuration: u, totalDuration: c, resolvedDuration: d } = r;
    if (this.startTime === null)
      return i.next(0);
    const { delay: f, repeat: p, repeatType: g, repeatDelay: y, onUpdate: b } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - c / this.speed, this.startTime)), t ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const k = this.currentTime - f * (this.speed >= 0 ? 1 : -1), w = this.speed >= 0 ? k < 0 : k > c;
    this.currentTime = Math.max(k, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = c);
    let m = this.currentTime, _ = i;
    if (p) {
      const R = Math.min(this.currentTime, c) / d;
      let B = Math.floor(R), ue = R % 1;
      !ue && R >= 1 && (ue = 1), ue === 1 && B--, B = Math.min(B, p + 1), !!(B % 2) && (g === "reverse" ? (ue = 1 - ue, y && (ue -= y / d)) : g === "mirror" && (_ = a)), m = kt(0, 1, ue) * d;
    }
    const v = w ? { done: !1, value: l[0] } : _.next(m);
    o && (v.value = o(v.value));
    let { done: x } = v;
    !w && u !== null && (x = this.speed >= 0 ? this.currentTime >= c : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && x);
    return P && s !== void 0 && (v.value = Mr(l, this.options, s)), b && b(v.value), P && this.finish(), v;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? /* @__PURE__ */ bt(e.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ bt(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ ut(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const t = this.playbackSpeed !== e;
    this.playbackSpeed = e, t && (this.time = /* @__PURE__ */ bt(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = Yf, onPlay: t, startTime: r } = this.options;
    this.driver || (this.driver = e((i) => this.tick(i))), t && t();
    const s = this.driver.now();
    this.holdTime !== null ? this.startTime = s - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = s) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
const Uf = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function Hf(n, e, t, { delay: r = 0, duration: s = 300, repeat: i = 0, repeatType: a = "loop", ease: o = "easeInOut", times: l } = {}) {
  const u = { [e]: t };
  l && (u.offset = l);
  const c = vl(o, s);
  return Array.isArray(c) && (u.easing = c), n.animate(u, {
    delay: r,
    duration: s,
    easing: Array.isArray(c) ? "linear" : c,
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
const qf = /* @__PURE__ */ Vs(() => Object.hasOwnProperty.call(Element.prototype, "animate")), cr = 10, Gf = 2e4;
function Kf(n) {
  return Zs(n.type) || n.type === "spring" || !gl(n.ease);
}
function Xf(n, e) {
  const t = new di({
    ...e,
    keyframes: n,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: n[0] };
  const s = [];
  let i = 0;
  for (; !r.done && i < Gf; )
    r = t.sample(i), s.push(r.value), i += cr;
  return {
    times: void 0,
    keyframes: s,
    duration: i - cr,
    ease: "linear"
  };
}
const Zl = {
  anticipate: Al,
  backInOut: El,
  circInOut: Sl
};
function Qf(n) {
  return n in Zl;
}
class ba extends Hl {
  constructor(e) {
    super(e);
    const { name: t, motionValue: r, element: s, keyframes: i } = this.options;
    this.resolver = new Ul(i, (a, o) => this.onKeyframesResolved(a, o), t, r, s), this.resolver.scheduleResolve();
  }
  initPlayback(e, t) {
    let { duration: r = 300, times: s, ease: i, type: a, motionValue: o, name: l, startTime: u } = this.options;
    if (!o.owner || !o.owner.current)
      return !1;
    if (typeof i == "string" && or() && Qf(i) && (i = Zl[i]), Kf(this.options)) {
      const { onComplete: d, onUpdate: f, motionValue: p, element: g, ...y } = this.options, b = Xf(e, y);
      e = b.keyframes, e.length === 1 && (e[1] = e[0]), r = b.duration, s = b.times, i = b.ease, a = "keyframes";
    }
    const c = Hf(o.owner.current, l, e, { ...this.options, duration: r, times: s, ease: i });
    return c.startTime = u ?? this.calcStartTime(), this.pendingTimeline ? (na(c, this.pendingTimeline), this.pendingTimeline = void 0) : c.onfinish = () => {
      const { onComplete: d } = this.options;
      o.set(Mr(e, this.options, t)), d && d(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: c,
      duration: r,
      times: s,
      type: a,
      ease: i,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: t } = e;
    return /* @__PURE__ */ bt(t);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: t } = e;
    return /* @__PURE__ */ bt(t.currentTime || 0);
  }
  set time(e) {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: r } = t;
    r.currentTime = /* @__PURE__ */ ut(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: t } = e;
    return t.playbackRate;
  }
  set speed(e) {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: r } = t;
    r.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: t } = e;
    return t.playState;
  }
  get startTime() {
    const { resolved: e } = this;
    if (!e)
      return null;
    const { animation: t } = e;
    return t.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: t } = this;
      if (!t)
        return Ye;
      const { animation: r } = t;
      na(r, e);
    }
    return Ye;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: t } = e;
    t.playState === "finished" && this.updateFinishedPromise(), t.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: t } = e;
    t.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: t, keyframes: r, duration: s, type: i, ease: a, times: o } = e;
    if (t.playState === "idle" || t.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: u, onUpdate: c, onComplete: d, element: f, ...p } = this.options, g = new di({
        ...p,
        keyframes: r,
        duration: s,
        type: i,
        ease: a,
        times: o,
        isGenerator: !0
      }), y = /* @__PURE__ */ ut(this.time);
      u.setWithVelocity(g.sample(y - cr).value, g.sample(y).value, cr);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: t, name: r, repeatDelay: s, repeatType: i, damping: a, type: o } = e;
    if (!t || !t.owner || !(t.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: l, transformTemplate: u } = t.owner.getProps();
    return qf() && r && Uf.has(r) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !l && !u && !s && i !== "mirror" && a !== 0 && o !== "inertia";
  }
}
const Zf = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Jf = (n) => ({
  type: "spring",
  stiffness: 550,
  damping: n === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), ep = {
  type: "keyframes",
  duration: 0.8
}, tp = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, np = (n, { keyframes: e }) => e.length > 2 ? ep : zt.has(n) ? n.startsWith("scale") ? Jf(e[1]) : Zf : tp;
function rp({ when: n, delay: e, delayChildren: t, staggerChildren: r, staggerDirection: s, repeat: i, repeatType: a, repeatDelay: o, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
const hi = (n, e, t, r = {}, s, i) => (a) => {
  const o = Qs(r, n) || {}, l = o.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ ut(l);
  let c = {
    keyframes: Array.isArray(t) ? t : [null, t],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...o,
    delay: -u,
    onUpdate: (f) => {
      e.set(f), o.onUpdate && o.onUpdate(f);
    },
    onComplete: () => {
      a(), o.onComplete && o.onComplete();
    },
    name: n,
    motionValue: e,
    element: i ? void 0 : s
  };
  rp(o) || (c = {
    ...c,
    ...np(n, c)
  }), c.duration && (c.duration = /* @__PURE__ */ ut(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ ut(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let d = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (c.duration = 0, c.delay === 0 && (d = !0)), d && !i && e.get() !== void 0) {
    const f = Mr(c.keyframes, o);
    if (f !== void 0)
      return pe.update(() => {
        c.onUpdate(f), c.onComplete();
      }), new wh([]);
  }
  return !i && ba.supports(c) ? new ba(c) : new di(c);
};
function sp({ protectedKeys: n, needsAnimating: e }, t) {
  const r = n.hasOwnProperty(t) && e[t] !== !0;
  return e[t] = !1, r;
}
function Jl(n, e, { delay: t = 0, transitionOverride: r, type: s } = {}) {
  var i;
  let { transition: a = n.getDefaultTransition(), transitionEnd: o, ...l } = e;
  r && (a = r);
  const u = [], c = s && n.animationState && n.animationState.getState()[s];
  for (const d in l) {
    const f = n.getValue(d, (i = n.latestValues[d]) !== null && i !== void 0 ? i : null), p = l[d];
    if (p === void 0 || c && sp(c, d))
      continue;
    const g = {
      delay: t,
      ...Qs(a || {}, d)
    };
    let y = !1;
    if (window.MotionHandoffAnimation) {
      const k = xl(n);
      if (k) {
        const w = window.MotionHandoffAnimation(k, d, pe);
        w !== null && (g.startTime = w, y = !0);
      }
    }
    fs(n, d), f.start(hi(d, f, p, n.shouldReduceMotion && wl.has(d) ? { type: !1 } : g, n, y));
    const b = f.animation;
    b && u.push(b);
  }
  return o && Promise.all(u).then(() => {
    pe.update(() => {
      o && Rh(n, o);
    });
  }), u;
}
function ks(n, e, t = {}) {
  var r;
  const s = Cr(n, e, t.type === "exit" ? (r = n.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: i = n.getDefaultTransition() || {} } = s || {};
  t.transitionOverride && (i = t.transitionOverride);
  const a = s ? () => Promise.all(Jl(n, s, t)) : () => Promise.resolve(), o = n.variantChildren && n.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: d, staggerDirection: f } = i;
    return ip(n, e, c + u, d, f, t);
  } : () => Promise.resolve(), { when: l } = i;
  if (l) {
    const [u, c] = l === "beforeChildren" ? [a, o] : [o, a];
    return u().then(() => c());
  } else
    return Promise.all([a(), o(t.delay)]);
}
function ip(n, e, t = 0, r = 0, s = 1, i) {
  const a = [], o = (n.variantChildren.size - 1) * r, l = s === 1 ? (u = 0) => u * r : (u = 0) => o - u * r;
  return Array.from(n.variantChildren).sort(ap).forEach((u, c) => {
    u.notify("AnimationStart", e), a.push(ks(u, e, {
      ...i,
      delay: t + l(c)
    }).then(() => u.notify("AnimationComplete", e)));
  }), Promise.all(a);
}
function ap(n, e) {
  return n.sortNodePosition(e);
}
function op(n, e, t = {}) {
  n.notify("AnimationStart", e);
  let r;
  if (Array.isArray(e)) {
    const s = e.map((i) => ks(n, i, t));
    r = Promise.all(s);
  } else if (typeof e == "string")
    r = ks(n, e, t);
  else {
    const s = typeof e == "function" ? Cr(n, e, t.custom) : e;
    r = Promise.all(Jl(n, s, t));
  }
  return r.then(() => {
    n.notify("AnimationComplete", e);
  });
}
const lp = Ls.length;
function eu(n) {
  if (!n)
    return;
  if (!n.isControllingVariants) {
    const t = n.parent ? eu(n.parent) || {} : {};
    return n.props.initial !== void 0 && (t.initial = n.props.initial), t;
  }
  const e = {};
  for (let t = 0; t < lp; t++) {
    const r = Ls[t], s = n.props[r];
    (An(s) || s === !1) && (e[r] = s);
  }
  return e;
}
const up = [...Bs].reverse(), cp = Bs.length;
function dp(n) {
  return (e) => Promise.all(e.map(({ animation: t, options: r }) => op(n, t, r)));
}
function hp(n) {
  let e = dp(n), t = ka(), r = !0;
  const s = (l) => (u, c) => {
    var d;
    const f = Cr(n, c, l === "exit" ? (d = n.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: p, transitionEnd: g, ...y } = f;
      u = { ...u, ...y, ...g };
    }
    return u;
  };
  function i(l) {
    e = l(n);
  }
  function a(l) {
    const { props: u } = n, c = eu(n.parent) || {}, d = [], f = /* @__PURE__ */ new Set();
    let p = {}, g = 1 / 0;
    for (let b = 0; b < cp; b++) {
      const k = up[b], w = t[k], m = u[k] !== void 0 ? u[k] : c[k], _ = An(m), v = k === l ? w.isActive : null;
      v === !1 && (g = b);
      let x = m === c[k] && m !== u[k] && _;
      if (x && r && n.manuallyAnimateOnMount && (x = !1), w.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && v === null || // If we didn't and don't have any defined prop for this animation type
      !m && !w.prevProp || // Or if the prop doesn't define an animation
      xr(m) || typeof m == "boolean")
        continue;
      const P = fp(w.prevProp, m);
      let R = P || // If we're making this variant active, we want to always make it active
      k === l && w.isActive && !x && _ || // If we removed a higher-priority variant (i is in reverse order)
      b > g && _, B = !1;
      const ue = Array.isArray(m) ? m : [m];
      let ae = ue.reduce(s(k), {});
      v === !1 && (ae = {});
      const { prevResolvedValues: $ = {} } = w, Te = {
        ...$,
        ...ae
      }, ke = (E) => {
        R = !0, f.has(E) && (B = !0, f.delete(E)), w.needsAnimating[E] = !0;
        const A = n.getValue(E);
        A && (A.liveStyle = !1);
      };
      for (const E in Te) {
        const A = ae[E], Ee = $[E];
        if (p.hasOwnProperty(E))
          continue;
        let M = !1;
        cs(A) && cs(Ee) ? M = !fl(A, Ee) : M = A !== Ee, M ? A != null ? ke(E) : f.add(E) : A !== void 0 && f.has(E) ? ke(E) : w.protectedKeys[E] = !0;
      }
      w.prevProp = m, w.prevResolvedValues = ae, w.isActive && (p = { ...p, ...ae }), r && n.blockInitialAnimation && (R = !1), R && (!(x && P) || B) && d.push(...ue.map((E) => ({
        animation: E,
        options: { type: k }
      })));
    }
    if (f.size) {
      const b = {};
      f.forEach((k) => {
        const w = n.getBaseTarget(k), m = n.getValue(k);
        m && (m.liveStyle = !0), b[k] = w ?? null;
      }), d.push({ animation: b });
    }
    let y = !!d.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !n.manuallyAnimateOnMount && (y = !1), r = !1, y ? e(d) : Promise.resolve();
  }
  function o(l, u) {
    var c;
    if (t[l].isActive === u)
      return Promise.resolve();
    (c = n.variantChildren) === null || c === void 0 || c.forEach((f) => {
      var p;
      return (p = f.animationState) === null || p === void 0 ? void 0 : p.setActive(l, u);
    }), t[l].isActive = u;
    const d = a(l);
    for (const f in t)
      t[f].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: a,
    setActive: o,
    setAnimateFunction: i,
    getState: () => t,
    reset: () => {
      t = ka(), r = !0;
    }
  };
}
function fp(n, e) {
  return typeof e == "string" ? e !== n : Array.isArray(e) ? !fl(e, n) : !1;
}
function It(n = !1) {
  return {
    isActive: n,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function ka() {
  return {
    animate: It(!0),
    whileInView: It(),
    whileHover: It(),
    whileTap: It(),
    whileDrag: It(),
    whileFocus: It(),
    exit: It()
  };
}
class Rt {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class pp extends Rt {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = hp(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    xr(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: t } = this.node.prevProps || {};
    e !== t && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) === null || e === void 0 || e.call(this);
  }
}
let mp = 0;
class gp extends Rt {
  constructor() {
    super(...arguments), this.id = mp++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: t } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === r)
      return;
    const s = this.node.animationState.setActive("exit", !e);
    t && !e && s.then(() => t(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const vp = {
  animation: {
    Feature: pp
  },
  exit: {
    Feature: gp
  }
};
function On(n, e, t, r = { passive: !0 }) {
  return n.addEventListener(e, t, r), () => n.removeEventListener(e, t);
}
function jn(n) {
  return {
    point: {
      x: n.pageX,
      y: n.pageY
    }
  };
}
const yp = (n) => (e) => ei(e) && n(e, jn(e));
function Cn(n, e, t, r) {
  return On(n, e, yp(t), r);
}
const wa = (n, e) => Math.abs(n - e);
function bp(n, e) {
  const t = wa(n.x, e.x), r = wa(n.y, e.y);
  return Math.sqrt(t ** 2 + r ** 2);
}
class tu {
  constructor(e, t, { transformPagePoint: r, contextWindow: s, dragSnapToOrigin: i = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = zr(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, p = bp(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !p)
        return;
      const { point: g } = d, { timestamp: y } = Ne;
      this.history.push({ ...g, timestamp: y });
      const { onStart: b, onMove: k } = this.handlers;
      f || (b && b(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), k && k(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = $r(f, this.transformPagePoint), pe.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: p, onSessionEnd: g, resumeAnimation: y } = this.handlers;
      if (this.dragSnapToOrigin && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const b = zr(d.type === "pointercancel" ? this.lastMoveEventInfo : $r(f, this.transformPagePoint), this.history);
      this.startEvent && p && p(d, b), g && g(d, b);
    }, !ei(e))
      return;
    this.dragSnapToOrigin = i, this.handlers = t, this.transformPagePoint = r, this.contextWindow = s || window;
    const a = jn(e), o = $r(a, this.transformPagePoint), { point: l } = o, { timestamp: u } = Ne;
    this.history = [{ ...l, timestamp: u }];
    const { onSessionStart: c } = t;
    c && c(e, zr(o, this.history)), this.removeListeners = Ln(Cn(this.contextWindow, "pointermove", this.handlePointerMove), Cn(this.contextWindow, "pointerup", this.handlePointerUp), Cn(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), Ot(this.updatePoint);
  }
}
function $r(n, e) {
  return e ? { point: e(n.point) } : n;
}
function _a(n, e) {
  return { x: n.x - e.x, y: n.y - e.y };
}
function zr({ point: n }, e) {
  return {
    point: n,
    delta: _a(n, nu(e)),
    offset: _a(n, kp(e)),
    velocity: wp(e, 0.1)
  };
}
function kp(n) {
  return n[0];
}
function nu(n) {
  return n[n.length - 1];
}
function wp(n, e) {
  if (n.length < 2)
    return { x: 0, y: 0 };
  let t = n.length - 1, r = null;
  const s = nu(n);
  for (; t >= 0 && (r = n[t], !(s.timestamp - r.timestamp > /* @__PURE__ */ ut(e))); )
    t--;
  if (!r)
    return { x: 0, y: 0 };
  const i = /* @__PURE__ */ bt(s.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (s.x - r.x) / i,
    y: (s.y - r.y) / i
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
const ru = 1e-4, _p = 1 - ru, xp = 1 + ru, su = 0.01, Tp = 0 - su, Cp = 0 + su;
function qe(n) {
  return n.max - n.min;
}
function Mp(n, e, t) {
  return Math.abs(n - e) <= t;
}
function xa(n, e, t, r = 0.5) {
  n.origin = r, n.originPoint = ye(e.min, e.max, n.origin), n.scale = qe(t) / qe(e), n.translate = ye(t.min, t.max, n.origin) - n.originPoint, (n.scale >= _p && n.scale <= xp || isNaN(n.scale)) && (n.scale = 1), (n.translate >= Tp && n.translate <= Cp || isNaN(n.translate)) && (n.translate = 0);
}
function Mn(n, e, t, r) {
  xa(n.x, e.x, t.x, r ? r.originX : void 0), xa(n.y, e.y, t.y, r ? r.originY : void 0);
}
function Ta(n, e, t) {
  n.min = t.min + e.min, n.max = n.min + qe(e);
}
function Dp(n, e, t) {
  Ta(n.x, e.x, t.x), Ta(n.y, e.y, t.y);
}
function Ca(n, e, t) {
  n.min = e.min - t.min, n.max = n.min + qe(e);
}
function Dn(n, e, t) {
  Ca(n.x, e.x, t.x), Ca(n.y, e.y, t.y);
}
function Ep(n, { min: e, max: t }, r) {
  return e !== void 0 && n < e ? n = r ? ye(e, n, r.min) : Math.max(n, e) : t !== void 0 && n > t && (n = r ? ye(t, n, r.max) : Math.min(n, t)), n;
}
function Ma(n, e, t) {
  return {
    min: e !== void 0 ? n.min + e : void 0,
    max: t !== void 0 ? n.max + t - (n.max - n.min) : void 0
  };
}
function Ap(n, { top: e, left: t, bottom: r, right: s }) {
  return {
    x: Ma(n.x, t, s),
    y: Ma(n.y, e, r)
  };
}
function Da(n, e) {
  let t = e.min - n.min, r = e.max - n.max;
  return e.max - e.min < n.max - n.min && ([t, r] = [r, t]), { min: t, max: r };
}
function Pp(n, e) {
  return {
    x: Da(n.x, e.x),
    y: Da(n.y, e.y)
  };
}
function Sp(n, e) {
  let t = 0.5;
  const r = qe(n), s = qe(e);
  return s > r ? t = /* @__PURE__ */ rn(e.min, e.max - r, n.min) : r > s && (t = /* @__PURE__ */ rn(n.min, n.max - s, e.min)), kt(0, 1, t);
}
function Np(n, e) {
  const t = {};
  return e.min !== void 0 && (t.min = e.min - n.min), e.max !== void 0 && (t.max = e.max - n.min), t;
}
const ws = 0.35;
function Op(n = ws) {
  return n === !1 ? n = 0 : n === !0 && (n = ws), {
    x: Ea(n, "left", "right"),
    y: Ea(n, "top", "bottom")
  };
}
function Ea(n, e, t) {
  return {
    min: Aa(n, e),
    max: Aa(n, t)
  };
}
function Aa(n, e) {
  return typeof n == "number" ? n : n[e] || 0;
}
const Pa = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Xt = () => ({
  x: Pa(),
  y: Pa()
}), Sa = () => ({ min: 0, max: 0 }), Ce = () => ({
  x: Sa(),
  y: Sa()
});
function Qe(n) {
  return [n("x"), n("y")];
}
function iu({ top: n, left: e, right: t, bottom: r }) {
  return {
    x: { min: e, max: t },
    y: { min: n, max: r }
  };
}
function Fp({ x: n, y: e }) {
  return { top: e.min, right: n.max, bottom: e.max, left: n.min };
}
function Rp(n, e) {
  if (!e)
    return n;
  const t = e({ x: n.left, y: n.top }), r = e({ x: n.right, y: n.bottom });
  return {
    top: t.y,
    left: t.x,
    bottom: r.y,
    right: r.x
  };
}
function Ur(n) {
  return n === void 0 || n === 1;
}
function _s({ scale: n, scaleX: e, scaleY: t }) {
  return !Ur(n) || !Ur(e) || !Ur(t);
}
function Vt(n) {
  return _s(n) || au(n) || n.z || n.rotate || n.rotateX || n.rotateY || n.skewX || n.skewY;
}
function au(n) {
  return Na(n.x) || Na(n.y);
}
function Na(n) {
  return n && n !== "0%";
}
function dr(n, e, t) {
  const r = n - t, s = e * r;
  return t + s;
}
function Oa(n, e, t, r, s) {
  return s !== void 0 && (n = dr(n, s, r)), dr(n, t, r) + e;
}
function xs(n, e = 0, t = 1, r, s) {
  n.min = Oa(n.min, e, t, r, s), n.max = Oa(n.max, e, t, r, s);
}
function ou(n, { x: e, y: t }) {
  xs(n.x, e.translate, e.scale, e.originPoint), xs(n.y, t.translate, t.scale, t.originPoint);
}
const Fa = 0.999999999999, Ra = 1.0000000000001;
function Ip(n, e, t, r = !1) {
  const s = t.length;
  if (!s)
    return;
  e.x = e.y = 1;
  let i, a;
  for (let o = 0; o < s; o++) {
    i = t[o], a = i.projectionDelta;
    const { visualElement: l } = i.options;
    l && l.props.style && l.props.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && Zt(n, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), a && (e.x *= a.x.scale, e.y *= a.y.scale, ou(n, a)), r && Vt(i.latestValues) && Zt(n, i.latestValues));
  }
  e.x < Ra && e.x > Fa && (e.x = 1), e.y < Ra && e.y > Fa && (e.y = 1);
}
function Qt(n, e) {
  n.min = n.min + e, n.max = n.max + e;
}
function Ia(n, e, t, r, s = 0.5) {
  const i = ye(n.min, n.max, s);
  xs(n, e, t, i, r);
}
function Zt(n, e) {
  Ia(n.x, e.x, e.scaleX, e.scale, e.originX), Ia(n.y, e.y, e.scaleY, e.scale, e.originY);
}
function lu(n, e) {
  return iu(Rp(n.getBoundingClientRect(), e));
}
function Vp(n, e, t) {
  const r = lu(n, t), { scroll: s } = e;
  return s && (Qt(r.x, s.offset.x), Qt(r.y, s.offset.y)), r;
}
const uu = ({ current: n }) => n ? n.ownerDocument.defaultView : null, Bp = /* @__PURE__ */ new WeakMap();
class Lp {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Ce(), this.visualElement = e;
  }
  start(e, { snapToCursor: t = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const s = (c) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), t && this.snapToCursor(jn(c).point);
    }, i = (c, d) => {
      const { drag: f, dragPropagation: p, onDragStart: g } = this.getProps();
      if (f && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = Ph(f), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Qe((b) => {
        let k = this.getAxisMotionValue(b).get() || 0;
        if (ct.test(k)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const m = w.layout.layoutBox[b];
            m && (k = qe(m) * (parseFloat(k) / 100));
          }
        }
        this.originPoint[b] = k;
      }), g && pe.postRender(() => g(c, d)), fs(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, a = (c, d) => {
      const { dragPropagation: f, dragDirectionLock: p, onDirectionLock: g, onDrag: y } = this.getProps();
      if (!f && !this.openDragLock)
        return;
      const { offset: b } = d;
      if (p && this.currentDirection === null) {
        this.currentDirection = jp(b), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, b), this.updateAxis("y", d.point, b), this.visualElement.render(), y && y(c, d);
    }, o = (c, d) => this.stop(c, d), l = () => Qe((c) => {
      var d;
      return this.getAnimationState(c) === "paused" && ((d = this.getAxisMotionValue(c).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new tu(e, {
      onSessionStart: s,
      onStart: i,
      onMove: a,
      onSessionEnd: o,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      contextWindow: uu(this.visualElement)
    });
  }
  stop(e, t) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: s } = t;
    this.startAnimation(s);
    const { onDragEnd: i } = this.getProps();
    i && pe.postRender(() => i(e, t));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: t } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), t && t.setActive("whileDrag", !1);
  }
  updateAxis(e, t, r) {
    const { drag: s } = this.getProps();
    if (!r || !Xn(e, s, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(e);
    let a = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (a = Ep(a, this.constraints[e], this.elastic[e])), i.set(a);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: t, dragElastic: r } = this.getProps(), s = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, i = this.constraints;
    t && Gt(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && s ? this.constraints = Ap(s.layoutBox, t) : this.constraints = !1, this.elastic = Op(r), i !== this.constraints && s && this.constraints && !this.hasMutatedConstraints && Qe((a) => {
      this.constraints !== !1 && this.getAxisMotionValue(a) && (this.constraints[a] = Np(s.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: t } = this.getProps();
    if (!e || !Gt(e))
      return !1;
    const r = e.current;
    Nt(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: s } = this.visualElement;
    if (!s || !s.layout)
      return !1;
    const i = Vp(r, s.root, this.visualElement.getTransformPagePoint());
    let a = Pp(s.layout.layoutBox, i);
    if (t) {
      const o = t(Fp(a));
      this.hasMutatedConstraints = !!o, o && (a = iu(o));
    }
    return a;
  }
  startAnimation(e) {
    const { drag: t, dragMomentum: r, dragElastic: s, dragTransition: i, dragSnapToOrigin: a, onDragTransitionEnd: o } = this.getProps(), l = this.constraints || {}, u = Qe((c) => {
      if (!Xn(c, t, this.currentDirection))
        return;
      let d = l && l[c] || {};
      a && (d = { min: 0, max: 0 });
      const f = s ? 200 : 1e6, p = s ? 40 : 1e7, g = {
        type: "inertia",
        velocity: r ? e[c] : 0,
        bounceStiffness: f,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...d
      };
      return this.startAxisValueAnimation(c, g);
    });
    return Promise.all(u).then(o);
  }
  startAxisValueAnimation(e, t) {
    const r = this.getAxisMotionValue(e);
    return fs(this.visualElement, e), r.start(hi(e, r, 0, t, this.visualElement, !1));
  }
  stopAnimation() {
    Qe((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    Qe((e) => {
      var t;
      return (t = this.getAxisMotionValue(e).animation) === null || t === void 0 ? void 0 : t.pause();
    });
  }
  getAnimationState(e) {
    var t;
    return (t = this.getAxisMotionValue(e).animation) === null || t === void 0 ? void 0 : t.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const t = `_drag${e.toUpperCase()}`, r = this.visualElement.getProps(), s = r[t];
    return s || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    Qe((t) => {
      const { drag: r } = this.getProps();
      if (!Xn(t, r, this.currentDirection))
        return;
      const { projection: s } = this.visualElement, i = this.getAxisMotionValue(t);
      if (s && s.layout) {
        const { min: a, max: o } = s.layout.layoutBox[t];
        i.set(e[t] - ye(a, o, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: t } = this.getProps(), { projection: r } = this.visualElement;
    if (!Gt(t) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const s = { x: 0, y: 0 };
    Qe((a) => {
      const o = this.getAxisMotionValue(a);
      if (o && this.constraints !== !1) {
        const l = o.get();
        s[a] = Sp({ min: l, max: l }, this.constraints[a]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Qe((a) => {
      if (!Xn(a, e, null))
        return;
      const o = this.getAxisMotionValue(a), { min: l, max: u } = this.constraints[a];
      o.set(ye(l, u, s[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Bp.set(this.visualElement, this);
    const e = this.visualElement.current, t = Cn(e, "pointerdown", (l) => {
      const { drag: u, dragListener: c = !0 } = this.getProps();
      u && c && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      Gt(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: s } = this.visualElement, i = s.addEventListener("measure", r);
    s && !s.layout && (s.root && s.root.updateScroll(), s.updateLayout()), pe.read(r);
    const a = On(window, "resize", () => this.scalePositionWithinConstraints()), o = s.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: u }) => {
      this.isDragging && u && (Qe((c) => {
        const d = this.getAxisMotionValue(c);
        d && (this.originPoint[c] += l[c].translate, d.set(d.get() + l[c].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), t(), i(), o && o();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: t = !1, dragDirectionLock: r = !1, dragPropagation: s = !1, dragConstraints: i = !1, dragElastic: a = ws, dragMomentum: o = !0 } = e;
    return {
      ...e,
      drag: t,
      dragDirectionLock: r,
      dragPropagation: s,
      dragConstraints: i,
      dragElastic: a,
      dragMomentum: o
    };
  }
}
function Xn(n, e, t) {
  return (e === !0 || e === n) && (t === null || t === n);
}
function jp(n, e = 10) {
  let t = null;
  return Math.abs(n.y) > e ? t = "y" : Math.abs(n.x) > e && (t = "x"), t;
}
class Wp extends Rt {
  constructor(e) {
    super(e), this.removeGroupControls = Ye, this.removeListeners = Ye, this.controls = new Lp(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Ye;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Va = (n) => (e, t) => {
  n && pe.postRender(() => n(e, t));
};
class Yp extends Rt {
  constructor() {
    super(...arguments), this.removePointerDownListener = Ye;
  }
  onPointerDown(e) {
    this.session = new tu(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: uu(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: t, onPan: r, onPanEnd: s } = this.node.getProps();
    return {
      onSessionStart: Va(e),
      onStart: Va(t),
      onMove: r,
      onEnd: (i, a) => {
        delete this.session, s && pe.postRender(() => s(i, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Cn(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const er = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Ba(n, e) {
  return e.max === e.min ? 0 : n / (e.max - e.min) * 100;
}
const bn = {
  correct: (n, e) => {
    if (!e.target)
      return n;
    if (typeof n == "string")
      if (L.test(n))
        n = parseFloat(n);
      else
        return n;
    const t = Ba(n, e.target.x), r = Ba(n, e.target.y);
    return `${t}% ${r}%`;
  }
}, $p = {
  correct: (n, { treeScale: e, projectionDelta: t }) => {
    const r = n, s = Ft.parse(n);
    if (s.length > 5)
      return r;
    const i = Ft.createTransformer(n), a = typeof s[0] != "number" ? 1 : 0, o = t.x.scale * e.x, l = t.y.scale * e.y;
    s[0 + a] /= o, s[1 + a] /= l;
    const u = ye(o, l, 0.5);
    return typeof s[2 + a] == "number" && (s[2 + a] /= u), typeof s[3 + a] == "number" && (s[3 + a] /= u), i(s);
  }
};
class zp extends pc {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: t, switchLayoutGroup: r, layoutId: s } = this.props, { projection: i } = e;
    uh(Up), i && (t.group && t.group.add(i), r && r.register && s && r.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), er.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: t, visualElement: r, drag: s, isPresent: i } = this.props, a = r.projection;
    return a && (a.isPresent = i, s || e.layoutDependency !== t || t === void 0 ? a.willUpdate() : this.safeToRemove(), e.isPresent !== i && (i ? a.promote() : a.relegate() || pe.postRender(() => {
      const o = a.getStack();
      (!o || !o.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), Ws.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: t, switchLayoutGroup: r } = this.props, { projection: s } = e;
    s && (s.scheduleCheckAfterUnmount(), t && t.group && t.group.remove(s), r && r.deregister && r.deregister(s));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function cu(n) {
  const [e, t] = Ho(), r = ce(Rs);
  return h(zp, { ...n, layoutGroup: r, switchLayoutGroup: ce(el), isPresent: e, safeToRemove: t });
}
const Up = {
  borderRadius: {
    ...bn,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: bn,
  borderTopRightRadius: bn,
  borderBottomLeftRadius: bn,
  borderBottomRightRadius: bn,
  boxShadow: $p
};
function Hp(n, e, t) {
  const r = Re(n) ? n : Sn(n);
  return r.start(hi("", r, e, t)), r.animation;
}
function qp(n) {
  return n instanceof SVGElement && n.tagName !== "svg";
}
const Gp = (n, e) => n.depth - e.depth;
class Kp {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    ti(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    ni(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(Gp), this.isDirty = !1, this.children.forEach(e);
  }
}
function Xp(n, e) {
  const t = dt.now(), r = ({ timestamp: s }) => {
    const i = s - t;
    i >= e && (Ot(r), n(i - e));
  };
  return pe.read(r, !0), () => Ot(r);
}
const du = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Qp = du.length, La = (n) => typeof n == "string" ? parseFloat(n) : n, ja = (n) => typeof n == "number" || L.test(n);
function Zp(n, e, t, r, s, i) {
  s ? (n.opacity = ye(
    0,
    // TODO Reinstate this if only child
    t.opacity !== void 0 ? t.opacity : 1,
    Jp(r)
  ), n.opacityExit = ye(e.opacity !== void 0 ? e.opacity : 1, 0, em(r))) : i && (n.opacity = ye(e.opacity !== void 0 ? e.opacity : 1, t.opacity !== void 0 ? t.opacity : 1, r));
  for (let a = 0; a < Qp; a++) {
    const o = `border${du[a]}Radius`;
    let l = Wa(e, o), u = Wa(t, o);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || ja(l) === ja(u) ? (n[o] = Math.max(ye(La(l), La(u), r), 0), (ct.test(u) || ct.test(l)) && (n[o] += "%")) : n[o] = u;
  }
  (e.rotate || t.rotate) && (n.rotate = ye(e.rotate || 0, t.rotate || 0, r));
}
function Wa(n, e) {
  return n[e] !== void 0 ? n[e] : n.borderRadius;
}
const Jp = /* @__PURE__ */ hu(0, 0.5, Pl), em = /* @__PURE__ */ hu(0.5, 0.95, Ye);
function hu(n, e, t) {
  return (r) => r < n ? 0 : r > e ? 1 : t(/* @__PURE__ */ rn(n, e, r));
}
function Ya(n, e) {
  n.min = e.min, n.max = e.max;
}
function Xe(n, e) {
  Ya(n.x, e.x), Ya(n.y, e.y);
}
function $a(n, e) {
  n.translate = e.translate, n.scale = e.scale, n.originPoint = e.originPoint, n.origin = e.origin;
}
function za(n, e, t, r, s) {
  return n -= e, n = dr(n, 1 / t, r), s !== void 0 && (n = dr(n, 1 / s, r)), n;
}
function tm(n, e = 0, t = 1, r = 0.5, s, i = n, a = n) {
  if (ct.test(e) && (e = parseFloat(e), e = ye(a.min, a.max, e / 100) - a.min), typeof e != "number")
    return;
  let o = ye(i.min, i.max, r);
  n === i && (o -= e), n.min = za(n.min, e, t, o, s), n.max = za(n.max, e, t, o, s);
}
function Ua(n, e, [t, r, s], i, a) {
  tm(n, e[t], e[r], e[s], e.scale, i, a);
}
const nm = ["x", "scaleX", "originX"], rm = ["y", "scaleY", "originY"];
function Ha(n, e, t, r) {
  Ua(n.x, e, nm, t ? t.x : void 0, r ? r.x : void 0), Ua(n.y, e, rm, t ? t.y : void 0, r ? r.y : void 0);
}
function qa(n) {
  return n.translate === 0 && n.scale === 1;
}
function fu(n) {
  return qa(n.x) && qa(n.y);
}
function Ga(n, e) {
  return n.min === e.min && n.max === e.max;
}
function sm(n, e) {
  return Ga(n.x, e.x) && Ga(n.y, e.y);
}
function Ka(n, e) {
  return Math.round(n.min) === Math.round(e.min) && Math.round(n.max) === Math.round(e.max);
}
function pu(n, e) {
  return Ka(n.x, e.x) && Ka(n.y, e.y);
}
function Xa(n) {
  return qe(n.x) / qe(n.y);
}
function Qa(n, e) {
  return n.translate === e.translate && n.scale === e.scale && n.originPoint === e.originPoint;
}
class im {
  constructor() {
    this.members = [];
  }
  add(e) {
    ti(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (ni(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const t = this.members[this.members.length - 1];
      t && this.promote(t);
    }
  }
  relegate(e) {
    const t = this.members.findIndex((s) => e === s);
    if (t === 0)
      return !1;
    let r;
    for (let s = t; s >= 0; s--) {
      const i = this.members[s];
      if (i.isPresent !== !1) {
        r = i;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(e, t) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender(), e.resumeFrom = r, t && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: s } = e.options;
      s === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: t, resumingFrom: r } = e;
      t.onExitComplete && t.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function am(n, e, t) {
  let r = "";
  const s = n.x.translate / e.x, i = n.y.translate / e.y, a = (t == null ? void 0 : t.z) || 0;
  if ((s || i || a) && (r = `translate3d(${s}px, ${i}px, ${a}px) `), (e.x !== 1 || e.y !== 1) && (r += `scale(${1 / e.x}, ${1 / e.y}) `), t) {
    const { transformPerspective: u, rotate: c, rotateX: d, rotateY: f, skewX: p, skewY: g } = t;
    u && (r = `perspective(${u}px) ${r}`), c && (r += `rotate(${c}deg) `), d && (r += `rotateX(${d}deg) `), f && (r += `rotateY(${f}deg) `), p && (r += `skewX(${p}deg) `), g && (r += `skewY(${g}deg) `);
  }
  const o = n.x.scale * e.x, l = n.y.scale * e.y;
  return (o !== 1 || l !== 1) && (r += `scale(${o}, ${l})`), r || "none";
}
const Bt = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, xn = typeof window < "u" && window.MotionDebug !== void 0, Hr = ["", "X", "Y", "Z"], om = { visibility: "hidden" }, Za = 1e3;
let lm = 0;
function qr(n, e, t, r) {
  const { latestValues: s } = e;
  s[n] && (t[n] = s[n], e.setStaticValue(n, 0), r && (r[n] = 0));
}
function mu(n) {
  if (n.hasCheckedOptimisedAppear = !0, n.root === n)
    return;
  const { visualElement: e } = n.options;
  if (!e)
    return;
  const t = xl(e);
  if (window.MotionHasOptimisedAnimation(t, "transform")) {
    const { layout: s, layoutId: i } = n.options;
    window.MotionCancelOptimisedAnimation(t, "transform", pe, !(s || i));
  }
  const { parent: r } = n;
  r && !r.hasCheckedOptimisedAppear && mu(r);
}
function gu({ attachResizeListener: n, defaultParent: e, measureScroll: t, checkIsScrollRoot: r, resetTransform: s }) {
  return class {
    constructor(a = {}, o = e == null ? void 0 : e()) {
      this.id = lm++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, xn && (Bt.totalNodes = Bt.resolvedTargetDeltas = Bt.recalculatedProjection = 0), this.nodes.forEach(dm), this.nodes.forEach(gm), this.nodes.forEach(vm), this.nodes.forEach(hm), xn && window.MotionDebug.record(Bt);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = o ? o.root || o : this, this.path = o ? [...o.path, o] : [], this.parent = o, this.depth = o ? o.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Kp());
    }
    addEventListener(a, o) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new ri()), this.eventHandlers.get(a).add(o);
    }
    notifyListeners(a, ...o) {
      const l = this.eventHandlers.get(a);
      l && l.notify(...o);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a, o = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = qp(a), this.instance = a;
      const { layoutId: l, layout: u, visualElement: c } = this.options;
      if (c && !c.current && c.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), o && (u || l) && (this.isLayoutDirty = !0), n) {
        let d;
        const f = () => this.root.updateBlockedByResize = !1;
        n(a, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = Xp(f, 250), er.hasAnimatedSinceResize && (er.hasAnimatedSinceResize = !1, this.nodes.forEach(eo));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && c && (l || u) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f, hasRelativeTargetChanged: p, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const y = this.options.transition || c.getDefaultTransition() || _m, { onLayoutAnimationStart: b, onLayoutAnimationComplete: k } = c.getProps(), w = !this.targetLayout || !pu(this.targetLayout, g) || p, m = !f && p;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || m || f && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, m);
          const _ = {
            ...Qs(y, "layout"),
            onPlay: b,
            onComplete: k
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (_.delay = 0, _.type = !1), this.startAnimation(_);
        } else
          f || eo(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Ot(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(ym), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && mu(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: o, layout: l } = this.options;
      if (o === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Ja);
        return;
      }
      this.isUpdating || this.nodes.forEach(pm), this.isUpdating = !1, this.nodes.forEach(mm), this.nodes.forEach(um), this.nodes.forEach(cm), this.clearAllSnapshots();
      const o = dt.now();
      Ne.delta = kt(0, 1e3 / 60, o - Ne.timestamp), Ne.timestamp = o, Ne.isProcessing = !0, Vr.update.process(Ne), Vr.preRender.process(Ne), Vr.render.process(Ne), Ne.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Ws.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(fm), this.sharedNodes.forEach(bm);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, pe.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      pe.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Ce(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: o } = this.options;
      o && o.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let o = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (o = !1), o) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: l,
          offset: t(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!s)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, o = this.projectionDelta && !fu(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      a && (o || Vt(this.latestValues) || c) && (s(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const o = this.measurePageBox();
      let l = this.removeElementScroll(o);
      return a && (l = this.removeTransform(l)), xm(l), {
        animationId: this.root.animationId,
        measuredBox: o,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var a;
      const { visualElement: o } = this.options;
      if (!o)
        return Ce();
      const l = o.measureViewportBox();
      if (!(((a = this.scroll) === null || a === void 0 ? void 0 : a.wasRoot) || this.path.some(Tm))) {
        const { scroll: c } = this.root;
        c && (Qt(l.x, c.offset.x), Qt(l.y, c.offset.y));
      }
      return l;
    }
    removeElementScroll(a) {
      var o;
      const l = Ce();
      if (Xe(l, a), !((o = this.scroll) === null || o === void 0) && o.wasRoot)
        return l;
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u], { scroll: d, options: f } = c;
        c !== this.root && d && f.layoutScroll && (d.wasRoot && Xe(l, a), Qt(l.x, d.offset.x), Qt(l.y, d.offset.y));
      }
      return l;
    }
    applyTransform(a, o = !1) {
      const l = Ce();
      Xe(l, a);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        !o && c.options.layoutScroll && c.scroll && c !== c.root && Zt(l, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), Vt(c.latestValues) && Zt(l, c.latestValues);
      }
      return Vt(this.latestValues) && Zt(l, this.latestValues), l;
    }
    removeTransform(a) {
      const o = Ce();
      Xe(o, a);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!u.instance || !Vt(u.latestValues))
          continue;
        _s(u.latestValues) && u.updateSnapshot();
        const c = Ce(), d = u.measurePageBox();
        Xe(c, d), Ha(o, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, c);
      }
      return Vt(this.latestValues) && Ha(o, this.latestValues), o;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Ne.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var o;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const u = !!this.resumingFrom || this !== l;
      if (!(a || u && this.isSharedProjectionDirty || this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: d, layoutId: f } = this.options;
      if (!(!this.layout || !(d || f))) {
        if (this.resolvedRelativeTargetAt = Ne.timestamp, !this.targetDelta && !this.relativeTarget) {
          const p = this.getClosestProjectingParent();
          p && p.layout && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Ce(), this.relativeTargetOrigin = Ce(), Dn(this.relativeTargetOrigin, this.layout.layoutBox, p.layout.layoutBox), Xe(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = Ce(), this.targetWithTransforms = Ce()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Dp(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Xe(this.target, this.layout.layoutBox), ou(this.target, this.targetDelta)) : Xe(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const p = this.getClosestProjectingParent();
            p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Ce(), this.relativeTargetOrigin = Ce(), Dn(this.relativeTargetOrigin, this.target, p.target), Xe(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          xn && Bt.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || _s(this.parent.latestValues) || au(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const o = this.getLead(), l = !!this.resumingFrom || this !== o;
      let u = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (u = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (u = !1), this.resolvedRelativeTargetAt === Ne.timestamp && (u = !1), u)
        return;
      const { layout: c, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || d))
        return;
      Xe(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, p = this.treeScale.y;
      Ip(this.layoutCorrected, this.treeScale, this.path, l), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = Ce());
      const { target: g } = o;
      if (!g) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : ($a(this.prevProjectionDelta.x, this.projectionDelta.x), $a(this.prevProjectionDelta.y, this.projectionDelta.y)), Mn(this.projectionDelta, this.layoutCorrected, g, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== p || !Qa(this.projectionDelta.x, this.prevProjectionDelta.x) || !Qa(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g)), xn && Bt.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      var o;
      if ((o = this.options.visualElement) === null || o === void 0 || o.scheduleRender(), a) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Xt(), this.projectionDelta = Xt(), this.projectionDeltaWithTransform = Xt();
    }
    setAnimationOrigin(a, o = !1) {
      const l = this.snapshot, u = l ? l.latestValues : {}, c = { ...this.latestValues }, d = Xt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !o;
      const f = Ce(), p = l ? l.source : void 0, g = this.layout ? this.layout.source : void 0, y = p !== g, b = this.getStack(), k = !b || b.members.length <= 1, w = !!(y && !k && this.options.crossfade === !0 && !this.path.some(wm));
      this.animationProgress = 0;
      let m;
      this.mixTargetDelta = (_) => {
        const v = _ / 1e3;
        to(d.x, a.x, v), to(d.y, a.y, v), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Dn(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), km(this.relativeTarget, this.relativeTargetOrigin, f, v), m && sm(this.relativeTarget, m) && (this.isProjectionDirty = !1), m || (m = Ce()), Xe(m, this.relativeTarget)), y && (this.animationValues = c, Zp(c, u, this.latestValues, v, w, k)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = v;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Ot(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = pe.update(() => {
        er.hasAnimatedSinceResize = !0, this.currentAnimation = Hp(0, Za, {
          ...a,
          onUpdate: (o) => {
            this.mixTargetDelta(o), a.onUpdate && a.onUpdate(o);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Za), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: o, target: l, layout: u, latestValues: c } = a;
      if (!(!o || !l || !u)) {
        if (this !== a && this.layout && u && vu(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || Ce();
          const d = qe(this.layout.layoutBox.x);
          l.x.min = a.target.x.min, l.x.max = l.x.min + d;
          const f = qe(this.layout.layoutBox.y);
          l.y.min = a.target.y.min, l.y.max = l.y.min + f;
        }
        Xe(o, l), Zt(o, c), Mn(this.projectionDeltaWithTransform, this.layoutCorrected, o, c);
      }
    }
    registerSharedNode(a, o) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new im()), this.sharedNodes.get(a).add(o);
      const u = o.options.initialPromotionConfig;
      o.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(o) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: o, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), a && (this.projectionDelta = void 0, this.needsReset = !0), o && this.setOptions({ transition: o });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let o = !1;
      const { latestValues: l } = a;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (o = !0), !o)
        return;
      const u = {};
      l.z && qr("z", a, u, this.animationValues);
      for (let c = 0; c < Hr.length; c++)
        qr(`rotate${Hr[c]}`, a, u, this.animationValues), qr(`skew${Hr[c]}`, a, u, this.animationValues);
      a.render();
      for (const c in u)
        a.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      var o, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return om;
      const u = {
        visibility: ""
      }, c = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, u.opacity = "", u.pointerEvents = Zn(a == null ? void 0 : a.pointerEvents) || "", u.transform = c ? c(this.latestValues, "") : "none", u;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const y = {};
        return this.options.layoutId && (y.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, y.pointerEvents = Zn(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !Vt(this.latestValues) && (y.transform = c ? c({}, "") : "none", this.hasProjected = !1), y;
      }
      const f = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), u.transform = am(this.projectionDeltaWithTransform, this.treeScale, f), c && (u.transform = c(f, u.transform));
      const { x: p, y: g } = this.projectionDelta;
      u.transformOrigin = `${p.origin * 100}% ${g.origin * 100}% 0`, d.animationValues ? u.opacity = d === this ? (l = (o = f.opacity) !== null && o !== void 0 ? o : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : u.opacity = d === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const y in ar) {
        if (f[y] === void 0)
          continue;
        const { correct: b, applyTo: k } = ar[y], w = u.transform === "none" ? f[y] : b(f[y], d);
        if (k) {
          const m = k.length;
          for (let _ = 0; _ < m; _++)
            u[k[_]] = w;
        } else
          u[y] = w;
      }
      return this.options.layoutId && (u.pointerEvents = d === this ? Zn(a == null ? void 0 : a.pointerEvents) || "" : "none"), u;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var o;
        return (o = a.currentAnimation) === null || o === void 0 ? void 0 : o.stop();
      }), this.root.nodes.forEach(Ja), this.root.sharedNodes.clear();
    }
  };
}
function um(n) {
  n.updateLayout();
}
function cm(n) {
  var e;
  const t = ((e = n.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || n.snapshot;
  if (n.isLead() && n.layout && t && n.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: s } = n.layout, { animationType: i } = n.options, a = t.source !== n.layout.source;
    i === "size" ? Qe((d) => {
      const f = a ? t.measuredBox[d] : t.layoutBox[d], p = qe(f);
      f.min = r[d].min, f.max = f.min + p;
    }) : vu(i, t.layoutBox, r) && Qe((d) => {
      const f = a ? t.measuredBox[d] : t.layoutBox[d], p = qe(r[d]);
      f.max = f.min + p, n.relativeTarget && !n.currentAnimation && (n.isProjectionDirty = !0, n.relativeTarget[d].max = n.relativeTarget[d].min + p);
    });
    const o = Xt();
    Mn(o, r, t.layoutBox);
    const l = Xt();
    a ? Mn(l, n.applyTransform(s, !0), t.measuredBox) : Mn(l, r, t.layoutBox);
    const u = !fu(o);
    let c = !1;
    if (!n.resumeFrom) {
      const d = n.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: p } = d;
        if (f && p) {
          const g = Ce();
          Dn(g, t.layoutBox, f.layoutBox);
          const y = Ce();
          Dn(y, r, p.layoutBox), pu(g, y) || (c = !0), d.options.layoutRoot && (n.relativeTarget = y, n.relativeTargetOrigin = g, n.relativeParent = d);
        }
      }
    }
    n.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: l,
      layoutDelta: o,
      hasLayoutChanged: u,
      hasRelativeTargetChanged: c
    });
  } else if (n.isLead()) {
    const { onExitComplete: r } = n.options;
    r && r();
  }
  n.options.transition = void 0;
}
function dm(n) {
  xn && Bt.totalNodes++, n.parent && (n.isProjecting() || (n.isProjectionDirty = n.parent.isProjectionDirty), n.isSharedProjectionDirty || (n.isSharedProjectionDirty = !!(n.isProjectionDirty || n.parent.isProjectionDirty || n.parent.isSharedProjectionDirty)), n.isTransformDirty || (n.isTransformDirty = n.parent.isTransformDirty));
}
function hm(n) {
  n.isProjectionDirty = n.isSharedProjectionDirty = n.isTransformDirty = !1;
}
function fm(n) {
  n.clearSnapshot();
}
function Ja(n) {
  n.clearMeasurements();
}
function pm(n) {
  n.isLayoutDirty = !1;
}
function mm(n) {
  const { visualElement: e } = n.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), n.resetTransform();
}
function eo(n) {
  n.finishAnimation(), n.targetDelta = n.relativeTarget = n.target = void 0, n.isProjectionDirty = !0;
}
function gm(n) {
  n.resolveTargetDelta();
}
function vm(n) {
  n.calcProjection();
}
function ym(n) {
  n.resetSkewAndRotation();
}
function bm(n) {
  n.removeLeadSnapshot();
}
function to(n, e, t) {
  n.translate = ye(e.translate, 0, t), n.scale = ye(e.scale, 1, t), n.origin = e.origin, n.originPoint = e.originPoint;
}
function no(n, e, t, r) {
  n.min = ye(e.min, t.min, r), n.max = ye(e.max, t.max, r);
}
function km(n, e, t, r) {
  no(n.x, e.x, t.x, r), no(n.y, e.y, t.y, r);
}
function wm(n) {
  return n.animationValues && n.animationValues.opacityExit !== void 0;
}
const _m = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, ro = (n) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(n), so = ro("applewebkit/") && !ro("chrome/") ? Math.round : Ye;
function io(n) {
  n.min = so(n.min), n.max = so(n.max);
}
function xm(n) {
  io(n.x), io(n.y);
}
function vu(n, e, t) {
  return n === "position" || n === "preserve-aspect" && !Mp(Xa(e), Xa(t), 0.2);
}
function Tm(n) {
  var e;
  return n !== n.root && ((e = n.scroll) === null || e === void 0 ? void 0 : e.wasRoot);
}
const Cm = gu({
  attachResizeListener: (n, e) => On(n, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Gr = {
  current: void 0
}, yu = gu({
  measureScroll: (n) => ({
    x: n.scrollLeft,
    y: n.scrollTop
  }),
  defaultParent: () => {
    if (!Gr.current) {
      const n = new Cm({});
      n.mount(window), n.setOptions({ layoutScroll: !0 }), Gr.current = n;
    }
    return Gr.current;
  },
  resetTransform: (n, e) => {
    n.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (n) => window.getComputedStyle(n).position === "fixed"
}), Mm = {
  pan: {
    Feature: Yp
  },
  drag: {
    Feature: Wp,
    ProjectionNode: yu,
    MeasureLayout: cu
  }
};
function ao(n, e, t) {
  const { props: r } = n;
  n.animationState && r.whileHover && n.animationState.setActive("whileHover", t === "Start");
  const s = "onHover" + t, i = r[s];
  i && pe.postRender(() => i(e, jn(e)));
}
class Dm extends Rt {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = Ch(e, (t) => (ao(this.node, t, "Start"), (r) => ao(this.node, r, "End"))));
  }
  unmount() {
  }
}
class Em extends Rt {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Ln(On(this.node.current, "focus", () => this.onFocus()), On(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function oo(n, e, t) {
  const { props: r } = n;
  n.animationState && r.whileTap && n.animationState.setActive("whileTap", t === "Start");
  const s = "onTap" + (t === "End" ? "" : t), i = r[s];
  i && pe.postRender(() => i(e, jn(e)));
}
class Am extends Rt {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = Ah(e, (t) => (oo(this.node, t, "Start"), (r, { success: s }) => oo(this.node, r, s ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Ts = /* @__PURE__ */ new WeakMap(), Kr = /* @__PURE__ */ new WeakMap(), Pm = (n) => {
  const e = Ts.get(n.target);
  e && e(n);
}, Sm = (n) => {
  n.forEach(Pm);
};
function Nm({ root: n, ...e }) {
  const t = n || document;
  Kr.has(t) || Kr.set(t, {});
  const r = Kr.get(t), s = JSON.stringify(e);
  return r[s] || (r[s] = new IntersectionObserver(Sm, { root: n, ...e })), r[s];
}
function Om(n, e, t) {
  const r = Nm(e);
  return Ts.set(n, t), r.observe(n), () => {
    Ts.delete(n), r.unobserve(n);
  };
}
const Fm = {
  some: 0,
  all: 1
};
class Rm extends Rt {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: t, margin: r, amount: s = "some", once: i } = e, a = {
      root: t ? t.current : void 0,
      rootMargin: r,
      threshold: typeof s == "number" ? s : Fm[s]
    }, o = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, i && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: d } = this.node.getProps(), f = u ? c : d;
      f && f(l);
    };
    return Om(this.node.current, a, o);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: t } = this.node;
    ["amount", "margin", "root"].some(Im(e, t)) && this.startObserver();
  }
  unmount() {
  }
}
function Im({ viewport: n = {} }, { viewport: e = {} } = {}) {
  return (t) => n[t] !== e[t];
}
const Vm = {
  inView: {
    Feature: Rm
  },
  tap: {
    Feature: Am
  },
  focus: {
    Feature: Em
  },
  hover: {
    Feature: Dm
  }
}, Bm = {
  layout: {
    ProjectionNode: yu,
    MeasureLayout: cu
  }
}, Cs = { current: null }, bu = { current: !1 };
function Lm() {
  if (bu.current = !0, !!Is)
    if (window.matchMedia) {
      const n = window.matchMedia("(prefers-reduced-motion)"), e = () => Cs.current = n.matches;
      n.addListener(e), e();
    } else
      Cs.current = !1;
}
const jm = [...zl, Fe, Ft], Wm = (n) => jm.find($l(n)), lo = /* @__PURE__ */ new WeakMap();
function Ym(n, e, t) {
  for (const r in e) {
    const s = e[r], i = t[r];
    if (Re(s))
      n.addValue(r, s), process.env.NODE_ENV === "development" && wr(s.version === "11.18.2", `Attempting to mix Motion versions ${s.version} with 11.18.2 may not work as expected.`);
    else if (Re(i))
      n.addValue(r, Sn(s, { owner: n }));
    else if (i !== s)
      if (n.hasValue(r)) {
        const a = n.getValue(r);
        a.liveStyle === !0 ? a.jump(s) : a.hasAnimated || a.set(s);
      } else {
        const a = n.getStaticValue(r);
        n.addValue(r, Sn(a !== void 0 ? a : s, { owner: n }));
      }
  }
  for (const r in t)
    e[r] === void 0 && n.removeValue(r);
  return e;
}
const uo = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class $m {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, t, r) {
    return {};
  }
  constructor({ parent: e, props: t, presenceContext: r, reducedMotionConfig: s, blockInitialAnimation: i, visualState: a }, o = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = ui, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = dt.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, pe.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u, onUpdate: c } = a;
    this.onUpdate = c, this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = t.initial ? { ...l } : {}, this.renderState = u, this.parent = e, this.props = t, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = s, this.options = o, this.blockInitialAnimation = !!i, this.isControllingVariants = Tr(t), this.isVariantNode = Zo(t), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: d, ...f } = this.scrapeMotionValuesFromProps(t, {}, this);
    for (const p in f) {
      const g = f[p];
      l[p] !== void 0 && Re(g) && g.set(l[p], !1);
    }
  }
  mount(e) {
    this.current = e, lo.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((t, r) => this.bindToMotionValue(r, t)), bu.current || Lm(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Cs.current, process.env.NODE_ENV !== "production" && wr(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    lo.delete(this.current), this.projection && this.projection.unmount(), Ot(this.notifyUpdate), Ot(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const t = this.features[e];
      t && (t.unmount(), t.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, t) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const r = zt.has(e), s = t.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && pe.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), i = t.on("renderRequest", this.scheduleRender);
    let a;
    window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, e, t)), this.valueSubscriptions.set(e, () => {
      s(), i(), a && a(), t.owner && t.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in sn) {
      const t = sn[e];
      if (!t)
        continue;
      const { isEnabled: r, Feature: s } = t;
      if (!this.features[e] && s && r(this.props) && (this.features[e] = new s(this)), this.features[e]) {
        const i = this.features[e];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Ce();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, t) {
    this.latestValues[e] = t;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, t) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = t;
    for (let r = 0; r < uo.length; r++) {
      const s = uo[r];
      this.propEventSubscriptions[s] && (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
      const i = "on" + s, a = e[i];
      a && (this.propEventSubscriptions[s] = this.on(s, a));
    }
    this.prevMotionValues = Ym(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const t = this.getClosestVariantNode();
    if (t)
      return t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, t) {
    const r = this.values.get(e);
    t !== r && (r && this.removeValue(e), this.bindToMotionValue(e, t), this.values.set(e, t), this.latestValues[e] = t.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const t = this.valueSubscriptions.get(e);
    t && (t(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, t) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let r = this.values.get(e);
    return r === void 0 && t !== void 0 && (r = Sn(t === null ? void 0 : t, { owner: this }), this.addValue(e, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, t) {
    var r;
    let s = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (r = this.getBaseTargetFromProps(this.props, e)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, e, this.options);
    return s != null && (typeof s == "string" && (Wl(s) || Nl(s)) ? s = parseFloat(s) : !Wm(s) && Ft.test(t) && (s = Bl(e, t)), this.setBaseTarget(e, Re(s) ? s.get() : s)), Re(s) ? s.get() : s;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, t) {
    this.baseTarget[e] = t;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var t;
    const { initial: r } = this.props;
    let s;
    if (typeof r == "string" || typeof r == "object") {
      const a = $s(this.props, r, (t = this.presenceContext) === null || t === void 0 ? void 0 : t.custom);
      a && (s = a[e]);
    }
    if (r && s !== void 0)
      return s;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !Re(i) ? i : this.initialValues[e] !== void 0 && s === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, t) {
    return this.events[e] || (this.events[e] = new ri()), this.events[e].add(t);
  }
  notify(e, ...t) {
    this.events[e] && this.events[e].notify(...t);
  }
}
class ku extends $m {
  constructor() {
    super(...arguments), this.KeyframeResolver = Ul;
  }
  sortInstanceNodePosition(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, t) {
    return e.style ? e.style[t] : void 0;
  }
  removeValueFromRenderState(e, { vars: t, style: r }) {
    delete t[e], delete r[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    Re(e) && (this.childSubscription = e.on("change", (t) => {
      this.current && (this.current.textContent = `${t}`);
    }));
  }
}
function zm(n) {
  return window.getComputedStyle(n);
}
class Um extends ku {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = ol;
  }
  readValueFromInstance(e, t) {
    if (zt.has(t)) {
      const r = li(t);
      return r && r.default || 0;
    } else {
      const r = zm(e), s = (sl(t) ? r.getPropertyValue(t) : r[t]) || 0;
      return typeof s == "string" ? s.trim() : s;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: t }) {
    return lu(e, t);
  }
  build(e, t, r) {
    Hs(e, t, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, t, r) {
    return Xs(e, t, r);
  }
}
class Hm extends ku {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Ce;
  }
  getBaseTargetFromProps(e, t) {
    return e[t];
  }
  readValueFromInstance(e, t) {
    if (zt.has(t)) {
      const r = li(t);
      return r && r.default || 0;
    }
    return t = ll.has(t) ? t : js(t), e.getAttribute(t);
  }
  scrapeMotionValuesFromProps(e, t, r) {
    return dl(e, t, r);
  }
  build(e, t, r) {
    qs(e, t, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(e, t, r, s) {
    ul(e, t, r, s);
  }
  mount(e) {
    this.isSVGTag = Ks(e.tagName), super.mount(e);
  }
}
const qm = (n, e) => Ys(n) ? new Hm(e) : new Um(e, {
  allowProjection: n !== gr
}), Gm = /* @__PURE__ */ yh({
  ...vp,
  ...Vm,
  ...Mm,
  ...Bm
}, qm), At = /* @__PURE__ */ Od(Gm);
function Ck({ actions: n, backHref: e, backLabel: t = "Voltar", className: r, onBack: s, subtitle: i, title: a, ...o }) {
  const l = e ? At.a : At.button;
  return /* @__PURE__ */ T("header", { className: S("akuna-detail-header", r), ...o, children: [
    /* @__PURE__ */ h(
      l,
      {
        "aria-label": t,
        className: "akuna-detail-header__pill",
        href: e,
        onClick: s,
        whileTap: { scale: 0.92 },
        ...e ? {} : { type: "button" },
        children: /* @__PURE__ */ h(nn, { icon: Zc, size: 24 })
      }
    ),
    /* @__PURE__ */ T("div", { className: "akuna-detail-header__copy", children: [
      /* @__PURE__ */ h("div", { className: "akuna-detail-header__title", children: a }),
      i ? /* @__PURE__ */ h("div", { className: "akuna-detail-header__subtitle", children: i }) : null
    ] }),
    /* @__PURE__ */ h("div", { className: "akuna-detail-header__actions", children: n ?? /* @__PURE__ */ h("span", { "aria-hidden": "true", className: "akuna-detail-header__pill akuna-detail-header__pill--placeholder", children: /* @__PURE__ */ h(nn, { icon: sd, size: 20 }) }) })
  ] });
}
const Ms = At.create(
  le((n, e) => /* @__PURE__ */ h("div", { ref: e, ...n }))
);
Ms.displayName = "MoreSheetMotionDiv";
const wu = le(
  ({ children: n, ...e }, t) => /* @__PURE__ */ h("div", { ref: t, ...e, children: /* @__PURE__ */ h(Nd, { reducedMotion: "user", children: n }) })
);
wu.displayName = "MoreSheetMotionPortalRoot";
function Km({ accountFooter: n, container: e, items: t, onOpenChange: r, open: s, title: i = "Mais", trigger: a }) {
  const o = (l) => In(l) ? l : (typeof l == "function" || typeof l == "object") && l ? tn(l, {
    "aria-hidden": !0,
    focusable: !1
  }) : null;
  return /* @__PURE__ */ T(Le.Root, { onOpenChange: r, open: s, children: [
    a ? /* @__PURE__ */ h(Le.Trigger, { asChild: !0, children: a }) : null,
    /* @__PURE__ */ h(Cd, { children: s ? /* @__PURE__ */ h(Le.Portal, { container: e ?? void 0, forceMount: !0, children: /* @__PURE__ */ T(wu, { children: [
      /* @__PURE__ */ h(Le.Overlay, { asChild: !0, forceMount: !0, children: /* @__PURE__ */ h(
        Ms,
        {
          animate: { opacity: 1 },
          className: "akuna-more-sheet__scrim",
          exit: { opacity: 0 },
          initial: { opacity: 0 },
          transition: { duration: 0.2, ease: [0.2, 0.8, 0.2, 1] }
        }
      ) }),
      /* @__PURE__ */ h(Le.Content, { "aria-describedby": void 0, asChild: !0, forceMount: !0, children: /* @__PURE__ */ T(
        Ms,
        {
          animate: { y: "0%" },
          className: "akuna-more-sheet",
          exit: { y: "105%" },
          initial: { y: "105%" },
          transition: { duration: 0.32, ease: [0.2, 0.8, 0.2, 1] },
          children: [
            /* @__PURE__ */ h("div", { "aria-hidden": "true", className: "akuna-more-sheet__handle" }),
            /* @__PURE__ */ T("div", { className: "akuna-more-sheet__head", children: [
              /* @__PURE__ */ h(Le.Title, { className: "akuna-more-sheet__title", children: i }),
              /* @__PURE__ */ h(Le.Close, { "aria-label": "Fechar", className: "akuna-more-sheet__close", type: "button", children: /* @__PURE__ */ h(nn, { icon: yr, size: 20 }) })
            ] }),
            /* @__PURE__ */ h("div", { className: "akuna-more-sheet__grid", children: t.map((l) => {
              const u = l.href ? "a" : "button";
              return /* @__PURE__ */ T(
                u,
                {
                  className: "akuna-more-sheet__item",
                  href: l.href,
                  onClick: (c) => {
                    var d;
                    (d = l.onClick) == null || d.call(l, c), (!l.href || c.defaultPrevented) && r(!1);
                  },
                  ...l.href ? {} : { type: "button" },
                  children: [
                    /* @__PURE__ */ h("span", { className: S("akuna-more-sheet__tile", `akuna-more-sheet__tile--${l.tone ?? "default"}`), children: o(l.icon) }),
                    /* @__PURE__ */ h("span", { className: "akuna-more-sheet__label", children: l.label })
                  ]
                },
                l.value
              );
            }) }),
            n ? /* @__PURE__ */ h("div", { className: "akuna-more-sheet__footer", children: n }) : null
          ]
        }
      ) })
    ] }) }) : null })
  ] });
}
function Mk({
  accountFooter: n,
  className: e,
  container: t,
  items: r,
  label: s = "Navegação inferior",
  maxVisible: i = 4,
  moreIcon: a = ld,
  moreItems: o,
  moreLabel: l = "Mais",
  onValueChange: u,
  value: c,
  ...d
}) {
  const [f, p] = Z(!1), g = r.slice(0, i), y = o ?? r, b = y.length > 0, k = y.map((m) => ({
    value: m.value,
    label: m.label,
    icon: m.icon,
    href: m.href,
    onClick: (_) => {
      var v;
      (v = m.onClick) == null || v.call(m, _), u == null || u(m.value);
    }
  })), w = (m) => In(m) ? m : (typeof m == "function" || typeof m == "object") && m ? tn(m, {
    "aria-hidden": !0,
    className: "akuna-glass-nav__icon-svg",
    focusable: !1
  }) : null;
  return /* @__PURE__ */ T(je, { children: [
    /* @__PURE__ */ T("nav", { "aria-label": s, className: S("akuna-glass-nav", e), ...d, children: [
      g.map((m) => {
        const _ = m.value === c && !f, v = m.href ? At.a : At.button;
        return /* @__PURE__ */ T(
          v,
          {
            "aria-current": _ ? "page" : void 0,
            className: "akuna-glass-nav__item",
            href: m.href,
            onClick: (x) => {
              var P;
              (P = m.onClick) == null || P.call(m, x), u == null || u(m.value);
            },
            whileTap: { scale: 0.92 },
            ...m.href ? {} : { type: "button" },
            children: [
              /* @__PURE__ */ T("span", { className: "akuna-glass-nav__disk", "data-active": _ || void 0, children: [
                _ ? /* @__PURE__ */ h(At.span, { className: "akuna-glass-nav__highlight", layoutId: "akuna-glass-nav-disk" }) : null,
                /* @__PURE__ */ h("span", { className: "akuna-glass-nav__icon", children: w(m.icon) })
              ] }),
              /* @__PURE__ */ h("span", { className: "akuna-glass-nav__label", "data-active": _ || void 0, children: m.label })
            ]
          },
          m.value
        );
      }),
      b ? /* @__PURE__ */ T(
        At.button,
        {
          "aria-haspopup": "dialog",
          className: "akuna-glass-nav__item",
          onClick: () => p(!0),
          type: "button",
          whileTap: { scale: 0.92 },
          children: [
            /* @__PURE__ */ T("span", { className: "akuna-glass-nav__disk", "data-active": f || void 0, children: [
              f ? /* @__PURE__ */ h(At.span, { className: "akuna-glass-nav__highlight", layoutId: "akuna-glass-nav-disk" }) : null,
              /* @__PURE__ */ h("span", { className: "akuna-glass-nav__icon", children: w(a) })
            ] }),
            /* @__PURE__ */ h("span", { className: "akuna-glass-nav__label", "data-active": f || void 0, children: l })
          ]
        }
      ) : null
    ] }),
    /* @__PURE__ */ h(
      Km,
      {
        accountFooter: n,
        container: t,
        items: k,
        onOpenChange: p,
        open: f,
        title: l
      }
    )
  ] });
}
function Dk({ actions: n, brand: e, className: t, meta: r, search: s, title: i, ...a }) {
  return /* @__PURE__ */ T("header", { className: S("akuna-mobile-header", t), ...a, children: [
    e || n ? /* @__PURE__ */ T("div", { className: "akuna-mobile-header__top", children: [
      /* @__PURE__ */ h("div", { className: "akuna-mobile-header__brand", children: e }),
      n ? /* @__PURE__ */ h("div", { className: "akuna-mobile-header__actions", children: n }) : null
    ] }) : null,
    i ? /* @__PURE__ */ h("h1", { className: "akuna-mobile-header__title", children: i }) : null,
    r ? /* @__PURE__ */ h("div", { className: "akuna-mobile-header__meta", children: r }) : null,
    s ? /* @__PURE__ */ h("div", { className: "akuna-mobile-header__search", children: s }) : null
  ] });
}
function Ek({
  className: n,
  defaultValue: e,
  fill: t = "fit",
  items: r,
  label: s,
  onValueChange: i,
  scrollable: a = !1,
  value: o,
  variant: l = "primary",
  width: u = "fit"
}) {
  var _, v;
  const c = r.filter((x) => x.content != null), d = Ie([]), f = Ie(null), [p, g] = Z(), [y, b] = Z(e ?? ((_ = r[0]) == null ? void 0 : _.value)), k = o ?? y, w = Pt(
    (x) => {
      b(x), i == null || i(x);
    },
    [i]
  );
  rr(() => {
    if (u !== "equal") {
      g(void 0);
      return;
    }
    const x = d.current.map((P) => (P == null ? void 0 : P.getBoundingClientRect().width) ?? 0);
    g(Math.max(0, ...x));
  }, [u, r.map((x) => x.value).join("|"), r.map((x) => x.label).join("|")]), rr(() => {
    var ue;
    const x = f.current;
    if (!x) return;
    const P = () => {
      if (x.scrollWidth <= x.clientWidth) return;
      const ae = x.querySelector('[data-state="active"]');
      if (!ae) return;
      const $ = x.scrollLeft + ae.getBoundingClientRect().left - x.getBoundingClientRect().left, Te = 12, ke = x.scrollWidth - x.clientWidth;
      let Se = x.scrollLeft;
      if ($ - Te < x.scrollLeft)
        Se = $ - Te;
      else if ($ + ae.offsetWidth + Te > x.scrollLeft + x.clientWidth)
        Se = $ + ae.offsetWidth + Te - x.clientWidth;
      else
        return;
      x.scrollLeft = Math.max(0, Math.min(Se, ke));
    };
    P();
    const R = requestAnimationFrame(P), B = typeof ResizeObserver > "u" ? null : new ResizeObserver(P);
    B == null || B.observe(x);
    for (const ae of Array.from(x.children)) B == null || B.observe(ae);
    return (ue = document.fonts) == null || ue.ready.then(P), () => {
      cancelAnimationFrame(R), B == null || B.disconnect();
    };
  }, [k]);
  const m = p ? { "--akuna-seg-tab-min-width": `${p}px` } : void 0;
  return /* @__PURE__ */ T(
    Hn.Root,
    {
      className: S(
        "akuna-seg-tabs",
        a && "akuna-seg-tabs--scrollable",
        a === "mobile" && "akuna-seg-tabs--scrollable-mobile",
        n
      ),
      "data-fill": t,
      "data-variant": l,
      "data-width": u,
      defaultValue: e ?? ((v = r[0]) == null ? void 0 : v.value),
      onValueChange: w,
      style: m,
      value: o,
      children: [
        /* @__PURE__ */ h(Hn.List, { "aria-label": s, className: "akuna-seg-tabs__list", ref: f, children: r.map((x, P) => /* @__PURE__ */ T(
          Hn.Trigger,
          {
            className: "akuna-seg-tabs__trigger",
            ref: (R) => {
              d.current[P] = R;
            },
            value: x.value,
            children: [
              x.icon ? /* @__PURE__ */ h(nn, { icon: x.icon, size: 20 }) : null,
              /* @__PURE__ */ h("span", { children: x.label })
            ]
          },
          x.value
        )) }),
        c.map((x) => /* @__PURE__ */ h(Hn.Content, { className: "akuna-seg-tabs__panel", forceMount: !0, value: x.value, children: x.content }, x.value))
      ]
    }
  );
}
const _u = le(({ checked: n, className: e, defaultChecked: t, label: r, onCheckedChange: s, ...i }, a) => {
  const [o, l] = Z(t ?? !1), u = n ?? o;
  return /* @__PURE__ */ T("label", { className: S("akuna-choice", e), children: [
    /* @__PURE__ */ h(
      "input",
      {
        ref: a,
        checked: u,
        className: "akuna-choice__native",
        onChange: (c) => {
          l(c.currentTarget.checked), s == null || s(c.currentTarget.checked);
        },
        type: "checkbox",
        ...i
      }
    ),
    /* @__PURE__ */ h("span", { "aria-hidden": "true", className: "akuna-choice__box", children: /* @__PURE__ */ h(vr, { size: 14 }) }),
    r ? /* @__PURE__ */ h("span", { className: "akuna-choice__label", children: r }) : null
  ] });
});
_u.displayName = "Checkbox";
const kn = (n) => !!n && /^#[0-9a-f]{6}$/i.test(n);
function Ak({
  value: n,
  onChange: e,
  label: t,
  options: r,
  customLabel: s = `${t} — custom`,
  className: i
}) {
  const a = kn(n) ? { backgroundColor: n } : void 0;
  return /* @__PURE__ */ T("div", { role: "radiogroup", "aria-label": t, className: S("flex flex-wrap items-center gap-2", i), children: [
    r.map((o) => /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        role: "radio",
        "aria-checked": n === o.value,
        "aria-label": o.value,
        onClick: () => e(o.value),
        className: S(
          "h-6 w-6 rounded-full transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          o.className,
          n === o.value ? "ring-2 ring-foreground/60 ring-offset-2 ring-offset-card" : "hover:scale-110"
        )
      },
      o.value
    )),
    /* @__PURE__ */ T(
      "div",
      {
        role: "radio",
        "aria-checked": kn(n),
        "aria-label": `${s} option`,
        className: S(
          "relative flex h-6 w-6 items-center justify-center rounded-full bg-muted text-muted-foreground transition-transform",
          kn(n) ? "ring-2 ring-foreground/60 ring-offset-2 ring-offset-card" : "hover:scale-110"
        ),
        style: a,
        children: [
          kn(n) ? null : /* @__PURE__ */ h(ud, { className: "h-3.5 w-3.5", "aria-hidden": "true" }),
          /* @__PURE__ */ h(
            "input",
            {
              type: "color",
              value: kn(n) ? n : "#f97316",
              onChange: (o) => e(o.target.value),
              className: "absolute inset-0 h-full w-full cursor-pointer opacity-0",
              "aria-label": s
            }
          )
        ]
      }
    )
  ] });
}
const Wn = ze(null), on = le(({ className: n, id: e, invalid: t, ...r }, s) => {
  const i = Tt(), a = e ?? `akuna-field-${i}`, o = `${a}-description`, l = `${a}-error`;
  return /* @__PURE__ */ h(Wn.Provider, { value: { controlId: a, descriptionId: o, errorId: l, invalid: t }, children: /* @__PURE__ */ h("div", { ref: s, className: S("akuna-field", n), "data-invalid": t || void 0, ...r }) });
});
on.displayName = "Field";
const ln = le(({ className: n, htmlFor: e, ...t }, r) => {
  const s = ce(Wn);
  return /* @__PURE__ */ h("label", { ref: r, className: S("akuna-field__label", n), htmlFor: e ?? (s == null ? void 0 : s.controlId), ...t });
});
ln.displayName = "FieldLabel";
const Xm = le(({ className: n, id: e, ...t }, r) => {
  const s = ce(Wn);
  return /* @__PURE__ */ h("p", { ref: r, className: S("akuna-field__description", n), id: e ?? (s == null ? void 0 : s.descriptionId), ...t });
});
Xm.displayName = "FieldDescription";
const Qm = le(({ className: n, id: e, ...t }, r) => {
  const s = ce(Wn);
  return /* @__PURE__ */ h("p", { ref: r, className: S("akuna-field__error", n), id: e ?? (s == null ? void 0 : s.errorId), role: "alert", ...t });
});
Qm.displayName = "FieldError";
function Zm(...n) {
  return n.flatMap((e) => (e == null ? void 0 : e.split(" ")) ?? []).filter(Boolean).join(" ");
}
function Dr(n) {
  const e = ce(Wn), t = n.invalid || n["aria-invalid"] === !0 || n["aria-invalid"] === "true" || (e == null ? void 0 : e.invalid);
  return {
    "aria-describedby": Zm(n["aria-describedby"], e == null ? void 0 : e.descriptionId, t ? e == null ? void 0 : e.errorId : void 0) || void 0,
    "aria-invalid": t ? !0 : void 0,
    id: n.id ?? (e == null ? void 0 : e.controlId)
  };
}
const Er = le(({ className: n, filled: e, inputSize: t = "md", invalid: r, ...s }, i) => {
  const a = Dr({
    "aria-describedby": s["aria-describedby"],
    "aria-invalid": s["aria-invalid"],
    id: s.id,
    invalid: r
  });
  return /* @__PURE__ */ h(
    "input",
    {
      ref: i,
      className: S(
        "akuna-control akuna-input",
        t === "sm" && "akuna-input--sm",
        e && "akuna-input--filled",
        n
      ),
      ...s,
      ...a
    }
  );
});
Er.displayName = "Input";
function Jm(n, e) {
  const t = n.toLowerCase(), r = e.toLowerCase().trim().split(/\s+/).filter(Boolean);
  return r.length === 0 ? !0 : r.every((s) => t.includes(s));
}
function Pk({
  className: n,
  label: e,
  value: t,
  onValueChange: r,
  onSelect: s,
  options: i,
  placeholder: a,
  emptyMessage: o = "Nenhum resultado encontrado.",
  disabled: l,
  renderOption: u,
  selectedValue: c,
  disableLocalFilter: d
}) {
  const p = `akuna-combobox-${Tt()}`, g = `${p}-list`, [y, b] = Z(!1), [k, w] = Z(0), m = He(() => d || t.trim() === "" ? i : i.filter((x) => Jm(x.label, t)), [i, t, d]), _ = (x) => {
    x.disabled || (r(x.label), s == null || s(x), b(!1));
  }, v = (x) => {
    if (x.key === "Escape") {
      b(!1);
      return;
    }
    x.key === "ArrowDown" ? (x.preventDefault(), b(!0), w((P) => Math.min(P + 1, m.length - 1))) : x.key === "ArrowUp" ? (x.preventDefault(), w((P) => Math.max(P - 1, 0))) : x.key === "Enter" && y && m[k] && (x.preventDefault(), _(m[k]));
  };
  return /* @__PURE__ */ T(on, { id: p, className: n, children: [
    /* @__PURE__ */ h(ln, { children: e }),
    /* @__PURE__ */ T("div", { className: "akuna-combobox", children: [
      /* @__PURE__ */ h(
        Er,
        {
          id: p,
          role: "combobox",
          "aria-controls": g,
          "aria-expanded": y,
          "aria-autocomplete": "list",
          "aria-activedescendant": y && m[k] ? `${g}-${m[k].value}` : void 0,
          autoComplete: "off",
          disabled: l,
          placeholder: a,
          value: t,
          onFocus: () => b(!0),
          onBlur: () => window.setTimeout(() => b(!1), 120),
          onKeyDown: v,
          onChange: (x) => {
            r(x.currentTarget.value), b(!0), w(0);
          }
        }
      ),
      y ? /* @__PURE__ */ h("div", { id: g, role: "listbox", className: "akuna-combobox__list", children: m.length === 0 ? /* @__PURE__ */ h("div", { className: "akuna-combobox__empty", children: o }) : m.map((x, P) => {
        const R = (c ?? "") === x.value;
        return /* @__PURE__ */ h(
          "button",
          {
            id: `${g}-${x.value}`,
            type: "button",
            role: "option",
            "aria-selected": R,
            disabled: x.disabled,
            className: S("akuna-combobox__option", P === k && "akuna-combobox__option--active"),
            onMouseDown: (B) => B.preventDefault(),
            onMouseEnter: () => w(P),
            onClick: () => _(x),
            children: u ? u(x, R) : /* @__PURE__ */ T(je, { children: [
              /* @__PURE__ */ h(
                vr,
                {
                  "aria-hidden": !0,
                  size: 16,
                  className: S("akuna-combobox__check", !R && "akuna-combobox__check--hidden")
                }
              ),
              /* @__PURE__ */ h("span", { children: x.label })
            ] })
          },
          x.value
        );
      }) }) : null
    ] })
  ] });
}
function K(n) {
  const e = Object.prototype.toString.call(n);
  return n instanceof Date || typeof n == "object" && e === "[object Date]" ? new n.constructor(+n) : typeof n == "number" || e === "[object Number]" || typeof n == "string" || e === "[object String]" ? new Date(n) : /* @__PURE__ */ new Date(NaN);
}
function de(n, e) {
  return n instanceof Date ? new n.constructor(e) : new Date(e);
}
function Oe(n, e) {
  const t = K(n);
  return isNaN(e) ? de(n, NaN) : (e && t.setDate(t.getDate() + e), t);
}
function et(n, e) {
  const t = K(n);
  if (isNaN(e)) return de(n, NaN);
  if (!e)
    return t;
  const r = t.getDate(), s = de(n, t.getTime());
  s.setMonth(t.getMonth() + e + 1, 0);
  const i = s.getDate();
  return r >= i ? s : (t.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    r
  ), t);
}
const fi = 6048e5, eg = 864e5, tg = 6e4, ng = 36e5, rg = 1e3;
let sg = {};
function Ut() {
  return sg;
}
function Ge(n, e) {
  var o, l, u, c;
  const t = Ut(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = K(n), i = s.getDay(), a = (i < r ? 7 : 0) + i - r;
  return s.setDate(s.getDate() - a), s.setHours(0, 0, 0, 0), s;
}
function wt(n) {
  return Ge(n, { weekStartsOn: 1 });
}
function xu(n) {
  const e = K(n), t = e.getFullYear(), r = de(n, 0);
  r.setFullYear(t + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const s = wt(r), i = de(n, 0);
  i.setFullYear(t, 0, 4), i.setHours(0, 0, 0, 0);
  const a = wt(i);
  return e.getTime() >= s.getTime() ? t + 1 : e.getTime() >= a.getTime() ? t : t - 1;
}
function un(n) {
  const e = K(n);
  return e.setHours(0, 0, 0, 0), e;
}
function cn(n) {
  const e = K(n), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +n - +t;
}
function ot(n, e) {
  const t = un(n), r = un(e), s = +t - cn(t), i = +r - cn(r);
  return Math.round((s - i) / eg);
}
function ig(n) {
  const e = xu(n), t = de(n, 0);
  return t.setFullYear(e, 0, 4), t.setHours(0, 0, 0, 0), wt(t);
}
function Ds(n, e) {
  const t = e * 7;
  return Oe(n, t);
}
function ag(n, e) {
  return et(n, e * 12);
}
function og(n) {
  let e;
  return n.forEach(function(t) {
    const r = K(t);
    (e === void 0 || e < r || isNaN(Number(r))) && (e = r);
  }), e || /* @__PURE__ */ new Date(NaN);
}
function lg(n) {
  let e;
  return n.forEach((t) => {
    const r = K(t);
    (!e || e > r || isNaN(+r)) && (e = r);
  }), e || /* @__PURE__ */ new Date(NaN);
}
function We(n, e) {
  const t = un(n), r = un(e);
  return +t == +r;
}
function pi(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function ug(n) {
  if (!pi(n) && typeof n != "number")
    return !1;
  const e = K(n);
  return !isNaN(Number(e));
}
function Fn(n, e) {
  const t = K(n), r = K(e), s = t.getFullYear() - r.getFullYear(), i = t.getMonth() - r.getMonth();
  return s * 12 + i;
}
function cg(n, e, t) {
  const r = Ge(n, t), s = Ge(e, t), i = +r - cn(r), a = +s - cn(s);
  return Math.round((i - a) / fi);
}
function mi(n) {
  const e = K(n), t = e.getMonth();
  return e.setFullYear(e.getFullYear(), t + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function $e(n) {
  const e = K(n);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function Tu(n) {
  const e = K(n), t = de(n, 0);
  return t.setFullYear(e.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function gi(n, e) {
  var o, l, u, c;
  const t = Ut(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = K(n), i = s.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return s.setDate(s.getDate() + a), s.setHours(23, 59, 59, 999), s;
}
function Cu(n) {
  return gi(n, { weekStartsOn: 1 });
}
const dg = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, hg = (n, e, t) => {
  let r;
  const s = dg[n];
  return typeof s == "string" ? r = s : e === 1 ? r = s.one : r = s.other.replace("{{count}}", e.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function en(n) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
const fg = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, pg = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, mg = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gg = {
  date: en({
    formats: fg,
    defaultWidth: "full"
  }),
  time: en({
    formats: pg,
    defaultWidth: "full"
  }),
  dateTime: en({
    formats: mg,
    defaultWidth: "full"
  })
}, vg = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, yg = (n, e, t, r) => vg[n];
function rt(n) {
  return (e, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (r === "formatting" && n.formattingValues) {
      const a = n.defaultFormattingWidth || n.defaultWidth, o = t != null && t.width ? String(t.width) : a;
      s = n.formattingValues[o] || n.formattingValues[a];
    } else {
      const a = n.defaultWidth, o = t != null && t.width ? String(t.width) : n.defaultWidth;
      s = n.values[o] || n.values[a];
    }
    const i = n.argumentCallback ? n.argumentCallback(e) : e;
    return s[i];
  };
}
const bg = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, kg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, wg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, _g = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, xg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Tg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Cg = (n, e) => {
  const t = Number(n), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Mg = {
  ordinalNumber: Cg,
  era: rt({
    values: bg,
    defaultWidth: "wide"
  }),
  quarter: rt({
    values: kg,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: rt({
    values: wg,
    defaultWidth: "wide"
  }),
  day: rt({
    values: _g,
    defaultWidth: "wide"
  }),
  dayPeriod: rt({
    values: xg,
    defaultWidth: "wide",
    formattingValues: Tg,
    defaultFormattingWidth: "wide"
  })
};
function st(n) {
  return (e, t = {}) => {
    const r = t.width, s = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], i = e.match(s);
    if (!i)
      return null;
    const a = i[0], o = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], l = Array.isArray(o) ? Eg(o, (d) => d.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Dg(o, (d) => d.test(a))
    );
    let u;
    u = n.valueCallback ? n.valueCallback(l) : l, u = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = e.slice(a.length);
    return { value: u, rest: c };
  };
}
function Dg(n, e) {
  for (const t in n)
    if (Object.prototype.hasOwnProperty.call(n, t) && e(n[t]))
      return t;
}
function Eg(n, e) {
  for (let t = 0; t < n.length; t++)
    if (e(n[t]))
      return t;
}
function Mu(n) {
  return (e, t = {}) => {
    const r = e.match(n.matchPattern);
    if (!r) return null;
    const s = r[0], i = e.match(n.parsePattern);
    if (!i) return null;
    let a = n.valueCallback ? n.valueCallback(i[0]) : i[0];
    a = t.valueCallback ? t.valueCallback(a) : a;
    const o = e.slice(s.length);
    return { value: a, rest: o };
  };
}
const Ag = /^(\d+)(th|st|nd|rd)?/i, Pg = /\d+/i, Sg = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ng = {
  any: [/^b/i, /^(a|c)/i]
}, Og = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Fg = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Rg = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ig = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Vg = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Bg = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Lg = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, jg = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Wg = {
  ordinalNumber: Mu({
    matchPattern: Ag,
    parsePattern: Pg,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: st({
    matchPatterns: Sg,
    defaultMatchWidth: "wide",
    parsePatterns: Ng,
    defaultParseWidth: "any"
  }),
  quarter: st({
    matchPatterns: Og,
    defaultMatchWidth: "wide",
    parsePatterns: Fg,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: st({
    matchPatterns: Rg,
    defaultMatchWidth: "wide",
    parsePatterns: Ig,
    defaultParseWidth: "any"
  }),
  day: st({
    matchPatterns: Vg,
    defaultMatchWidth: "wide",
    parsePatterns: Bg,
    defaultParseWidth: "any"
  }),
  dayPeriod: st({
    matchPatterns: Lg,
    defaultMatchWidth: "any",
    parsePatterns: jg,
    defaultParseWidth: "any"
  })
}, vi = {
  code: "en-US",
  formatDistance: hg,
  formatLong: gg,
  formatRelative: yg,
  localize: Mg,
  match: Wg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Yg(n) {
  const e = K(n);
  return ot(e, Tu(e)) + 1;
}
function yi(n) {
  const e = K(n), t = +wt(e) - +ig(e);
  return Math.round(t / fi) + 1;
}
function bi(n, e) {
  var c, d, f, p;
  const t = K(n), r = t.getFullYear(), s = Ut(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((p = (f = s.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = de(n, 0);
  a.setFullYear(r + 1, 0, i), a.setHours(0, 0, 0, 0);
  const o = Ge(a, e), l = de(n, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const u = Ge(l, e);
  return t.getTime() >= o.getTime() ? r + 1 : t.getTime() >= u.getTime() ? r : r - 1;
}
function $g(n, e) {
  var o, l, u, c;
  const t = Ut(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = bi(n, e), i = de(n, 0);
  return i.setFullYear(s, 0, r), i.setHours(0, 0, 0, 0), Ge(i, e);
}
function ki(n, e) {
  const t = K(n), r = +Ge(t, e) - +$g(t, e);
  return Math.round(r / fi) + 1;
}
function oe(n, e) {
  const t = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(e, "0");
  return t + r;
}
const Dt = {
  // Year
  y(n, e) {
    const t = n.getFullYear(), r = t > 0 ? t : 1 - t;
    return oe(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(n, e) {
    const t = n.getMonth();
    return e === "M" ? String(t + 1) : oe(t + 1, 2);
  },
  // Day of the month
  d(n, e) {
    return oe(n.getDate(), e.length);
  },
  // AM or PM
  a(n, e) {
    const t = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, e) {
    return oe(n.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(n, e) {
    return oe(n.getHours(), e.length);
  },
  // Minute
  m(n, e) {
    return oe(n.getMinutes(), e.length);
  },
  // Second
  s(n, e) {
    return oe(n.getSeconds(), e.length);
  },
  // Fraction of second
  S(n, e) {
    const t = e.length, r = n.getMilliseconds(), s = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return oe(s, e.length);
  }
}, qt = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, co = {
  // Era
  G: function(n, e, t) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, e, t) {
    if (e === "yo") {
      const r = n.getFullYear(), s = r > 0 ? r : 1 - r;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return Dt.y(n, e);
  },
  // Local week-numbering year
  Y: function(n, e, t, r) {
    const s = bi(n, r), i = s > 0 ? s : 1 - s;
    if (e === "YY") {
      const a = i % 100;
      return oe(a, 2);
    }
    return e === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : oe(i, e.length);
  },
  // ISO week-numbering year
  R: function(n, e) {
    const t = xu(n);
    return oe(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, e) {
    const t = n.getFullYear();
    return oe(t, e.length);
  },
  // Quarter
  Q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(r);
      case "QQ":
        return oe(r, 2);
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(r);
      case "qq":
        return oe(r, 2);
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Dt.M(n, e);
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "L":
        return String(r + 1);
      case "LL":
        return oe(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, e, t, r) {
    const s = ki(n, r);
    return e === "wo" ? t.ordinalNumber(s, { unit: "week" }) : oe(s, e.length);
  },
  // ISO week of year
  I: function(n, e, t) {
    const r = yi(n);
    return e === "Io" ? t.ordinalNumber(r, { unit: "week" }) : oe(r, e.length);
  },
  // Day of the month
  d: function(n, e, t) {
    return e === "do" ? t.ordinalNumber(n.getDate(), { unit: "date" }) : Dt.d(n, e);
  },
  // Day of year
  D: function(n, e, t) {
    const r = Yg(n);
    return e === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : oe(r, e.length);
  },
  // Day of week
  E: function(n, e, t) {
    const r = n.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, e, t, r) {
    const s = n.getDay(), i = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(i);
      case "ee":
        return oe(i, 2);
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, e, t, r) {
    const s = n.getDay(), i = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(i);
      case "cc":
        return oe(i, e.length);
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, e, t) {
    const r = n.getDay(), s = r === 0 ? 7 : r;
    switch (e) {
      case "i":
        return String(s);
      case "ii":
        return oe(s, e.length);
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, e, t) {
    const s = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, e, t) {
    const r = n.getHours();
    let s;
    switch (r === 12 ? s = qt.noon : r === 0 ? s = qt.midnight : s = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, e, t) {
    const r = n.getHours();
    let s;
    switch (r >= 17 ? s = qt.evening : r >= 12 ? s = qt.afternoon : r >= 4 ? s = qt.morning : s = qt.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, e, t) {
    if (e === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return Dt.h(n, e);
  },
  // Hour [0-23]
  H: function(n, e, t) {
    return e === "Ho" ? t.ordinalNumber(n.getHours(), { unit: "hour" }) : Dt.H(n, e);
  },
  // Hour [0-11]
  K: function(n, e, t) {
    const r = n.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : oe(r, e.length);
  },
  // Hour [1-24]
  k: function(n, e, t) {
    let r = n.getHours();
    return r === 0 && (r = 24), e === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : oe(r, e.length);
  },
  // Minute
  m: function(n, e, t) {
    return e === "mo" ? t.ordinalNumber(n.getMinutes(), { unit: "minute" }) : Dt.m(n, e);
  },
  // Second
  s: function(n, e, t) {
    return e === "so" ? t.ordinalNumber(n.getSeconds(), { unit: "second" }) : Dt.s(n, e);
  },
  // Fraction of second
  S: function(n, e) {
    return Dt.S(n, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, e, t) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      case "X":
        return fo(r);
      case "XXXX":
      case "XX":
        return Lt(r);
      case "XXXXX":
      case "XXX":
      default:
        return Lt(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "x":
        return fo(r);
      case "xxxx":
      case "xx":
        return Lt(r);
      case "xxxxx":
      case "xxx":
      default:
        return Lt(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ho(r, ":");
      case "OOOO":
      default:
        return "GMT" + Lt(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ho(r, ":");
      case "zzzz":
      default:
        return "GMT" + Lt(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, e, t) {
    const r = Math.trunc(n.getTime() / 1e3);
    return oe(r, e.length);
  },
  // Milliseconds timestamp
  T: function(n, e, t) {
    const r = n.getTime();
    return oe(r, e.length);
  }
};
function ho(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), s = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? t + String(s) : t + String(s) + e + oe(i, 2);
}
function fo(n, e) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + oe(Math.abs(n) / 60, 2) : Lt(n, e);
}
function Lt(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), s = oe(Math.trunc(r / 60), 2), i = oe(r % 60, 2);
  return t + s + e + i;
}
const po = (n, e) => {
  switch (n) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Du = (n, e) => {
  switch (n) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, zg = (n, e) => {
  const t = n.match(/(P+)(p+)?/) || [], r = t[1], s = t[2];
  if (!s)
    return po(n, e);
  let i;
  switch (r) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", po(r, e)).replace("{{time}}", Du(s, e));
}, Es = {
  p: Du,
  P: zg
}, Ug = /^D+$/, Hg = /^Y+$/, qg = ["D", "DD", "YY", "YYYY"];
function Eu(n) {
  return Ug.test(n);
}
function Au(n) {
  return Hg.test(n);
}
function As(n, e, t) {
  const r = Gg(n, e, t);
  if (console.warn(r), qg.includes(n)) throw new RangeError(r);
}
function Gg(n, e, t) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${e}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Kg = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Xg = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Qg = /^'([^]*?)'?$/, Zg = /''/g, Jg = /[a-zA-Z]/;
function _t(n, e, t) {
  var c, d, f, p, g, y, b, k;
  const r = Ut(), s = (t == null ? void 0 : t.locale) ?? r.locale ?? vi, i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((p = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = (t == null ? void 0 : t.weekStartsOn) ?? ((y = (g = t == null ? void 0 : t.locale) == null ? void 0 : g.options) == null ? void 0 : y.weekStartsOn) ?? r.weekStartsOn ?? ((k = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : k.weekStartsOn) ?? 0, o = K(n);
  if (!ug(o))
    throw new RangeError("Invalid time value");
  let l = e.match(Xg).map((w) => {
    const m = w[0];
    if (m === "p" || m === "P") {
      const _ = Es[m];
      return _(w, s.formatLong);
    }
    return w;
  }).join("").match(Kg).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const m = w[0];
    if (m === "'")
      return { isToken: !1, value: ev(w) };
    if (co[m])
      return { isToken: !0, value: w };
    if (m.match(Jg))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + m + "`"
      );
    return { isToken: !1, value: w };
  });
  s.localize.preprocessor && (l = s.localize.preprocessor(o, l));
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: s
  };
  return l.map((w) => {
    if (!w.isToken) return w.value;
    const m = w.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Au(m) || !(t != null && t.useAdditionalDayOfYearTokens) && Eu(m)) && As(m, e, String(n));
    const _ = co[m[0]];
    return _(o, m, s.localize, u);
  }).join("");
}
function ev(n) {
  const e = n.match(Qg);
  return e ? e[1].replace(Zg, "'") : n;
}
function tv(n) {
  const e = K(n), t = e.getFullYear(), r = e.getMonth(), s = de(n, 0);
  return s.setFullYear(t, r + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function nv() {
  return Object.assign({}, Ut());
}
function rv(n) {
  let t = K(n).getDay();
  return t === 0 && (t = 7), t;
}
function sv(n) {
  return Math.trunc(+K(n) / 1e3);
}
function iv(n) {
  const e = K(n), t = e.getMonth();
  return e.setFullYear(e.getFullYear(), t + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function av(n, e) {
  return cg(
    iv(n),
    $e(n),
    e
  ) + 1;
}
function Ps(n, e) {
  const t = K(n), r = K(e);
  return t.getTime() > r.getTime();
}
function Pu(n, e) {
  const t = K(n), r = K(e);
  return +t < +r;
}
function ov(n, e) {
  const t = e instanceof Date ? de(e, 0) : new e(0);
  return t.setFullYear(
    n.getFullYear(),
    n.getMonth(),
    n.getDate()
  ), t.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), t;
}
const lv = 10;
class Su {
  constructor() {
    F(this, "subPriority", 0);
  }
  validate(e, t) {
    return !0;
  }
}
class uv extends Su {
  constructor(e, t, r, s, i) {
    super(), this.value = e, this.validateValue = t, this.setValue = r, this.priority = s, i && (this.subPriority = i);
  }
  validate(e, t) {
    return this.validateValue(e, this.value, t);
  }
  set(e, t, r) {
    return this.setValue(e, t, this.value, r);
  }
}
class cv extends Su {
  constructor() {
    super(...arguments);
    F(this, "priority", lv);
    F(this, "subPriority", -1);
  }
  set(t, r) {
    return r.timestampIsSet ? t : de(t, ov(t, Date));
  }
}
class ne {
  run(e, t, r, s) {
    const i = this.parse(e, t, r, s);
    return i ? {
      setter: new uv(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(e, t, r) {
    return !0;
  }
}
class dv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 140);
    F(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
      case "GGGGG":
        return s.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return s.era(t, { width: "wide" }) || s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
    }
  }
  set(t, r, s) {
    return r.era = s, t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const Me = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, it = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function De(n, e) {
  return n && {
    value: e(n.value),
    rest: n.rest
  };
}
function be(n, e) {
  const t = e.match(n);
  return t ? {
    value: parseInt(t[0], 10),
    rest: e.slice(t[0].length)
  } : null;
}
function at(n, e) {
  const t = e.match(n);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, s = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, a = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (s * ng + i * tg + a * rg),
    rest: e.slice(t[0].length)
  };
}
function Nu(n) {
  return be(Me.anyDigitsSigned, n);
}
function xe(n, e) {
  switch (n) {
    case 1:
      return be(Me.singleDigit, e);
    case 2:
      return be(Me.twoDigits, e);
    case 3:
      return be(Me.threeDigits, e);
    case 4:
      return be(Me.fourDigits, e);
    default:
      return be(new RegExp("^\\d{1," + n + "}"), e);
  }
}
function hr(n, e) {
  switch (n) {
    case 1:
      return be(Me.singleDigitSigned, e);
    case 2:
      return be(Me.twoDigitsSigned, e);
    case 3:
      return be(Me.threeDigitsSigned, e);
    case 4:
      return be(Me.fourDigitsSigned, e);
    default:
      return be(new RegExp("^-?\\d{1," + n + "}"), e);
  }
}
function wi(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Ou(n, e) {
  const t = e > 0, r = t ? e : 1 - e;
  let s;
  if (r <= 50)
    s = n || 100;
  else {
    const i = r + 50, a = Math.trunc(i / 100) * 100, o = n >= i % 100;
    s = n + a - (o ? 100 : 0);
  }
  return t ? s : 1 - s;
}
function Fu(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class hv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 130);
    F(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, s) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return De(xe(4, t), i);
      case "yo":
        return De(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return De(xe(r.length, t), i);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, s) {
    const i = t.getFullYear();
    if (s.isTwoDigitYear) {
      const o = Ou(
        s.year,
        i
      );
      return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const a = !("era" in r) || r.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class fv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 130);
    F(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return De(xe(4, t), i);
      case "Yo":
        return De(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return De(xe(r.length, t), i);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, s, i) {
    const a = bi(t, i);
    if (s.isTwoDigitYear) {
      const l = Ou(
        s.year,
        a
      );
      return t.setFullYear(
        l,
        0,
        i.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), Ge(t, i);
    }
    const o = !("era" in r) || r.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(o, 0, i.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Ge(t, i);
  }
}
class pv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 130);
    F(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r) {
    return hr(r === "R" ? 4 : r.length, t);
  }
  set(t, r, s) {
    const i = de(t, 0);
    return i.setFullYear(s, 0, 4), i.setHours(0, 0, 0, 0), wt(i);
  }
}
class mv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 130);
    F(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return hr(r === "u" ? 4 : r.length, t);
  }
  set(t, r, s) {
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class gv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 120);
    F(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "Q":
      case "QQ":
        return xe(r.length, t);
      case "Qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class vv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 120);
    F(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "q":
      case "qq":
        return xe(r.length, t);
      case "qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class yv extends ne {
  constructor() {
    super(...arguments);
    F(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    F(this, "priority", 110);
  }
  parse(t, r, s) {
    const i = (a) => a - 1;
    switch (r) {
      case "M":
        return De(
          be(Me.month, t),
          i
        );
      case "MM":
        return De(xe(2, t), i);
      case "Mo":
        return De(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return s.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return s.month(t, { width: "wide", context: "formatting" }) || s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class bv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 110);
    F(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const i = (a) => a - 1;
    switch (r) {
      case "L":
        return De(
          be(Me.month, t),
          i
        );
      case "LL":
        return De(xe(2, t), i);
      case "Lo":
        return De(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return s.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return s.month(t, { width: "wide", context: "standalone" }) || s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function kv(n, e, t) {
  const r = K(n), s = ki(r, t) - e;
  return r.setDate(r.getDate() - s * 7), r;
}
class wv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 100);
    F(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "w":
        return be(Me.week, t);
      case "wo":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, s, i) {
    return Ge(kv(t, s, i), i);
  }
}
function _v(n, e) {
  const t = K(n), r = yi(t) - e;
  return t.setDate(t.getDate() - r * 7), t;
}
class xv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 100);
    F(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "I":
        return be(Me.week, t);
      case "Io":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, s) {
    return wt(_v(t, s));
  }
}
const Tv = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Cv = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Mv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 90);
    F(this, "subPriority", 1);
    F(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "d":
        return be(Me.date, t);
      case "do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    const s = t.getFullYear(), i = Fu(s), a = t.getMonth();
    return i ? r >= 1 && r <= Cv[a] : r >= 1 && r <= Tv[a];
  }
  set(t, r, s) {
    return t.setDate(s), t.setHours(0, 0, 0, 0), t;
  }
}
class Dv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 90);
    F(this, "subpriority", 1);
    F(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "D":
      case "DD":
        return be(Me.dayOfYear, t);
      case "Do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    const s = t.getFullYear();
    return Fu(s) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, s) {
    return t.setMonth(0, s), t.setHours(0, 0, 0, 0), t;
  }
}
function _i(n, e, t) {
  var d, f, p, g;
  const r = Ut(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((g = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? 0, i = K(n), a = i.getDay(), l = (e % 7 + 7) % 7, u = 7 - s, c = e < 0 || e > 6 ? e - (a + u) % 7 : (l + u) % 7 - (a + u) % 7;
  return Oe(i, c);
}
class Ev extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 90);
    F(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, i) {
    return t = _i(t, s, i), t.setHours(0, 0, 0, 0), t;
  }
}
class Av extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 90);
    F(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s, i) {
    const a = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "e":
      case "ee":
        return De(xe(r.length, t), a);
      case "eo":
        return De(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, i) {
    return t = _i(t, s, i), t.setHours(0, 0, 0, 0), t;
  }
}
class Pv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 90);
    F(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, r, s, i) {
    const a = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "c":
      case "cc":
        return De(xe(r.length, t), a);
      case "co":
        return De(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return s.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return s.day(t, { width: "wide", context: "standalone" }) || s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, i) {
    return t = _i(t, s, i), t.setHours(0, 0, 0, 0), t;
  }
}
function Sv(n, e) {
  const t = K(n), r = rv(t), s = e - r;
  return Oe(t, s);
}
class Nv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 90);
    F(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const i = (a) => a === 0 ? 7 : a;
    switch (r) {
      case "i":
      case "ii":
        return xe(r.length, t);
      case "io":
        return s.ordinalNumber(t, { unit: "day" });
      case "iii":
        return De(
          s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return De(
          s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return De(
          s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return De(
          s.day(t, {
            width: "wide",
            context: "formatting"
          }) || s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, s) {
    return t = Sv(t, s), t.setHours(0, 0, 0, 0), t;
  }
}
class Ov extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 80);
    F(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(wi(s), 0, 0, 0), t;
  }
}
class Fv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 80);
    F(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(wi(s), 0, 0, 0), t;
  }
}
class Rv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 80);
    F(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(wi(s), 0, 0, 0), t;
  }
}
class Iv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 70);
    F(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "h":
        return be(Me.hour12h, t);
      case "ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, s) {
    const i = t.getHours() >= 12;
    return i && s < 12 ? t.setHours(s + 12, 0, 0, 0) : !i && s === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Vv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 70);
    F(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "H":
        return be(Me.hour23h, t);
      case "Ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, s) {
    return t.setHours(s, 0, 0, 0), t;
  }
}
class Bv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 70);
    F(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "K":
        return be(Me.hour11h, t);
      case "Ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.getHours() >= 12 && s < 12 ? t.setHours(s + 12, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Lv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 70);
    F(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "k":
        return be(Me.hour24h, t);
      case "ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, s) {
    const i = s <= 24 ? s % 24 : s;
    return t.setHours(i, 0, 0, 0), t;
  }
}
class jv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 60);
    F(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "m":
        return be(Me.minute, t);
      case "mo":
        return s.ordinalNumber(t, { unit: "minute" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, s) {
    return t.setMinutes(s, 0, 0), t;
  }
}
class Wv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 50);
    F(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "s":
        return be(Me.second, t);
      case "so":
        return s.ordinalNumber(t, { unit: "second" });
      default:
        return xe(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, s) {
    return t.setSeconds(s, 0), t;
  }
}
class Yv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 30);
    F(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    const s = (i) => Math.trunc(i * Math.pow(10, -r.length + 3));
    return De(xe(r.length, t), s);
  }
  set(t, r, s) {
    return t.setMilliseconds(s), t;
  }
}
class $v extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 10);
    F(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return at(
          it.basicOptionalMinutes,
          t
        );
      case "XX":
        return at(it.basic, t);
      case "XXXX":
        return at(
          it.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return at(
          it.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return at(it.extended, t);
    }
  }
  set(t, r, s) {
    return r.timestampIsSet ? t : de(
      t,
      t.getTime() - cn(t) - s
    );
  }
}
class zv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 10);
    F(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return at(
          it.basicOptionalMinutes,
          t
        );
      case "xx":
        return at(it.basic, t);
      case "xxxx":
        return at(
          it.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return at(
          it.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return at(it.extended, t);
    }
  }
  set(t, r, s) {
    return r.timestampIsSet ? t : de(
      t,
      t.getTime() - cn(t) - s
    );
  }
}
class Uv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 40);
    F(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Nu(t);
  }
  set(t, r, s) {
    return [de(t, s * 1e3), { timestampIsSet: !0 }];
  }
}
class Hv extends ne {
  constructor() {
    super(...arguments);
    F(this, "priority", 20);
    F(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Nu(t);
  }
  set(t, r, s) {
    return [de(t, s), { timestampIsSet: !0 }];
  }
}
const qv = {
  G: new dv(),
  y: new hv(),
  Y: new fv(),
  R: new pv(),
  u: new mv(),
  Q: new gv(),
  q: new vv(),
  M: new yv(),
  L: new bv(),
  w: new wv(),
  I: new xv(),
  d: new Mv(),
  D: new Dv(),
  E: new Ev(),
  e: new Av(),
  c: new Pv(),
  i: new Nv(),
  a: new Ov(),
  b: new Fv(),
  B: new Rv(),
  h: new Iv(),
  H: new Vv(),
  K: new Bv(),
  k: new Lv(),
  m: new jv(),
  s: new Wv(),
  S: new Yv(),
  X: new $v(),
  x: new zv(),
  t: new Uv(),
  T: new Hv()
}, Gv = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Kv = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Xv = /^'([^]*?)'?$/, Qv = /''/g, Zv = /\S/, Jv = /[a-zA-Z]/;
function ey(n, e, t, r) {
  var y, b, k, w;
  const s = nv(), i = s.locale ?? vi, a = s.firstWeekContainsDate ?? ((b = (y = s.locale) == null ? void 0 : y.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, o = s.weekStartsOn ?? ((w = (k = s.locale) == null ? void 0 : k.options) == null ? void 0 : w.weekStartsOn) ?? 0, l = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: i
  }, u = [new cv()], c = e.match(Kv).map((m) => {
    const _ = m[0];
    if (_ in Es) {
      const v = Es[_];
      return v(m, i.formatLong);
    }
    return m;
  }).join("").match(Gv), d = [];
  for (let m of c) {
    Au(m) && As(m, e, n), Eu(m) && As(m, e, n);
    const _ = m[0], v = qv[_];
    if (v) {
      const { incompatibleTokens: x } = v;
      if (Array.isArray(x)) {
        const R = d.find(
          (B) => x.includes(B.token) || B.token === _
        );
        if (R)
          throw new RangeError(
            `The format string mustn't contain \`${R.fullToken}\` and \`${m}\` at the same time`
          );
      } else if (v.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${m}\` and any other token at the same time`
        );
      d.push({ token: _, fullToken: m });
      const P = v.run(
        n,
        m,
        i.match,
        l
      );
      if (!P)
        return de(t, NaN);
      u.push(P.setter), n = P.rest;
    } else {
      if (_.match(Jv))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + _ + "`"
        );
      if (m === "''" ? m = "'" : _ === "'" && (m = ty(m)), n.indexOf(m) === 0)
        n = n.slice(m.length);
      else
        return de(t, NaN);
    }
  }
  if (n.length > 0 && Zv.test(n))
    return de(t, NaN);
  const f = u.map((m) => m.priority).sort((m, _) => _ - m).filter((m, _, v) => v.indexOf(m) === _).map(
    (m) => u.filter((_) => _.priority === m).sort((_, v) => v.subPriority - _.subPriority)
  ).map((m) => m[0]);
  let p = K(t);
  if (isNaN(p.getTime()))
    return de(t, NaN);
  const g = {};
  for (const m of f) {
    if (!m.validate(p, l))
      return de(t, NaN);
    const _ = m.set(p, g, l);
    Array.isArray(_) ? (p = _[0], Object.assign(g, _[1])) : p = _;
  }
  return de(t, p);
}
function ty(n) {
  return n.match(Xv)[1].replace(Qv, "'");
}
function xi(n, e) {
  const t = K(n), r = K(e);
  return t.getFullYear() === r.getFullYear() && t.getMonth() === r.getMonth();
}
function ny(n, e) {
  const t = K(n), r = K(e);
  return t.getFullYear() === r.getFullYear();
}
function Xr(n, e) {
  return Oe(n, -e);
}
function Qr(n, e) {
  const t = K(n), r = t.getFullYear(), s = t.getDate(), i = de(n, 0);
  i.setFullYear(r, e, 15), i.setHours(0, 0, 0, 0);
  const a = tv(i);
  return t.setMonth(e, Math.min(s, a)), t;
}
function mo(n, e) {
  const t = K(n);
  return isNaN(+t) ? de(n, NaN) : (t.setFullYear(e), t);
}
const ry = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, sy = (n, e, t) => {
  let r;
  const s = ry[n];
  return typeof s == "string" ? r = s : e === 1 ? r = s.one : r = s.other.replace("{{count}}", String(e)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "em " + r : "há " + r : r;
}, iy = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, ay = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, oy = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ly = {
  date: en({
    formats: iy,
    defaultWidth: "full"
  }),
  time: en({
    formats: ay,
    defaultWidth: "full"
  }),
  dateTime: en({
    formats: oy,
    defaultWidth: "full"
  })
}, uy = {
  lastWeek: (n) => {
    const e = n.getDay();
    return "'" + (e === 0 || e === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, cy = (n, e, t, r) => {
  const s = uy[n];
  return typeof s == "function" ? s(e) : s;
}, dy = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, hy = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, fy = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, py = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado"
  ],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, my = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, gy = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, vy = (n, e) => {
  const t = Number(n);
  return (e == null ? void 0 : e.unit) === "week" ? t + "ª" : t + "º";
}, yy = {
  ordinalNumber: vy,
  era: rt({
    values: dy,
    defaultWidth: "wide"
  }),
  quarter: rt({
    values: hy,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: rt({
    values: fy,
    defaultWidth: "wide"
  }),
  day: rt({
    values: py,
    defaultWidth: "wide"
  }),
  dayPeriod: rt({
    values: my,
    defaultWidth: "wide",
    formattingValues: gy,
    defaultFormattingWidth: "wide"
  })
}, by = /^(\d+)[ºªo]?/i, ky = /\d+/i, wy = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, _y = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, xy = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Ty = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Cy = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, My = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i
  ]
}, Dy = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, Ey = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, Ay = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, Py = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, Sy = {
  ordinalNumber: Mu({
    matchPattern: by,
    parsePattern: ky,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: st({
    matchPatterns: wy,
    defaultMatchWidth: "wide",
    parsePatterns: _y,
    defaultParseWidth: "any"
  }),
  quarter: st({
    matchPatterns: xy,
    defaultMatchWidth: "wide",
    parsePatterns: Ty,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: st({
    matchPatterns: Cy,
    defaultMatchWidth: "wide",
    parsePatterns: My,
    defaultParseWidth: "any"
  }),
  day: st({
    matchPatterns: Dy,
    defaultMatchWidth: "wide",
    parsePatterns: Ey,
    defaultParseWidth: "any"
  }),
  dayPeriod: st({
    matchPatterns: Ay,
    defaultMatchWidth: "any",
    parsePatterns: Py,
    defaultParseWidth: "any"
  })
}, Ny = {
  code: "pt-BR",
  formatDistance: sy,
  formatLong: ly,
  formatRelative: cy,
  localize: yy,
  match: Sy,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var j = function() {
  return j = Object.assign || function(e) {
    for (var t, r = 1, s = arguments.length; r < s; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, j.apply(this, arguments);
};
function Oy(n, e) {
  var t = {};
  for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, r = Object.getOwnPropertySymbols(n); s < r.length; s++)
      e.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[s]) && (t[r[s]] = n[r[s]]);
  return t;
}
function Ru(n, e, t) {
  for (var r = 0, s = e.length, i; r < s; r++)
    (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return n.concat(i || Array.prototype.slice.call(e));
}
function Yn(n) {
  return n.mode === "multiple";
}
function $n(n) {
  return n.mode === "range";
}
function Ar(n) {
  return n.mode === "single";
}
var Fy = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function Ry(n, e) {
  return _t(n, "LLLL y", e);
}
function Iy(n, e) {
  return _t(n, "d", e);
}
function Vy(n, e) {
  return _t(n, "LLLL", e);
}
function By(n) {
  return "".concat(n);
}
function Ly(n, e) {
  return _t(n, "cccccc", e);
}
function jy(n, e) {
  return _t(n, "yyyy", e);
}
var Wy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: Ry,
  formatDay: Iy,
  formatMonthCaption: Vy,
  formatWeekNumber: By,
  formatWeekdayName: Ly,
  formatYearCaption: jy
}), Yy = function(n, e, t) {
  return _t(n, "do MMMM (EEEE)", t);
}, $y = function() {
  return "Month: ";
}, zy = function() {
  return "Go to next month";
}, Uy = function() {
  return "Go to previous month";
}, Hy = function(n, e) {
  return _t(n, "cccc", e);
}, qy = function(n) {
  return "Week n. ".concat(n);
}, Gy = function() {
  return "Year: ";
}, Ky = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: Yy,
  labelMonthDropdown: $y,
  labelNext: zy,
  labelPrevious: Uy,
  labelWeekNumber: qy,
  labelWeekday: Hy,
  labelYearDropdown: Gy
});
function Xy() {
  var n = "buttons", e = Fy, t = vi, r = {}, s = {}, i = 1, a = {}, o = /* @__PURE__ */ new Date();
  return {
    captionLayout: n,
    classNames: e,
    formatters: Wy,
    labels: Ky,
    locale: t,
    modifiersClassNames: r,
    modifiers: s,
    numberOfMonths: i,
    styles: a,
    today: o,
    mode: "default"
  };
}
function Qy(n) {
  var e = n.fromYear, t = n.toYear, r = n.fromMonth, s = n.toMonth, i = n.fromDate, a = n.toDate;
  return r ? i = $e(r) : e && (i = new Date(e, 0, 1)), s ? a = mi(s) : t && (a = new Date(t, 11, 31)), {
    fromDate: i ? un(i) : void 0,
    toDate: a ? un(a) : void 0
  };
}
var Iu = ze(void 0);
function Zy(n) {
  var e, t = n.initialProps, r = Xy(), s = Qy(t), i = s.fromDate, a = s.toDate, o = (e = t.captionLayout) !== null && e !== void 0 ? e : r.captionLayout;
  o !== "buttons" && (!i || !a) && (o = "buttons");
  var l;
  (Ar(t) || Yn(t) || $n(t)) && (l = t.onSelect);
  var u = j(j(j({}, r), t), { captionLayout: o, classNames: j(j({}, r.classNames), t.classNames), components: j({}, t.components), formatters: j(j({}, r.formatters), t.formatters), fromDate: i, labels: j(j({}, r.labels), t.labels), mode: t.mode || r.mode, modifiers: j(j({}, r.modifiers), t.modifiers), modifiersClassNames: j(j({}, r.modifiersClassNames), t.modifiersClassNames), onSelect: l, styles: j(j({}, r.styles), t.styles), toDate: a });
  return h(Iu.Provider, { value: u, children: n.children });
}
function he() {
  var n = ce(Iu);
  if (!n)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return n;
}
function Vu(n) {
  var e = he(), t = e.locale, r = e.classNames, s = e.styles, i = e.formatters.formatCaption;
  return h("div", { className: r.caption_label, style: s.caption_label, "aria-live": "polite", role: "presentation", id: n.id, children: i(n.displayMonth, { locale: t }) });
}
function Jy(n) {
  return h("svg", j({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, n, { children: h("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Bu(n) {
  var e, t, r = n.onChange, s = n.value, i = n.children, a = n.caption, o = n.className, l = n.style, u = he(), c = (t = (e = u.components) === null || e === void 0 ? void 0 : e.IconDropdown) !== null && t !== void 0 ? t : Jy;
  return T("div", { className: o, style: l, children: [h("span", { className: u.classNames.vhidden, children: n["aria-label"] }), h("select", { name: n.name, "aria-label": n["aria-label"], className: u.classNames.dropdown, style: u.styles.dropdown, value: s, onChange: r, children: i }), T("div", { className: u.classNames.caption_label, style: u.styles.caption_label, "aria-hidden": "true", children: [a, h(c, { className: u.classNames.dropdown_icon, style: u.styles.dropdown_icon })] })] });
}
function e0(n) {
  var e, t = he(), r = t.fromDate, s = t.toDate, i = t.styles, a = t.locale, o = t.formatters.formatMonthCaption, l = t.classNames, u = t.components, c = t.labels.labelMonthDropdown;
  if (!r)
    return h(je, {});
  if (!s)
    return h(je, {});
  var d = [];
  if (ny(r, s))
    for (var f = $e(r), p = r.getMonth(); p <= s.getMonth(); p++)
      d.push(Qr(f, p));
  else
    for (var f = $e(/* @__PURE__ */ new Date()), p = 0; p <= 11; p++)
      d.push(Qr(f, p));
  var g = function(b) {
    var k = Number(b.target.value), w = Qr($e(n.displayMonth), k);
    n.onChange(w);
  }, y = (e = u == null ? void 0 : u.Dropdown) !== null && e !== void 0 ? e : Bu;
  return h(y, { name: "months", "aria-label": c(), className: l.dropdown_month, style: i.dropdown_month, onChange: g, value: n.displayMonth.getMonth(), caption: o(n.displayMonth, { locale: a }), children: d.map(function(b) {
    return h("option", { value: b.getMonth(), children: o(b, { locale: a }) }, b.getMonth());
  }) });
}
function t0(n) {
  var e, t = n.displayMonth, r = he(), s = r.fromDate, i = r.toDate, a = r.locale, o = r.styles, l = r.classNames, u = r.components, c = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!s)
    return h(je, {});
  if (!i)
    return h(je, {});
  for (var p = s.getFullYear(), g = i.getFullYear(), y = p; y <= g; y++)
    f.push(mo(Tu(/* @__PURE__ */ new Date()), y));
  var b = function(w) {
    var m = mo($e(t), Number(w.target.value));
    n.onChange(m);
  }, k = (e = u == null ? void 0 : u.Dropdown) !== null && e !== void 0 ? e : Bu;
  return h(k, { name: "years", "aria-label": d(), className: l.dropdown_year, style: o.dropdown_year, onChange: b, value: t.getFullYear(), caption: c(t, { locale: a }), children: f.map(function(w) {
    return h("option", { value: w.getFullYear(), children: c(w, { locale: a }) }, w.getFullYear());
  }) });
}
function n0(n, e) {
  var t = Z(n), r = t[0], s = t[1], i = e === void 0 ? r : e;
  return [i, s];
}
function r0(n) {
  var e = n.month, t = n.defaultMonth, r = n.today, s = e || t || r || /* @__PURE__ */ new Date(), i = n.toDate, a = n.fromDate, o = n.numberOfMonths, l = o === void 0 ? 1 : o;
  if (i && Fn(i, s) < 0) {
    var u = -1 * (l - 1);
    s = et(i, u);
  }
  return a && Fn(s, a) < 0 && (s = a), $e(s);
}
function s0() {
  var n = he(), e = r0(n), t = n0(e, n.month), r = t[0], s = t[1], i = function(a) {
    var o;
    if (!n.disableNavigation) {
      var l = $e(a);
      s(l), (o = n.onMonthChange) === null || o === void 0 || o.call(n, l);
    }
  };
  return [r, i];
}
function i0(n, e) {
  for (var t = e.reverseMonths, r = e.numberOfMonths, s = $e(n), i = $e(et(s, r)), a = Fn(i, s), o = [], l = 0; l < a; l++) {
    var u = et(s, l);
    o.push(u);
  }
  return t && (o = o.reverse()), o;
}
function a0(n, e) {
  if (!e.disableNavigation) {
    var t = e.toDate, r = e.pagedNavigation, s = e.numberOfMonths, i = s === void 0 ? 1 : s, a = r ? i : 1, o = $e(n);
    if (!t)
      return et(o, a);
    var l = Fn(t, n);
    if (!(l < i))
      return et(o, a);
  }
}
function o0(n, e) {
  if (!e.disableNavigation) {
    var t = e.fromDate, r = e.pagedNavigation, s = e.numberOfMonths, i = s === void 0 ? 1 : s, a = r ? i : 1, o = $e(n);
    if (!t)
      return et(o, -a);
    var l = Fn(o, t);
    if (!(l <= 0))
      return et(o, -a);
  }
}
var Lu = ze(void 0);
function l0(n) {
  var e = he(), t = s0(), r = t[0], s = t[1], i = i0(r, e), a = a0(r, e), o = o0(r, e), l = function(d) {
    return i.some(function(f) {
      return xi(d, f);
    });
  }, u = function(d, f) {
    l(d) || (f && Pu(d, f) ? s(et(d, 1 + e.numberOfMonths * -1)) : s(d));
  }, c = {
    currentMonth: r,
    displayMonths: i,
    goToMonth: s,
    goToDate: u,
    previousMonth: o,
    nextMonth: a,
    isDateDisplayed: l
  };
  return h(Lu.Provider, { value: c, children: n.children });
}
function zn() {
  var n = ce(Lu);
  if (!n)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return n;
}
function go(n) {
  var e, t = he(), r = t.classNames, s = t.styles, i = t.components, a = zn().goToMonth, o = function(c) {
    a(et(c, n.displayIndex ? -n.displayIndex : 0));
  }, l = (e = i == null ? void 0 : i.CaptionLabel) !== null && e !== void 0 ? e : Vu, u = h(l, { id: n.id, displayMonth: n.displayMonth });
  return T("div", { className: r.caption_dropdowns, style: s.caption_dropdowns, children: [h("div", { className: r.vhidden, children: u }), h(e0, { onChange: o, displayMonth: n.displayMonth }), h(t0, { onChange: o, displayMonth: n.displayMonth })] });
}
function u0(n) {
  return h("svg", j({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, n, { children: h("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function c0(n) {
  return h("svg", j({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, n, { children: h("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var fr = le(function(n, e) {
  var t = he(), r = t.classNames, s = t.styles, i = [r.button_reset, r.button];
  n.className && i.push(n.className);
  var a = i.join(" "), o = j(j({}, s.button_reset), s.button);
  return n.style && Object.assign(o, n.style), h("button", j({}, n, { ref: e, type: "button", className: a, style: o }));
});
function d0(n) {
  var e, t, r = he(), s = r.dir, i = r.locale, a = r.classNames, o = r.styles, l = r.labels, u = l.labelPrevious, c = l.labelNext, d = r.components;
  if (!n.nextMonth && !n.previousMonth)
    return h(je, {});
  var f = u(n.previousMonth, { locale: i }), p = [
    a.nav_button,
    a.nav_button_previous
  ].join(" "), g = c(n.nextMonth, { locale: i }), y = [
    a.nav_button,
    a.nav_button_next
  ].join(" "), b = (e = d == null ? void 0 : d.IconRight) !== null && e !== void 0 ? e : c0, k = (t = d == null ? void 0 : d.IconLeft) !== null && t !== void 0 ? t : u0;
  return T("div", { className: a.nav, style: o.nav, children: [!n.hidePrevious && h(fr, { name: "previous-month", "aria-label": f, className: p, style: o.nav_button_previous, disabled: !n.previousMonth, onClick: n.onPreviousClick, children: s === "rtl" ? h(b, { className: a.nav_icon, style: o.nav_icon }) : h(k, { className: a.nav_icon, style: o.nav_icon }) }), !n.hideNext && h(fr, { name: "next-month", "aria-label": g, className: y, style: o.nav_button_next, disabled: !n.nextMonth, onClick: n.onNextClick, children: s === "rtl" ? h(k, { className: a.nav_icon, style: o.nav_icon }) : h(b, { className: a.nav_icon, style: o.nav_icon }) })] });
}
function vo(n) {
  var e = he().numberOfMonths, t = zn(), r = t.previousMonth, s = t.nextMonth, i = t.goToMonth, a = t.displayMonths, o = a.findIndex(function(g) {
    return xi(n.displayMonth, g);
  }), l = o === 0, u = o === a.length - 1, c = e > 1 && (l || !u), d = e > 1 && (u || !l), f = function() {
    r && i(r);
  }, p = function() {
    s && i(s);
  };
  return h(d0, { displayMonth: n.displayMonth, hideNext: c, hidePrevious: d, nextMonth: s, previousMonth: r, onPreviousClick: f, onNextClick: p });
}
function h0(n) {
  var e, t = he(), r = t.classNames, s = t.disableNavigation, i = t.styles, a = t.captionLayout, o = t.components, l = (e = o == null ? void 0 : o.CaptionLabel) !== null && e !== void 0 ? e : Vu, u;
  return s ? u = h(l, { id: n.id, displayMonth: n.displayMonth }) : a === "dropdown" ? u = h(go, { displayMonth: n.displayMonth, id: n.id }) : a === "dropdown-buttons" ? u = T(je, { children: [h(go, { displayMonth: n.displayMonth, displayIndex: n.displayIndex, id: n.id }), h(vo, { displayMonth: n.displayMonth, displayIndex: n.displayIndex, id: n.id })] }) : u = T(je, { children: [h(l, { id: n.id, displayMonth: n.displayMonth, displayIndex: n.displayIndex }), h(vo, { displayMonth: n.displayMonth, id: n.id })] }), h("div", { className: r.caption, style: i.caption, children: u });
}
function f0(n) {
  var e = he(), t = e.footer, r = e.styles, s = e.classNames.tfoot;
  return t ? h("tfoot", { className: s, style: r.tfoot, children: h("tr", { children: h("td", { colSpan: 8, children: t }) }) }) : h(je, {});
}
function p0(n, e, t) {
  for (var r = t ? wt(/* @__PURE__ */ new Date()) : Ge(/* @__PURE__ */ new Date(), { locale: n, weekStartsOn: e }), s = [], i = 0; i < 7; i++) {
    var a = Oe(r, i);
    s.push(a);
  }
  return s;
}
function m0() {
  var n = he(), e = n.classNames, t = n.styles, r = n.showWeekNumber, s = n.locale, i = n.weekStartsOn, a = n.ISOWeek, o = n.formatters.formatWeekdayName, l = n.labels.labelWeekday, u = p0(s, i, a);
  return T("tr", { style: t.head_row, className: e.head_row, children: [r && h("td", { style: t.head_cell, className: e.head_cell }), u.map(function(c, d) {
    return h("th", { scope: "col", className: e.head_cell, style: t.head_cell, "aria-label": l(c, { locale: s }), children: o(c, { locale: s }) }, d);
  })] });
}
function g0() {
  var n, e = he(), t = e.classNames, r = e.styles, s = e.components, i = (n = s == null ? void 0 : s.HeadRow) !== null && n !== void 0 ? n : m0;
  return h("thead", { style: r.head, className: t.head, children: h(i, {}) });
}
function v0(n) {
  var e = he(), t = e.locale, r = e.formatters.formatDay;
  return h(je, { children: r(n.date, { locale: t }) });
}
var Ti = ze(void 0);
function y0(n) {
  if (!Yn(n.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return h(Ti.Provider, { value: e, children: n.children });
  }
  return h(b0, { initialProps: n.initialProps, children: n.children });
}
function b0(n) {
  var e = n.initialProps, t = n.children, r = e.selected, s = e.min, i = e.max, a = function(u, c, d) {
    var f, p;
    (f = e.onDayClick) === null || f === void 0 || f.call(e, u, c, d);
    var g = !!(c.selected && s && (r == null ? void 0 : r.length) === s);
    if (!g) {
      var y = !!(!c.selected && i && (r == null ? void 0 : r.length) === i);
      if (!y) {
        var b = r ? Ru([], r) : [];
        if (c.selected) {
          var k = b.findIndex(function(w) {
            return We(u, w);
          });
          b.splice(k, 1);
        } else
          b.push(u);
        (p = e.onSelect) === null || p === void 0 || p.call(e, b, u, c, d);
      }
    }
  }, o = {
    disabled: []
  };
  r && o.disabled.push(function(u) {
    var c = i && r.length > i - 1, d = r.some(function(f) {
      return We(f, u);
    });
    return !!(c && !d);
  });
  var l = {
    selected: r,
    onDayClick: a,
    modifiers: o
  };
  return h(Ti.Provider, { value: l, children: t });
}
function Ci() {
  var n = ce(Ti);
  if (!n)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return n;
}
function k0(n, e) {
  var t = e || {}, r = t.from, s = t.to;
  return r && s ? We(s, n) && We(r, n) ? void 0 : We(s, n) ? { from: s, to: void 0 } : We(r, n) ? void 0 : Ps(r, n) ? { from: n, to: s } : { from: r, to: n } : s ? Ps(n, s) ? { from: s, to: n } : { from: n, to: s } : r ? Pu(n, r) ? { from: n, to: r } : { from: r, to: n } : { from: n, to: void 0 };
}
var Mi = ze(void 0);
function w0(n) {
  if (!$n(n.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return h(Mi.Provider, { value: e, children: n.children });
  }
  return h(_0, { initialProps: n.initialProps, children: n.children });
}
function _0(n) {
  var e = n.initialProps, t = n.children, r = e.selected, s = r || {}, i = s.from, a = s.to, o = e.min, l = e.max, u = function(p, g, y) {
    var b, k;
    (b = e.onDayClick) === null || b === void 0 || b.call(e, p, g, y);
    var w = k0(p, r);
    (k = e.onSelect) === null || k === void 0 || k.call(e, w, p, g, y);
  }, c = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i ? (c.range_start = [i], a ? (c.range_end = [a], We(i, a) || (c.range_middle = [
    {
      after: i,
      before: a
    }
  ])) : c.range_end = [i]) : a && (c.range_start = [a], c.range_end = [a]), o && (i && !a && c.disabled.push({
    after: Xr(i, o - 1),
    before: Oe(i, o - 1)
  }), i && a && c.disabled.push({
    after: i,
    before: Oe(i, o - 1)
  }), !i && a && c.disabled.push({
    after: Xr(a, o - 1),
    before: Oe(a, o - 1)
  })), l) {
    if (i && !a && (c.disabled.push({
      before: Oe(i, -l + 1)
    }), c.disabled.push({
      after: Oe(i, l - 1)
    })), i && a) {
      var d = ot(a, i) + 1, f = l - d;
      c.disabled.push({
        before: Xr(i, f)
      }), c.disabled.push({
        after: Oe(a, f)
      });
    }
    !i && a && (c.disabled.push({
      before: Oe(a, -l + 1)
    }), c.disabled.push({
      after: Oe(a, l - 1)
    }));
  }
  return h(Mi.Provider, { value: { selected: r, onDayClick: u, modifiers: c }, children: t });
}
function Di() {
  var n = ce(Mi);
  if (!n)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return n;
}
function tr(n) {
  return Array.isArray(n) ? Ru([], n) : n !== void 0 ? [n] : [];
}
function x0(n) {
  var e = {};
  return Object.entries(n).forEach(function(t) {
    var r = t[0], s = t[1];
    e[r] = tr(s);
  }), e;
}
var tt;
(function(n) {
  n.Outside = "outside", n.Disabled = "disabled", n.Selected = "selected", n.Hidden = "hidden", n.Today = "today", n.RangeStart = "range_start", n.RangeEnd = "range_end", n.RangeMiddle = "range_middle";
})(tt || (tt = {}));
var T0 = tt.Selected, vt = tt.Disabled, C0 = tt.Hidden, M0 = tt.Today, Zr = tt.RangeEnd, Jr = tt.RangeMiddle, es = tt.RangeStart, D0 = tt.Outside;
function E0(n, e, t) {
  var r, s = (r = {}, r[T0] = tr(n.selected), r[vt] = tr(n.disabled), r[C0] = tr(n.hidden), r[M0] = [n.today], r[Zr] = [], r[Jr] = [], r[es] = [], r[D0] = [], r);
  return n.fromDate && s[vt].push({ before: n.fromDate }), n.toDate && s[vt].push({ after: n.toDate }), Yn(n) ? s[vt] = s[vt].concat(e.modifiers[vt]) : $n(n) && (s[vt] = s[vt].concat(t.modifiers[vt]), s[es] = t.modifiers[es], s[Jr] = t.modifiers[Jr], s[Zr] = t.modifiers[Zr]), s;
}
var ju = ze(void 0);
function A0(n) {
  var e = he(), t = Ci(), r = Di(), s = E0(e, t, r), i = x0(e.modifiers), a = j(j({}, s), i);
  return h(ju.Provider, { value: a, children: n.children });
}
function Wu() {
  var n = ce(ju);
  if (!n)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return n;
}
function P0(n) {
  return !!(n && typeof n == "object" && "before" in n && "after" in n);
}
function S0(n) {
  return !!(n && typeof n == "object" && "from" in n);
}
function N0(n) {
  return !!(n && typeof n == "object" && "after" in n);
}
function O0(n) {
  return !!(n && typeof n == "object" && "before" in n);
}
function F0(n) {
  return !!(n && typeof n == "object" && "dayOfWeek" in n);
}
function R0(n, e) {
  var t, r = e.from, s = e.to;
  if (r && s) {
    var i = ot(s, r) < 0;
    i && (t = [s, r], r = t[0], s = t[1]);
    var a = ot(n, r) >= 0 && ot(s, n) >= 0;
    return a;
  }
  return s ? We(s, n) : r ? We(r, n) : !1;
}
function I0(n) {
  return pi(n);
}
function V0(n) {
  return Array.isArray(n) && n.every(pi);
}
function B0(n, e) {
  return e.some(function(t) {
    if (typeof t == "boolean")
      return t;
    if (I0(t))
      return We(n, t);
    if (V0(t))
      return t.includes(n);
    if (S0(t))
      return R0(n, t);
    if (F0(t))
      return t.dayOfWeek.includes(n.getDay());
    if (P0(t)) {
      var r = ot(t.before, n), s = ot(t.after, n), i = r > 0, a = s < 0, o = Ps(t.before, t.after);
      return o ? a && i : i || a;
    }
    return N0(t) ? ot(n, t.after) > 0 : O0(t) ? ot(t.before, n) > 0 : typeof t == "function" ? t(n) : !1;
  });
}
function Ei(n, e, t) {
  var r = Object.keys(e).reduce(function(i, a) {
    var o = e[a];
    return B0(n, o) && i.push(a), i;
  }, []), s = {};
  return r.forEach(function(i) {
    return s[i] = !0;
  }), t && !xi(n, t) && (s.outside = !0), s;
}
function L0(n, e) {
  for (var t = $e(n[0]), r = mi(n[n.length - 1]), s, i, a = t; a <= r; ) {
    var o = Ei(a, e), l = !o.disabled && !o.hidden;
    if (!l) {
      a = Oe(a, 1);
      continue;
    }
    if (o.selected)
      return a;
    o.today && !i && (i = a), s || (s = a), a = Oe(a, 1);
  }
  return i || s;
}
var j0 = 365;
function Yu(n, e) {
  var t = e.moveBy, r = e.direction, s = e.context, i = e.modifiers, a = e.retry, o = a === void 0 ? { count: 0, lastFocused: n } : a, l = s.weekStartsOn, u = s.fromDate, c = s.toDate, d = s.locale, f = {
    day: Oe,
    week: Ds,
    month: et,
    year: ag,
    startOfWeek: function(b) {
      return s.ISOWeek ? wt(b) : Ge(b, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(b) {
      return s.ISOWeek ? Cu(b) : gi(b, { locale: d, weekStartsOn: l });
    }
  }, p = f[t](n, r === "after" ? 1 : -1);
  r === "before" && u ? p = og([u, p]) : r === "after" && c && (p = lg([c, p]));
  var g = !0;
  if (i) {
    var y = Ei(p, i);
    g = !y.disabled && !y.hidden;
  }
  return g ? p : o.count > j0 ? o.lastFocused : Yu(p, {
    moveBy: t,
    direction: r,
    context: s,
    modifiers: i,
    retry: j(j({}, o), { count: o.count + 1 })
  });
}
var $u = ze(void 0);
function W0(n) {
  var e = zn(), t = Wu(), r = Z(), s = r[0], i = r[1], a = Z(), o = a[0], l = a[1], u = L0(e.displayMonths, t), c = s ?? (o && e.isDateDisplayed(o)) ? o : u, d = function() {
    l(s), i(void 0);
  }, f = function(b) {
    i(b);
  }, p = he(), g = function(b, k) {
    if (s) {
      var w = Yu(s, {
        moveBy: b,
        direction: k,
        context: p,
        modifiers: t
      });
      We(s, w) || (e.goToDate(w, s), f(w));
    }
  }, y = {
    focusedDay: s,
    focusTarget: c,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return g("day", "after");
    },
    focusDayBefore: function() {
      return g("day", "before");
    },
    focusWeekAfter: function() {
      return g("week", "after");
    },
    focusWeekBefore: function() {
      return g("week", "before");
    },
    focusMonthBefore: function() {
      return g("month", "before");
    },
    focusMonthAfter: function() {
      return g("month", "after");
    },
    focusYearBefore: function() {
      return g("year", "before");
    },
    focusYearAfter: function() {
      return g("year", "after");
    },
    focusStartOfWeek: function() {
      return g("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return g("endOfWeek", "after");
    }
  };
  return h($u.Provider, { value: y, children: n.children });
}
function Ai() {
  var n = ce($u);
  if (!n)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return n;
}
function Y0(n, e) {
  var t = Wu(), r = Ei(n, t, e);
  return r;
}
var Pi = ze(void 0);
function $0(n) {
  if (!Ar(n.initialProps)) {
    var e = {
      selected: void 0
    };
    return h(Pi.Provider, { value: e, children: n.children });
  }
  return h(z0, { initialProps: n.initialProps, children: n.children });
}
function z0(n) {
  var e = n.initialProps, t = n.children, r = function(i, a, o) {
    var l, u, c;
    if ((l = e.onDayClick) === null || l === void 0 || l.call(e, i, a, o), a.selected && !e.required) {
      (u = e.onSelect) === null || u === void 0 || u.call(e, void 0, i, a, o);
      return;
    }
    (c = e.onSelect) === null || c === void 0 || c.call(e, i, i, a, o);
  }, s = {
    selected: e.selected,
    onDayClick: r
  };
  return h(Pi.Provider, { value: s, children: t });
}
function zu() {
  var n = ce(Pi);
  if (!n)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return n;
}
function U0(n, e) {
  var t = he(), r = zu(), s = Ci(), i = Di(), a = Ai(), o = a.focusDayAfter, l = a.focusDayBefore, u = a.focusWeekAfter, c = a.focusWeekBefore, d = a.blur, f = a.focus, p = a.focusMonthBefore, g = a.focusMonthAfter, y = a.focusYearBefore, b = a.focusYearAfter, k = a.focusStartOfWeek, w = a.focusEndOfWeek, m = function(E) {
    var A, Ee, M, D;
    Ar(t) ? (A = r.onDayClick) === null || A === void 0 || A.call(r, n, e, E) : Yn(t) ? (Ee = s.onDayClick) === null || Ee === void 0 || Ee.call(s, n, e, E) : $n(t) ? (M = i.onDayClick) === null || M === void 0 || M.call(i, n, e, E) : (D = t.onDayClick) === null || D === void 0 || D.call(t, n, e, E);
  }, _ = function(E) {
    var A;
    f(n), (A = t.onDayFocus) === null || A === void 0 || A.call(t, n, e, E);
  }, v = function(E) {
    var A;
    d(), (A = t.onDayBlur) === null || A === void 0 || A.call(t, n, e, E);
  }, x = function(E) {
    var A;
    (A = t.onDayMouseEnter) === null || A === void 0 || A.call(t, n, e, E);
  }, P = function(E) {
    var A;
    (A = t.onDayMouseLeave) === null || A === void 0 || A.call(t, n, e, E);
  }, R = function(E) {
    var A;
    (A = t.onDayPointerEnter) === null || A === void 0 || A.call(t, n, e, E);
  }, B = function(E) {
    var A;
    (A = t.onDayPointerLeave) === null || A === void 0 || A.call(t, n, e, E);
  }, ue = function(E) {
    var A;
    (A = t.onDayTouchCancel) === null || A === void 0 || A.call(t, n, e, E);
  }, ae = function(E) {
    var A;
    (A = t.onDayTouchEnd) === null || A === void 0 || A.call(t, n, e, E);
  }, $ = function(E) {
    var A;
    (A = t.onDayTouchMove) === null || A === void 0 || A.call(t, n, e, E);
  }, Te = function(E) {
    var A;
    (A = t.onDayTouchStart) === null || A === void 0 || A.call(t, n, e, E);
  }, ke = function(E) {
    var A;
    (A = t.onDayKeyUp) === null || A === void 0 || A.call(t, n, e, E);
  }, Se = function(E) {
    var A;
    switch (E.key) {
      case "ArrowLeft":
        E.preventDefault(), E.stopPropagation(), t.dir === "rtl" ? o() : l();
        break;
      case "ArrowRight":
        E.preventDefault(), E.stopPropagation(), t.dir === "rtl" ? l() : o();
        break;
      case "ArrowDown":
        E.preventDefault(), E.stopPropagation(), u();
        break;
      case "ArrowUp":
        E.preventDefault(), E.stopPropagation(), c();
        break;
      case "PageUp":
        E.preventDefault(), E.stopPropagation(), E.shiftKey ? y() : p();
        break;
      case "PageDown":
        E.preventDefault(), E.stopPropagation(), E.shiftKey ? b() : g();
        break;
      case "Home":
        E.preventDefault(), E.stopPropagation(), k();
        break;
      case "End":
        E.preventDefault(), E.stopPropagation(), w();
        break;
    }
    (A = t.onDayKeyDown) === null || A === void 0 || A.call(t, n, e, E);
  }, we = {
    onClick: m,
    onFocus: _,
    onBlur: v,
    onKeyDown: Se,
    onKeyUp: ke,
    onMouseEnter: x,
    onMouseLeave: P,
    onPointerEnter: R,
    onPointerLeave: B,
    onTouchCancel: ue,
    onTouchEnd: ae,
    onTouchMove: $,
    onTouchStart: Te
  };
  return we;
}
function H0() {
  var n = he(), e = zu(), t = Ci(), r = Di(), s = Ar(n) ? e.selected : Yn(n) ? t.selected : $n(n) ? r.selected : void 0;
  return s;
}
function q0(n) {
  return Object.values(tt).includes(n);
}
function G0(n, e) {
  var t = [n.classNames.day];
  return Object.keys(e).forEach(function(r) {
    var s = n.modifiersClassNames[r];
    if (s)
      t.push(s);
    else if (q0(r)) {
      var i = n.classNames["day_".concat(r)];
      i && t.push(i);
    }
  }), t;
}
function K0(n, e) {
  var t = j({}, n.styles.day);
  return Object.keys(e).forEach(function(r) {
    var s;
    t = j(j({}, t), (s = n.modifiersStyles) === null || s === void 0 ? void 0 : s[r]);
  }), t;
}
function X0(n, e, t) {
  var r, s, i, a = he(), o = Ai(), l = Y0(n, e), u = U0(n, l), c = H0(), d = !!(a.onDayClick || a.mode !== "default");
  ve(function() {
    var x;
    l.outside || o.focusedDay && d && We(o.focusedDay, n) && ((x = t.current) === null || x === void 0 || x.focus());
  }, [
    o.focusedDay,
    n,
    t,
    d,
    l.outside
  ]);
  var f = G0(a, l).join(" "), p = K0(a, l), g = !!(l.outside && !a.showOutsideDays || l.hidden), y = (i = (s = a.components) === null || s === void 0 ? void 0 : s.DayContent) !== null && i !== void 0 ? i : v0, b = h(y, { date: n, displayMonth: e, activeModifiers: l }), k = {
    style: p,
    className: f,
    children: b,
    role: "gridcell"
  }, w = o.focusTarget && We(o.focusTarget, n) && !l.outside, m = o.focusedDay && We(o.focusedDay, n), _ = j(j(j({}, k), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = m || w ? 0 : -1, r)), u), v = {
    isButton: d,
    isHidden: g,
    activeModifiers: l,
    selectedDays: c,
    buttonProps: _,
    divProps: k
  };
  return v;
}
function Q0(n) {
  var e = Ie(null), t = X0(n.date, n.displayMonth, e);
  return t.isHidden ? h("div", { role: "gridcell" }) : t.isButton ? h(fr, j({ name: "day", ref: e }, t.buttonProps)) : h("div", j({}, t.divProps));
}
function Z0(n) {
  var e = n.number, t = n.dates, r = he(), s = r.onWeekNumberClick, i = r.styles, a = r.classNames, o = r.locale, l = r.labels.labelWeekNumber, u = r.formatters.formatWeekNumber, c = u(Number(e), { locale: o });
  if (!s)
    return h("span", { className: a.weeknumber, style: i.weeknumber, children: c });
  var d = l(Number(e), { locale: o }), f = function(p) {
    s(e, t, p);
  };
  return h(fr, { name: "week-number", "aria-label": d, className: a.weeknumber, style: i.weeknumber, onClick: f, children: c });
}
function J0(n) {
  var e, t, r = he(), s = r.styles, i = r.classNames, a = r.showWeekNumber, o = r.components, l = (e = o == null ? void 0 : o.Day) !== null && e !== void 0 ? e : Q0, u = (t = o == null ? void 0 : o.WeekNumber) !== null && t !== void 0 ? t : Z0, c;
  return a && (c = h("td", { className: i.cell, style: s.cell, children: h(u, { number: n.weekNumber, dates: n.dates }) })), T("tr", { className: i.row, style: s.row, children: [c, n.dates.map(function(d) {
    return h("td", { className: i.cell, style: s.cell, role: "presentation", children: h(l, { displayMonth: n.displayMonth, date: d }) }, sv(d));
  })] });
}
function yo(n, e, t) {
  for (var r = t != null && t.ISOWeek ? Cu(e) : gi(e, t), s = t != null && t.ISOWeek ? wt(n) : Ge(n, t), i = ot(r, s), a = [], o = 0; o <= i; o++)
    a.push(Oe(s, o));
  var l = a.reduce(function(u, c) {
    var d = t != null && t.ISOWeek ? yi(c) : ki(c, t), f = u.find(function(p) {
      return p.weekNumber === d;
    });
    return f ? (f.dates.push(c), u) : (u.push({
      weekNumber: d,
      dates: [c]
    }), u);
  }, []);
  return l;
}
function eb(n, e) {
  var t = yo($e(n), mi(n), e);
  if (e != null && e.useFixedWeeks) {
    var r = av(n, e);
    if (r < 6) {
      var s = t[t.length - 1], i = s.dates[s.dates.length - 1], a = Ds(i, 6 - r), o = yo(Ds(i, 1), a, e);
      t.push.apply(t, o);
    }
  }
  return t;
}
function tb(n) {
  var e, t, r, s = he(), i = s.locale, a = s.classNames, o = s.styles, l = s.hideHead, u = s.fixedWeeks, c = s.components, d = s.weekStartsOn, f = s.firstWeekContainsDate, p = s.ISOWeek, g = eb(n.displayMonth, {
    useFixedWeeks: !!u,
    ISOWeek: p,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), y = (e = c == null ? void 0 : c.Head) !== null && e !== void 0 ? e : g0, b = (t = c == null ? void 0 : c.Row) !== null && t !== void 0 ? t : J0, k = (r = c == null ? void 0 : c.Footer) !== null && r !== void 0 ? r : f0;
  return T("table", { id: n.id, className: a.table, style: o.table, role: "grid", "aria-labelledby": n["aria-labelledby"], children: [!l && h(y, {}), h("tbody", { className: a.tbody, style: o.tbody, children: g.map(function(w) {
    return h(b, { displayMonth: n.displayMonth, dates: w.dates, weekNumber: w.weekNumber }, w.weekNumber);
  }) }), h(k, { displayMonth: n.displayMonth })] });
}
function nb() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var rb = nb() ? rr : ve, ts = !1, sb = 0;
function bo() {
  return "react-day-picker-".concat(++sb);
}
function ib(n) {
  var e, t = n ?? (ts ? bo() : null), r = Z(t), s = r[0], i = r[1];
  return rb(function() {
    s === null && i(bo());
  }, []), ve(function() {
    ts === !1 && (ts = !0);
  }, []), (e = n ?? s) !== null && e !== void 0 ? e : void 0;
}
function ab(n) {
  var e, t, r = he(), s = r.dir, i = r.classNames, a = r.styles, o = r.components, l = zn().displayMonths, u = ib(r.id ? "".concat(r.id, "-").concat(n.displayIndex) : void 0), c = r.id ? "".concat(r.id, "-grid-").concat(n.displayIndex) : void 0, d = [i.month], f = a.month, p = n.displayIndex === 0, g = n.displayIndex === l.length - 1, y = !p && !g;
  s === "rtl" && (e = [p, g], g = e[0], p = e[1]), p && (d.push(i.caption_start), f = j(j({}, f), a.caption_start)), g && (d.push(i.caption_end), f = j(j({}, f), a.caption_end)), y && (d.push(i.caption_between), f = j(j({}, f), a.caption_between));
  var b = (t = o == null ? void 0 : o.Caption) !== null && t !== void 0 ? t : h0;
  return T("div", { className: d.join(" "), style: f, children: [h(b, { id: u, displayMonth: n.displayMonth, displayIndex: n.displayIndex }), h(tb, { id: c, "aria-labelledby": u, displayMonth: n.displayMonth })] }, n.displayIndex);
}
function ob(n) {
  var e = he(), t = e.classNames, r = e.styles;
  return h("div", { className: t.months, style: r.months, children: n.children });
}
function lb(n) {
  var e, t, r = n.initialProps, s = he(), i = Ai(), a = zn(), o = Z(!1), l = o[0], u = o[1];
  ve(function() {
    s.initialFocus && i.focusTarget && (l || (i.focus(i.focusTarget), u(!0)));
  }, [
    s.initialFocus,
    l,
    i.focus,
    i.focusTarget,
    i
  ]);
  var c = [s.classNames.root, s.className];
  s.numberOfMonths > 1 && c.push(s.classNames.multiple_months), s.showWeekNumber && c.push(s.classNames.with_weeknumber);
  var d = j(j({}, s.styles.root), s.style), f = Object.keys(r).filter(function(g) {
    return g.startsWith("data-");
  }).reduce(function(g, y) {
    var b;
    return j(j({}, g), (b = {}, b[y] = r[y], b));
  }, {}), p = (t = (e = r.components) === null || e === void 0 ? void 0 : e.Months) !== null && t !== void 0 ? t : ob;
  return h("div", j({ className: c.join(" "), style: d, dir: s.dir, id: s.id, nonce: r.nonce, title: r.title, lang: r.lang }, f, { children: h(p, { children: a.displayMonths.map(function(g, y) {
    return h(ab, { displayIndex: y, displayMonth: g }, y);
  }) }) }));
}
function ub(n) {
  var e = n.children, t = Oy(n, ["children"]);
  return h(Zy, { initialProps: t, children: h(l0, { children: h($0, { initialProps: t, children: h(y0, { initialProps: t, children: h(w0, { initialProps: t, children: h(A0, { children: h(W0, { children: e }) }) }) }) }) }) });
}
function cb(n) {
  return h(ub, j({}, n, { children: h(lb, { initialProps: n }) }));
}
function Si(n, e = !1) {
  const [t, r] = Z(() => typeof window > "u" || typeof window.matchMedia != "function" ? e : window.matchMedia(n).matches);
  return ve(() => {
    if (typeof window > "u" || typeof window.matchMedia != "function")
      return;
    const s = window.matchMedia(n), i = (a) => r(a.matches);
    return r(s.matches), s.addEventListener("change", i), () => s.removeEventListener("change", i);
  }, [n]), t;
}
const db = "(max-width: 640px), (pointer: coarse)";
function hb() {
  return { isMobile: Si(db, !1) };
}
const ko = "yyyy-MM-dd", fb = le(
  ({ id: n, label: e, value: t, onDateChange: r, min: s, max: i, forceNative: a, placeholder: o, ...l }, u) => {
    const c = Tt(), d = n ?? `akuna-date-${c}`, { isMobile: f } = hb(), [p, g] = Z(!1);
    if (f || a)
      return /* @__PURE__ */ T(on, { id: d, children: [
        /* @__PURE__ */ h(ln, { children: e }),
        /* @__PURE__ */ h(
          Er,
          {
            ref: u,
            id: d,
            type: "date",
            value: t,
            min: s,
            max: i,
            onChange: (k) => r == null ? void 0 : r(k.currentTarget.value),
            ...l
          }
        )
      ] });
    const y = t ? ey(t, ko, /* @__PURE__ */ new Date()) : void 0, b = y ? _t(y, "dd/MM/yyyy") : "";
    return /* @__PURE__ */ T(on, { id: d, children: [
      /* @__PURE__ */ h(ln, { children: e }),
      /* @__PURE__ */ T(Ze.Root, { open: p, onOpenChange: g, children: [
        /* @__PURE__ */ h(Ze.Trigger, { asChild: !0, children: /* @__PURE__ */ T("button", { id: d, type: "button", "aria-label": e, className: S("akuna-control akuna-date-trigger"), children: [
          /* @__PURE__ */ h("span", { className: S(!b && "akuna-date-trigger__placeholder"), children: b || o || "dd/mm/aaaa" }),
          /* @__PURE__ */ h(Qc, { "aria-hidden": !0, size: 16 })
        ] }) }),
        /* @__PURE__ */ h(Ze.Portal, { children: /* @__PURE__ */ h(
          Ze.Content,
          {
            className: "akuna-popover akuna-calendar-popover",
            sideOffset: 8,
            align: "start",
            children: /* @__PURE__ */ h(
              cb,
              {
                mode: "single",
                locale: Ny,
                selected: y,
                defaultMonth: y,
                onSelect: (k) => {
                  r == null || r(k ? _t(k, ko) : ""), g(!1);
                }
              }
            )
          }
        ) })
      ] })
    ] });
  }
);
fb.displayName = "DatePicker";
function pb({ children: n, className: e, closeLabel: t, defaultOpen: r, description: s, footer: i, header: a, icon: o, mode: l = "adaptive", onOpenChange: u, open: c, title: d, trigger: f }) {
  return /* @__PURE__ */ T(Le.Root, { defaultOpen: r, onOpenChange: u, open: c, children: [
    f ? /* @__PURE__ */ h(Le.Trigger, { asChild: !0, children: f }) : null,
    /* @__PURE__ */ T(Le.Portal, { children: [
      /* @__PURE__ */ h(Le.Overlay, { className: "akuna-overlay" }),
      /* @__PURE__ */ T(
        Le.Content,
        {
          "aria-describedby": void 0,
          className: S("akuna-dialog", "akuna-dialog--portal-safe", `akuna-dialog--${l}`, i ? "akuna-dialog--with-footer" : void 0, e),
          children: [
            /* @__PURE__ */ T("div", { className: "akuna-dialog__header", children: [
              /* @__PURE__ */ T("div", { className: "akuna-dialog__header-main", children: [
                o ? /* @__PURE__ */ h("div", { className: "akuna-dialog__icon", children: o }) : null,
                /* @__PURE__ */ T("div", { className: "akuna-dialog__heading", children: [
                  /* @__PURE__ */ h(Le.Title, { className: "akuna-dialog__title", children: d }),
                  a ? /* @__PURE__ */ h("div", { className: "akuna-dialog__meta", children: a }) : null
                ] })
              ] }),
              t ? /* @__PURE__ */ h(Le.Close, { "aria-label": t, className: "akuna-dialog__close", type: "button", children: /* @__PURE__ */ h("span", { "aria-hidden": "true", children: "×" }) }) : null
            ] }),
            s ? /* @__PURE__ */ h(Le.Description, { className: "akuna-dialog__description", children: s }) : null,
            /* @__PURE__ */ h("div", { className: "akuna-dialog__body", children: n }),
            i ? /* @__PURE__ */ h("div", { className: "akuna-dialog__footer", children: i }) : null
          ]
        }
      )
    ] })
  ] });
}
function Sk(n) {
  return /* @__PURE__ */ h(pb, { ...n, className: "akuna-drawer__content", mode: "sheet" });
}
function Nk({ items: n, label: e, trigger: t }) {
  const [r, s] = Z(!1);
  return In(t) ? /* @__PURE__ */ T("span", { className: "akuna-dropdown-root", children: [
    Fo(t, {
      "aria-expanded": r,
      "aria-haspopup": "menu",
      "aria-label": e,
      onClick: () => s((i) => !i)
    }),
    r ? /* @__PURE__ */ h("div", { className: "akuna-dropdown", role: "menu", children: n.map((i, a) => /* @__PURE__ */ h(
      "button",
      {
        className: "akuna-dropdown__item",
        disabled: i.disabled,
        onClick: () => {
          var o;
          (o = i.onSelect) == null || o.call(i), s(!1);
        },
        role: "menuitem",
        type: "button",
        children: i.label
      },
      a
    )) }) : null
  ] }) : null;
}
function mb({ action: n, className: e, description: t, icon: r, title: s, ...i }) {
  return /* @__PURE__ */ T("div", { className: S("akuna-empty-state", e), ...i, children: [
    /* @__PURE__ */ h("div", { "aria-hidden": "true", className: "akuna-empty-state__mark", children: r ? /* @__PURE__ */ h(nn, { icon: r, size: 24 }) : null }),
    /* @__PURE__ */ h("h3", { children: s }),
    t ? /* @__PURE__ */ h("p", { children: t }) : null,
    n ? /* @__PURE__ */ h("div", { className: "akuna-empty-state__action", children: n }) : null
  ] });
}
function gb(n, e) {
  return n.includes(e) ? n.filter((t) => t !== e) : [...n, e];
}
function wo(n) {
  return n.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
}
function vb({ group: n }) {
  const [e, t] = Z(""), r = n.searchable && e.trim().length > 0 ? n.options.filter((s) => wo(s.label).includes(wo(e.trim()))) : n.options;
  return /* @__PURE__ */ T("div", { className: "akuna-filter-menu__group", children: [
    /* @__PURE__ */ h("div", { className: "akuna-filter-menu__group-title", children: n.title }),
    n.searchable ? /* @__PURE__ */ h(
      "input",
      {
        className: "akuna-filter-menu__search",
        onChange: (s) => t(s.target.value),
        placeholder: n.searchPlaceholder,
        type: "search",
        value: e
      }
    ) : null,
    /* @__PURE__ */ T("div", { className: "akuna-filter-menu__options", children: [
      r.map((s) => /* @__PURE__ */ h(
        _u,
        {
          checked: n.selected.includes(s.value),
          label: s.label,
          onCheckedChange: () => n.onChange(gb(n.selected, s.value))
        },
        s.value
      )),
      r.length === 0 && n.emptyMessage ? /* @__PURE__ */ h("p", { className: "akuna-filter-menu__empty", children: n.emptyMessage }) : null
    ] })
  ] });
}
function Ok({ className: n, clearLabel: e, groups: t, label: r, onClear: s }) {
  const i = t.reduce((a, o) => a + o.selected.length, 0);
  return /* @__PURE__ */ T(Ze.Root, { children: [
    /* @__PURE__ */ h(Ze.Trigger, { asChild: !0, children: /* @__PURE__ */ T(ht, { className: n, type: "button", variant: "outline", children: [
      /* @__PURE__ */ h(id, { "aria-hidden": "true", size: 16 }),
      r,
      i > 0 ? /* @__PURE__ */ h(pd, { className: "akuna-filter-menu__trigger-badge", variant: "default", children: i }) : null
    ] }) }),
    /* @__PURE__ */ h(Ze.Portal, { children: /* @__PURE__ */ h(Ze.Content, { align: "start", className: "akuna-popover akuna-filter-menu-popover", sideOffset: 8, children: /* @__PURE__ */ T("div", { className: "akuna-filter-menu__panel", children: [
      t.map((a) => /* @__PURE__ */ h(vb, { group: a }, a.id)),
      s ? /* @__PURE__ */ h(ht, { className: "akuna-filter-menu__clear", onClick: s, type: "button", variant: "ghost", children: e }) : null
    ] }) }) })
  ] });
}
const Ni = le(({ children: n, className: e, label: t, ...r }, s) => {
  if (!(t != null && t.trim()))
    throw new Error("IconButton requires an accessible label");
  return /* @__PURE__ */ h(ht, { ref: s, "aria-label": t, className: ["akuna-icon-button", e].filter(Boolean).join(" "), ...r, children: n });
});
Ni.displayName = "IconButton";
function St(n) {
  return typeof n == "string" || n instanceof String;
}
function _o(n) {
  var e;
  return typeof n == "object" && n != null && (n == null || (e = n.constructor) == null ? void 0 : e.name) === "Object";
}
function Uu(n, e) {
  return Array.isArray(e) ? Uu(n, (t, r) => e.includes(r)) : Object.entries(n).reduce((t, r) => {
    let [s, i] = r;
    return e(i, s) && (t[s] = i), t;
  }, {});
}
const V = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function yb(n) {
  switch (n) {
    case V.LEFT:
      return V.FORCE_LEFT;
    case V.RIGHT:
      return V.FORCE_RIGHT;
    default:
      return n;
  }
}
function ns(n) {
  return n.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function pr(n, e) {
  if (e === n) return !0;
  const t = Array.isArray(e), r = Array.isArray(n);
  let s;
  if (t && r) {
    if (e.length != n.length) return !1;
    for (s = 0; s < e.length; s++) if (!pr(e[s], n[s])) return !1;
    return !0;
  }
  if (t != r) return !1;
  if (e && n && typeof e == "object" && typeof n == "object") {
    const i = e instanceof Date, a = n instanceof Date;
    if (i && a) return e.getTime() == n.getTime();
    if (i != a) return !1;
    const o = e instanceof RegExp, l = n instanceof RegExp;
    if (o && l) return e.toString() == n.toString();
    if (o != l) return !1;
    const u = Object.keys(e);
    for (s = 0; s < u.length; s++) if (!Object.prototype.hasOwnProperty.call(n, u[s])) return !1;
    for (s = 0; s < u.length; s++) if (!pr(n[u[s]], e[u[s]])) return !1;
    return !0;
  } else if (e && n && typeof e == "function" && typeof n == "function")
    return e.toString() === n.toString();
  return !1;
}
class bb {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(e) {
    for (Object.assign(this, e); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
    if (this.insertedCount)
      for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end); )
        this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? V.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? V.RIGHT : V.LEFT;
  }
}
function W(n, e) {
  return new W.InputMask(n, e);
}
function Hu(n) {
  if (n == null) throw new Error("mask property should be defined");
  return n instanceof RegExp ? W.MaskedRegExp : St(n) ? W.MaskedPattern : n === Date ? W.MaskedDate : n === Number ? W.MaskedNumber : Array.isArray(n) || n === Array ? W.MaskedDynamic : W.Masked && n.prototype instanceof W.Masked ? n : W.Masked && n instanceof W.Masked ? n.constructor : n instanceof Function ? W.MaskedFunction : (console.warn("Mask not found for mask", n), W.Masked);
}
function Rn(n) {
  if (!n) throw new Error("Options in not defined");
  if (W.Masked) {
    if (n.prototype instanceof W.Masked) return {
      mask: n
    };
    const {
      mask: e = void 0,
      ...t
    } = n instanceof W.Masked ? {
      mask: n
    } : _o(n) && n.mask instanceof W.Masked ? n : {};
    if (e) {
      const r = e.mask;
      return {
        ...Uu(e, (s, i) => !i.startsWith("_")),
        mask: e.constructor,
        _mask: r,
        ...t
      };
    }
  }
  return _o(n) ? {
    ...n
  } : {
    mask: n
  };
}
function xt(n) {
  if (W.Masked && n instanceof W.Masked) return n;
  const e = Rn(n), t = Hu(e.mask);
  if (!t) throw new Error("Masked class is not found for provided mask " + e.mask + ", appropriate module needs to be imported manually before creating mask.");
  return e.mask === t && delete e.mask, e._mask && (e.mask = e._mask, delete e._mask), new t(e);
}
W.createMask = xt;
class Oi {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely sets element selection */
  select(e, t) {
    if (!(e == null || t == null || e === this.selectionStart && t === this.selectionEnd))
      try {
        this._unsafeSelect(e, t);
      } catch {
      }
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
W.MaskElement = Oi;
const xo = 90, kb = 89;
class Pr extends Oi {
  /** HTMLElement to use mask on */
  constructor(e) {
    super(), this.input = e, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var e, t, r;
    return (e = (t = (r = this.input).getRootNode) == null ? void 0 : t.call(r)) != null ? e : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(e) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", e.drop), this.input.addEventListener("click", e.click), this.input.addEventListener("focus", e.focus), this.input.addEventListener("blur", e.commit), this._handlers = e;
  }
  _onKeydown(e) {
    if (this._handlers.redo && (e.keyCode === xo && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === kb && e.ctrlKey))
      return e.preventDefault(), this._handlers.redo(e);
    if (this._handlers.undo && e.keyCode === xo && (e.metaKey || e.ctrlKey))
      return e.preventDefault(), this._handlers.undo(e);
    e.isComposing || this._handlers.selectionChange(e);
  }
  _onBeforeinput(e) {
    if (e.inputType === "historyUndo" && this._handlers.undo)
      return e.preventDefault(), this._handlers.undo(e);
    if (e.inputType === "historyRedo" && this._handlers.redo)
      return e.preventDefault(), this._handlers.redo(e);
  }
  _onCompositionEnd(e) {
    this._handlers.input(e);
  }
  _onInput(e) {
    e.isComposing || this._handlers.input(e);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
W.HTMLMaskElement = Pr;
class wb extends Pr {
  /** InputElement to use mask on */
  constructor(e) {
    super(e), this.input = e;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(e, t) {
    this.input.setSelectionRange(e, t);
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
}
W.HTMLMaskElement = Pr;
class qu extends Pr {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const e = this.rootElement, t = e.getSelection && e.getSelection(), r = t && t.anchorOffset, s = t && t.focusOffset;
    return s == null || r == null || r < s ? r : s;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const e = this.rootElement, t = e.getSelection && e.getSelection(), r = t && t.anchorOffset, s = t && t.focusOffset;
    return s == null || r == null || r > s ? r : s;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(e, t) {
    if (!this.rootElement.createRange) return;
    const r = this.rootElement.createRange();
    r.setStart(this.input.firstChild || this.input, e), r.setEnd(this.input.lastChild || this.input, t);
    const s = this.rootElement, i = s.getSelection && s.getSelection();
    i && (i.removeAllRanges(), i.addRange(r));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(e) {
    this.input.textContent = e;
  }
}
W.HTMLContenteditableMaskElement = qu;
class Sr {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(e) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(e), this.states.length > Sr.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(e) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + e, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
Sr.MAX_LENGTH = 100;
class _b {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(e, t) {
    this.el = e instanceof Oi ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new qu(e) : new wb(e), this.masked = xt(t), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new Sr(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(e) {
    var t;
    return e == null || ((t = this.masked) == null ? void 0 : t.maskEquals(e));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(e) {
    if (this.maskEquals(e)) return;
    if (!(e instanceof W.Masked) && this.masked.constructor === Hu(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const t = e instanceof W.Masked ? e : xt({
      mask: e
    });
    t.unmaskedValue = this.masked.unmaskedValue, this.masked = t;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(e) {
    this.rawInputValue !== e && (this.masked.rawInputValue = e, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(e, t) {
    const r = this._listeners[e];
    r && r.forEach((s) => s(t));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(e) {
    const t = this.masked.unmaskedValue, r = this.masked.value, s = this.masked.rawInputValue, i = this.displayValue, a = this.unmaskedValue !== t || this.value !== r || this._rawInputValue !== s;
    this._unmaskedValue = t, this._value = r, this._rawInputValue = s, this.el.value !== i && (this.el.value = i), e === "auto" ? this.alignCursor() : e != null && (this.cursorPos = e), a && this._fireChangeEvents(), !this._historyChanging && (a || this.history.isEmpty) && this.history.push({
      unmaskedValue: t,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(e) {
    const {
      mask: t,
      ...r
    } = e, s = !this.maskEquals(t), i = this.masked.optionsIsChanged(r);
    s && (this.mask = t), i && this.masked.updateOptions(r), (s || i) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, V.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(e, t) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(t), this;
  }
  /** Removes custom event listener */
  off(e, t) {
    if (!this._listeners[e]) return this;
    if (!t)
      return delete this._listeners[e], this;
    const r = this._listeners[e].indexOf(t);
    return r >= 0 && this._listeners[e].splice(r, 1), this;
  }
  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e, this._abortUpdateCursor();
    const t = new bb({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    }), r = this.masked.rawInputValue, s = this.masked.splice(t.startChangePos, t.removed.length, t.inserted, t.removeDirection, {
      input: !0,
      raw: !0
    }).offset, i = r === this.masked.rawInputValue ? t.removeDirection : V.NONE;
    let a = this.masked.nearestInputPos(t.startChangePos + s, i);
    i !== V.NONE && (a = this.masked.nearestInputPos(a, V.NONE)), this.updateControl(a), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(e) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(e) {
    e && (this._historyChanging = !0, this.unmaskedValue = e.unmaskedValue, this.el.select(e.selection.start, e.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
W.InputMask = _b;
class G {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(e) {
    return Array.isArray(e) ? e : [e, new G()];
  }
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, e);
  }
  /** Aggregate changes */
  aggregate(e) {
    return this.inserted += e.inserted, this.rawInserted += e.rawInserted, this.tailShift += e.tailShift, this.skip = this.skip || e.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(e) {
    return this.inserted === e.inserted && this.tailShift === e.tailShift && this.rawInserted === e.rawInserted && this.skip === e.skip;
  }
}
W.ChangeDetails = G;
class lt {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(e, t, r) {
    e === void 0 && (e = ""), t === void 0 && (t = 0), this.value = e, this.from = t, this.stop = r;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e) return "";
    const t = this.value[0];
    return this.value = this.value.slice(1), t;
  }
  shift() {
    if (!this.value.length) return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
class Ve {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    this._value = "", this._update({
      ...Ve.DEFAULTS,
      ...e
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(e) {
    this.optionsIsChanged(e) && this.withValueRefresh(this._update.bind(this, e));
  }
  /** Sets new options */
  _update(e) {
    Object.assign(this, e);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(e, t) {
    t === void 0 && (t = {
      input: !0
    }), this.reset(), this.append(e, t, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.resolve(e, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(e) {
    this.format ? this.value = this.format(e, this) : this.unmaskedValue = String(e);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.resolve(e, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(e, t) {
    return e;
  }
  totalInputPositions(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), Math.min(this.displayValue.length, t - e);
  }
  /** Extracts value in range considering flags */
  extractInput(e, t, r) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), this.displayValue.slice(e, t);
  }
  /** Extracts tail in range */
  extractTail(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), new lt(this.extractInput(e, t), e);
  }
  /** Appends tail */
  appendTail(e) {
    return St(e) && (e = new lt(String(e))), e.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(e, t) {
    return e ? (this._value += e, new G({
      inserted: e,
      rawInserted: e
    })) : new G();
  }
  /** Appends char */
  _appendChar(e, t, r) {
    t === void 0 && (t = {});
    const s = this.state;
    let i;
    if ([e, i] = this.doPrepareChar(e, t), e && (i = i.aggregate(this._appendCharRaw(e, t)), !i.rawInserted && this.autofix === "pad")) {
      const a = this.state;
      this.state = s;
      let o = this.pad(t);
      const l = this._appendCharRaw(e, t);
      o = o.aggregate(l), l.rawInserted || o.equals(i) ? i = o : this.state = a;
    }
    if (i.inserted) {
      let a, o = this.doValidate(t) !== !1;
      if (o && r != null) {
        const l = this.state;
        if (this.overwrite === !0) {
          a = r.state;
          for (let c = 0; c < i.rawInserted.length; ++c)
            r.unshift(this.displayValue.length - i.tailShift);
        }
        let u = this.appendTail(r);
        if (o = u.rawInserted.length === r.toString().length, !(o && u.inserted) && this.overwrite === "shift") {
          this.state = l, a = r.state;
          for (let c = 0; c < i.rawInserted.length; ++c)
            r.shift();
          u = this.appendTail(r), o = u.rawInserted.length === r.toString().length;
        }
        o && u.inserted && (this.state = l);
      }
      o || (i = new G(), this.state = s, r && a && (r.state = a));
    }
    return i;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new G();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new G();
  }
  /** Appends symbols considering flags */
  append(e, t, r) {
    if (!St(e)) throw new Error("value should be string");
    const s = St(r) ? new lt(String(r)) : r;
    t != null && t.tail && (t._beforeTailState = this.state);
    let i;
    [e, i] = this.doPrepare(e, t);
    for (let a = 0; a < e.length; ++a) {
      const o = this._appendChar(e[a], t, s);
      if (!o.rawInserted && !this.doSkipInvalid(e[a], t, s)) break;
      i.aggregate(o);
    }
    return (this.eager === !0 || this.eager === "append") && t != null && t.input && e && i.aggregate(this._appendEager()), s != null && (i.tailShift += this.appendTail(s).tailShift), i;
  }
  remove(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), this._value = this.displayValue.slice(0, e) + this.displayValue.slice(t), new G();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(e) {
    if (this._refreshing || !this._initialized) return e();
    this._refreshing = !0;
    const t = this.rawInputValue, r = this.value, s = e();
    return this.rawInputValue = t, this.value && this.value !== r && r.indexOf(this.value) === 0 && (this.append(r.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, s;
  }
  runIsolated(e) {
    if (this._isolated || !this._initialized) return e(this);
    this._isolated = !0;
    const t = this.state, r = e(this);
    return this.state = t, delete this._isolated, r;
  }
  doSkipInvalid(e, t, r) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(e, t) {
    return t === void 0 && (t = {}), G.normalize(this.prepare ? this.prepare(e, this, t) : e);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(e, t) {
    return t === void 0 && (t = {}), G.normalize(this.prepareChar ? this.prepareChar(e, this, t) : e);
  }
  /** Validates if value is acceptable */
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(e, t, r, s, i) {
    r === void 0 && (r = ""), s === void 0 && (s = V.NONE), i === void 0 && (i = {
      input: !0
    });
    const a = e + t, o = this.extractTail(a), l = this.eager === !0 || this.eager === "remove";
    let u;
    l && (s = yb(s), u = this.extractInput(0, a, {
      raw: !0
    }));
    let c = e;
    const d = new G();
    if (s !== V.NONE && (c = this.nearestInputPos(e, t > 1 && e !== 0 && !l ? V.NONE : s), d.tailShift = c - e), d.aggregate(this.remove(c)), l && s !== V.NONE && u === this.rawInputValue)
      if (s === V.FORCE_LEFT) {
        let f;
        for (; u === this.rawInputValue && (f = this.displayValue.length); )
          d.aggregate(new G({
            tailShift: -1
          })).aggregate(this.remove(f - 1));
      } else s === V.FORCE_RIGHT && o.unshift();
    return d.aggregate(this.append(r, i, o));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  optionsIsChanged(e) {
    return !pr(this, e);
  }
  typedValueEquals(e) {
    const t = this.typedValue;
    return e === t || Ve.EMPTY_VALUES.includes(e) && Ve.EMPTY_VALUES.includes(t) || (this.format ? this.format(e, this) === this.format(this.typedValue, this) : !1);
  }
  pad(e) {
    return new G();
  }
}
Ve.DEFAULTS = {
  skipInvalid: !0
};
Ve.EMPTY_VALUES = [void 0, null, ""];
W.Masked = Ve;
class Yt {
  /** */
  constructor(e, t) {
    e === void 0 && (e = []), t === void 0 && (t = 0), this.chunks = e, this.from = t;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(e) {
    if (!String(e)) return;
    e = St(e) ? new lt(String(e)) : e;
    const t = this.chunks[this.chunks.length - 1], r = t && // if stops are same or tail has no stop
    (t.stop === e.stop || e.stop == null) && // if tail chunk goes just after last chunk
    e.from === t.from + t.toString().length;
    if (e instanceof lt)
      r ? t.extend(e.toString()) : this.chunks.push(e);
    else if (e instanceof Yt) {
      if (e.stop == null) {
        let s;
        for (; e.chunks.length && e.chunks[0].stop == null; )
          s = e.chunks.shift(), s.from += e.from, this.extend(s);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof W.MaskedPattern))
      return new lt(this.toString()).appendTo(e);
    const t = new G();
    for (let r = 0; r < this.chunks.length; ++r) {
      const s = this.chunks[r], i = e._mapPosToBlock(e.displayValue.length), a = s.stop;
      let o;
      if (a != null && // if block not found or stop is behind lastBlock
      (!i || i.index <= a) && ((s instanceof Yt || // for continuous block also check if stop is exist
      e._stops.indexOf(a) >= 0) && t.aggregate(e._appendPlaceholder(a)), o = s instanceof Yt && e._blocks[a]), o) {
        const l = o.appendTail(s);
        t.aggregate(l);
        const u = s.toString().slice(l.rawInserted.length);
        u && t.aggregate(e.append(u, {
          tail: !0
        }));
      } else
        t.aggregate(e.append(s.toString(), {
          tail: !0
        }));
    }
    return t;
  }
  get state() {
    return {
      chunks: this.chunks.map((e) => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: t,
      ...r
    } = e;
    Object.assign(this, r), this.chunks = t.map((s) => {
      const i = "chunks" in s ? new Yt() : new lt();
      return i.state = s, i;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e) return "";
    const t = e != null ? e - this.from : e;
    let r = 0;
    for (; r < this.chunks.length; ) {
      const s = this.chunks[r], i = s.unshift(t);
      if (s.toString()) {
        if (!i) break;
        ++r;
      } else
        this.chunks.splice(r, 1);
      if (i) return i;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length) return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e; ) {
      const t = this.chunks[e], r = t.shift();
      if (t.toString()) {
        if (!r) break;
        --e;
      } else
        this.chunks.splice(e, 1);
      if (r) return r;
    }
    return "";
  }
}
class xb {
  constructor(e, t) {
    this.masked = e, this._log = [];
    const {
      offset: r,
      index: s
    } = e._mapPosToBlock(t) || (t < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = r, this.index = s, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return e && (this.state = e), e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((t = this.block) == null ? void 0 : t.displayValue.length) || 0) {
      var t;
      if (e()) return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (e()) return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, V.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, V.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, V.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, V.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, V.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, V.NONE), !0;
    });
  }
}
class Gu {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this._value.length), this._value = this._value.slice(0, e) + this._value.slice(t), this._value || (this._isRawInput = !1), new G();
  }
  nearestInputPos(e, t) {
    t === void 0 && (t = V.NONE);
    const r = 0, s = this._value.length;
    switch (t) {
      case V.LEFT:
      case V.FORCE_LEFT:
        return r;
      case V.NONE:
      case V.RIGHT:
      case V.FORCE_RIGHT:
      default:
        return s;
    }
  }
  totalInputPositions(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this._value.length), this._isRawInput ? t - e : 0;
  }
  extractInput(e, t, r) {
    return e === void 0 && (e = 0), t === void 0 && (t = this._value.length), r === void 0 && (r = {}), r.raw && this._isRawInput && this._value.slice(e, t) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e, t) {
    if (t === void 0 && (t = {}), this.isFilled) return new G();
    const r = this.eager === !0 || this.eager === "append", i = this.char === e && (this.isUnmasking || t.input || t.raw) && (!t.raw || !r) && !t.tail, a = new G({
      inserted: this.char,
      rawInserted: i ? this.char : ""
    });
    return this._value = this.char, this._isRawInput = i && (t.raw || t.input), a;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new G();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return new lt("");
  }
  appendTail(e) {
    return St(e) && (e = new lt(String(e))), e.appendTo(this);
  }
  append(e, t, r) {
    const s = this._appendChar(e[0], t);
    return r != null && (s.tailShift += this.appendTail(r).tailShift), s;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value, this._isRawInput = !!e._rawInputValue;
  }
  pad(e) {
    return this._appendPlaceholder();
  }
}
class mr {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    const {
      parent: t,
      isOptional: r,
      placeholderChar: s,
      displayChar: i,
      lazy: a,
      eager: o,
      ...l
    } = e;
    this.masked = xt(l), Object.assign(this, {
      parent: t,
      isOptional: r,
      placeholderChar: s,
      displayChar: i,
      lazy: a,
      eager: o
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.value.length), e === 0 && t >= 1 ? (this.isFilled = !1, this.masked.remove(e, t)) : new G();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(e, t) {
    if (t === void 0 && (t = {}), this.isFilled) return new G();
    const r = this.masked.state;
    let s = this.masked._appendChar(e, this.currentMaskFlags(t));
    return s.inserted && this.doValidate(t) === !1 && (s = new G(), this.masked.state = r), !s.inserted && !this.isOptional && !this.lazy && !t.input && (s.inserted = this.placeholderChar), s.skip = !s.inserted && !this.isOptional, this.isFilled = !!s.inserted, s;
  }
  append(e, t, r) {
    return this.masked.append(e, this.currentMaskFlags(t), r);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new G() : (this.isFilled = !0, new G({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new G();
  }
  extractTail(e, t) {
    return this.masked.extractTail(e, t);
  }
  appendTail(e) {
    return this.masked.appendTail(e);
  }
  extractInput(e, t, r) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.value.length), this.masked.extractInput(e, t, r);
  }
  nearestInputPos(e, t) {
    t === void 0 && (t = V.NONE);
    const r = 0, s = this.value.length, i = Math.min(Math.max(e, r), s);
    switch (t) {
      case V.LEFT:
      case V.FORCE_LEFT:
        return this.isComplete ? i : r;
      case V.RIGHT:
      case V.FORCE_RIGHT:
        return this.isComplete ? i : s;
      case V.NONE:
      default:
        return i;
    }
  }
  totalInputPositions(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.value.length), this.value.slice(e, t).length;
  }
  doValidate(e) {
    return this.masked.doValidate(this.currentMaskFlags(e)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(e)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
  currentMaskFlags(e) {
    var t;
    return {
      ...e,
      _beforeTailState: (e == null || (t = e._beforeTailState) == null ? void 0 : t.masked) || (e == null ? void 0 : e._beforeTailState)
    };
  }
  pad(e) {
    return new G();
  }
}
mr.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class Tb extends Ve {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const t = e.mask;
    t && (e.validate = (r) => r.search(t) >= 0), super._update(e);
  }
}
W.MaskedRegExp = Tb;
class Be extends Ve {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    super({
      ...Be.DEFAULTS,
      ...e,
      definitions: Object.assign({}, mr.DEFAULT_DEFINITIONS, e == null ? void 0 : e.definitions)
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const t = this.mask;
    if (!t || !e) return;
    let r = !1, s = !1;
    for (let i = 0; i < t.length; ++i) {
      if (this.blocks) {
        const u = t.slice(i), c = Object.keys(this.blocks).filter((f) => u.indexOf(f) === 0);
        c.sort((f, p) => p.length - f.length);
        const d = c[0];
        if (d) {
          const {
            expose: f,
            repeat: p,
            ...g
          } = Rn(this.blocks[d]), y = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...g,
            repeat: p,
            parent: this
          }, b = p != null ? new W.RepeatBlock(
            y
            /* TODO */
          ) : xt(y);
          b && (this._blocks.push(b), f && (this.exposeBlock = b), this._maskedBlocks[d] || (this._maskedBlocks[d] = []), this._maskedBlocks[d].push(this._blocks.length - 1)), i += d.length - 1;
          continue;
        }
      }
      let a = t[i], o = a in e;
      if (a === Be.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (a === "{" || a === "}") {
        r = !r;
        continue;
      }
      if (a === "[" || a === "]") {
        s = !s;
        continue;
      }
      if (a === Be.ESCAPE_CHAR) {
        if (++i, a = t[i], !a) break;
        o = !1;
      }
      const l = o ? new mr({
        isOptional: s,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...Rn(e[a]),
        parent: this
      }) : new Gu({
        char: a,
        eager: this.eager,
        isUnmasking: r
      });
      this._blocks.push(l);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((e) => e.state)
    };
  }
  set state(e) {
    if (!e) {
      this.reset();
      return;
    }
    const {
      _blocks: t,
      ...r
    } = e;
    this._blocks.forEach((s, i) => s.state = t[i]), super.state = r;
  }
  reset() {
    super.reset(), this._blocks.forEach((e) => e.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((e) => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every((e) => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every((e) => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every((e) => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach((e) => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((e, t) => e += t.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    if (this.exposeBlock) {
      const t = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = e, this.appendTail(t), this.doCommit();
    } else super.unmaskedValue = e;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((e, t) => e += t.value, "")
    );
  }
  set value(e) {
    if (this.exposeBlock) {
      const t = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = e, this.appendTail(t), this.doCommit();
    } else super.value = e;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(e) {
    if (this.exposeBlock) {
      const t = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = e, this.appendTail(t), this.doCommit();
    } else super.typedValue = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, t) => e += t.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const t = new G();
    let r = (e = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : e.index;
    if (r == null) return t;
    this._blocks[r].isFilled && ++r;
    for (let s = r; s < this._blocks.length; ++s) {
      const i = this._blocks[s]._appendEager();
      if (!i.inserted) break;
      t.aggregate(i);
    }
    return t;
  }
  _appendCharRaw(e, t) {
    t === void 0 && (t = {});
    const r = this._mapPosToBlock(this.displayValue.length), s = new G();
    if (!r) return s;
    for (let a = r.index, o; o = this._blocks[a]; ++a) {
      var i;
      const l = o._appendChar(e, {
        ...t,
        _beforeTailState: (i = t._beforeTailState) == null || (i = i._blocks) == null ? void 0 : i[a]
      });
      if (s.aggregate(l), l.consumed) break;
    }
    return s;
  }
  extractTail(e, t) {
    e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length);
    const r = new Yt();
    return e === t || this._forEachBlocksInRange(e, t, (s, i, a, o) => {
      const l = s.extractTail(a, o);
      l.stop = this._findStopBefore(i), l.from = this._blockStartPos(i), l instanceof Yt && (l.blockIndex = i), r.extend(l);
    }), r;
  }
  extractInput(e, t, r) {
    if (e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), r === void 0 && (r = {}), e === t) return "";
    let s = "";
    return this._forEachBlocksInRange(e, t, (i, a, o, l) => {
      s += i.extractInput(o, l, r);
    }), s;
  }
  _findStopBefore(e) {
    let t;
    for (let r = 0; r < this._stops.length; ++r) {
      const s = this._stops[r];
      if (s <= e) t = s;
      else break;
    }
    return t;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const t = new G();
    if (this.lazy && e == null) return t;
    const r = this._mapPosToBlock(this.displayValue.length);
    if (!r) return t;
    const s = r.index, i = e ?? this._blocks.length;
    return this._blocks.slice(s, i).forEach((a) => {
      if (!a.lazy || e != null) {
        var o;
        t.aggregate(a._appendPlaceholder((o = a._blocks) == null ? void 0 : o.length));
      }
    }), t;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let t = "";
    for (let r = 0; r < this._blocks.length; ++r) {
      const s = this._blocks[r], i = t.length;
      if (t += s.displayValue, e <= t.length)
        return {
          index: r,
          offset: e - i
        };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((t, r) => t += r.displayValue.length, 0);
  }
  _forEachBlocksInRange(e, t, r) {
    t === void 0 && (t = this.displayValue.length);
    const s = this._mapPosToBlock(e);
    if (s) {
      const i = this._mapPosToBlock(t), a = i && s.index === i.index, o = s.offset, l = i && a ? i.offset : this._blocks[s.index].displayValue.length;
      if (r(this._blocks[s.index], s.index, o, l), i && !a) {
        for (let u = s.index + 1; u < i.index; ++u)
          r(this._blocks[u], u, 0, this._blocks[u].displayValue.length);
        r(this._blocks[i.index], i.index, 0, i.offset);
      }
    }
  }
  remove(e, t) {
    e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length);
    const r = super.remove(e, t);
    return this._forEachBlocksInRange(e, t, (s, i, a, o) => {
      r.aggregate(s.remove(a, o));
    }), r;
  }
  nearestInputPos(e, t) {
    if (t === void 0 && (t = V.NONE), !this._blocks.length) return 0;
    const r = new xb(this, e);
    if (t === V.NONE)
      return r.pushRightBeforeInput() || (r.popState(), r.pushLeftBeforeInput()) ? r.pos : this.displayValue.length;
    if (t === V.LEFT || t === V.FORCE_LEFT) {
      if (t === V.LEFT) {
        if (r.pushRightBeforeFilled(), r.ok && r.pos === e) return e;
        r.popState();
      }
      if (r.pushLeftBeforeInput(), r.pushLeftBeforeRequired(), r.pushLeftBeforeFilled(), t === V.LEFT) {
        if (r.pushRightBeforeInput(), r.pushRightBeforeRequired(), r.ok && r.pos <= e || (r.popState(), r.ok && r.pos <= e)) return r.pos;
        r.popState();
      }
      return r.ok ? r.pos : t === V.FORCE_LEFT ? 0 : (r.popState(), r.ok || (r.popState(), r.ok) ? r.pos : 0);
    }
    return t === V.RIGHT || t === V.FORCE_RIGHT ? (r.pushRightBeforeInput(), r.pushRightBeforeRequired(), r.pushRightBeforeFilled() ? r.pos : t === V.FORCE_RIGHT ? this.displayValue.length : (r.popState(), r.ok || (r.popState(), r.ok) ? r.pos : this.nearestInputPos(e, V.LEFT))) : e;
  }
  totalInputPositions(e, t) {
    e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length);
    let r = 0;
    return this._forEachBlocksInRange(e, t, (s, i, a, o) => {
      r += s.totalInputPositions(a, o);
    }), r;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const t = this._maskedBlocks[e];
    return t ? t.map((r) => this._blocks[r]) : [];
  }
  pad(e) {
    const t = new G();
    return this._forEachBlocksInRange(0, this.displayValue.length, (r) => t.aggregate(r.pad(e))), t;
  }
}
Be.DEFAULTS = {
  ...Ve.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
Be.STOP_CHAR = "`";
Be.ESCAPE_CHAR = "\\";
Be.InputDefinition = mr;
Be.FixedDefinition = Gu;
W.MaskedPattern = Be;
class nr extends Be {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      to: t = this.to || 0,
      from: r = this.from || 0,
      maxLength: s = this.maxLength || 0,
      autofix: i = this.autofix,
      ...a
    } = e;
    this.to = t, this.from = r, this.maxLength = Math.max(String(t).length, s), this.autofix = i;
    const o = String(this.from).padStart(this.maxLength, "0"), l = String(this.to).padStart(this.maxLength, "0");
    let u = 0;
    for (; u < l.length && l[u] === o[u]; ) ++u;
    a.mask = l.slice(0, u).replace(/0/g, "\\0") + "0".repeat(this.maxLength - u), super._update(a);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let t = "", r = "";
    const [, s, i] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return i && (t = "0".repeat(s.length) + i, r = "9".repeat(s.length) + i), t = t.padEnd(this.maxLength, "0"), r = r.padEnd(this.maxLength, "9"), [t, r];
  }
  doPrepareChar(e, t) {
    t === void 0 && (t = {});
    let r;
    return [e, r] = super.doPrepareChar(e.replace(/\D/g, ""), t), e || (r.skip = !this.isComplete), [e, r];
  }
  _appendCharRaw(e, t) {
    if (t === void 0 && (t = {}), !this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(e, t);
    const r = String(this.from).padStart(this.maxLength, "0"), s = String(this.to).padStart(this.maxLength, "0"), [i, a] = this.boundaries(this.value + e);
    return Number(a) < this.from ? super._appendCharRaw(r[this.value.length], t) : Number(i) > this.to ? !t.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(r[this.value.length], t).aggregate(this._appendCharRaw(e, t)) : super._appendCharRaw(s[this.value.length], t) : super._appendCharRaw(e, t);
  }
  doValidate(e) {
    const t = this.value;
    if (t.search(/[^0]/) === -1 && t.length <= this._matchFrom) return !0;
    const [s, i] = this.boundaries(t);
    return this.from <= Number(i) && Number(s) <= this.to && super.doValidate(e);
  }
  pad(e) {
    const t = new G();
    if (this.value.length === this.maxLength) return t;
    const r = this.value, s = this.maxLength - this.value.length;
    if (s) {
      this.reset();
      for (let i = 0; i < s; ++i)
        t.aggregate(super._appendCharRaw("0", e));
      r.split("").forEach((i) => this._appendCharRaw(i));
    }
    return t;
  }
}
W.MaskedRange = nr;
const Cb = "d{.}`m{.}`Y";
class yt extends Be {
  static extractPatternOptions(e) {
    const {
      mask: t,
      pattern: r,
      ...s
    } = e;
    return {
      ...s,
      mask: St(t) ? t : r
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super(yt.extractPatternOptions({
      ...yt.DEFAULTS,
      ...e
    }));
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      mask: t,
      pattern: r,
      blocks: s,
      ...i
    } = {
      ...yt.DEFAULTS,
      ...e
    }, a = Object.assign({}, yt.GET_DEFAULT_BLOCKS());
    e.min && (a.Y.from = e.min.getFullYear()), e.max && (a.Y.to = e.max.getFullYear()), e.min && e.max && a.Y.from === a.Y.to && (a.m.from = e.min.getMonth() + 1, a.m.to = e.max.getMonth() + 1, a.m.from === a.m.to && (a.d.from = e.min.getDate(), a.d.to = e.max.getDate())), Object.assign(a, this.blocks, s), super._update({
      ...i,
      mask: St(t) ? t : r,
      blocks: a
    });
  }
  doValidate(e) {
    const t = this.date;
    return super.doValidate(e) && (!this.isComplete || this.isDateExist(this.value) && t != null && (this.min == null || this.min <= t) && (this.max == null || t <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
  optionsIsChanged(e) {
    return super.optionsIsChanged(yt.extractPatternOptions(e));
  }
}
yt.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: nr,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: nr,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: nr,
    from: 1900,
    to: 9999
  }
});
yt.DEFAULTS = {
  ...Be.DEFAULTS,
  mask: Date,
  pattern: Cb,
  format: (n, e) => {
    if (!n) return "";
    const t = String(n.getDate()).padStart(2, "0"), r = String(n.getMonth() + 1).padStart(2, "0"), s = n.getFullYear();
    return [t, r, s].join(".");
  },
  parse: (n, e) => {
    const [t, r, s] = n.split(".").map(Number);
    return new Date(s, r - 1, t);
  }
};
W.MaskedDate = yt;
class Nr extends Ve {
  constructor(e) {
    super({
      ...Nr.DEFAULTS,
      ...e
    }), this.currentMask = void 0;
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), "mask" in e && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(e.mask) ? e.mask.map((t) => {
      const {
        expose: r,
        ...s
      } = Rn(t), i = xt({
        overwrite: this._overwrite,
        eager: this._eager,
        skipInvalid: this._skipInvalid,
        ...s
      });
      return r && (this.exposeMask = i), i;
    }) : []);
  }
  _appendCharRaw(e, t) {
    t === void 0 && (t = {});
    const r = this._applyDispatch(e, t);
    return this.currentMask && r.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(t))), r;
  }
  _applyDispatch(e, t, r) {
    e === void 0 && (e = ""), t === void 0 && (t = {}), r === void 0 && (r = "");
    const s = t.tail && t._beforeTailState != null ? t._beforeTailState._value : this.value, i = this.rawInputValue, a = t.tail && t._beforeTailState != null ? t._beforeTailState._rawInputValue : i, o = i.slice(a.length), l = this.currentMask, u = new G(), c = l == null ? void 0 : l.state;
    return this.currentMask = this.doDispatch(e, {
      ...t
    }, r), this.currentMask && (this.currentMask !== l ? (this.currentMask.reset(), a && (this.currentMask.append(a, {
      raw: !0
    }), u.tailShift = this.currentMask.value.length - s.length), o && (u.tailShift += this.currentMask.append(o, {
      raw: !0,
      tail: !0
    }).tailShift)) : c && (this.currentMask.state = c)), u;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  _appendEager() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  appendTail(e) {
    const t = new G();
    return e && t.aggregate(this._applyDispatch("", {}, e)), t.aggregate(this.currentMask ? this.currentMask.appendTail(e) : super.appendTail(e));
  }
  currentMaskFlags(e) {
    var t, r;
    return {
      ...e,
      _beforeTailState: ((t = e._beforeTailState) == null ? void 0 : t.currentMaskRef) === this.currentMask && ((r = e._beforeTailState) == null ? void 0 : r.currentMask) || e._beforeTailState
    };
  }
  doDispatch(e, t, r) {
    return t === void 0 && (t = {}), r === void 0 && (r = ""), this.dispatch(e, this, t, r);
  }
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  doPrepare(e, t) {
    t === void 0 && (t = {});
    let [r, s] = super.doPrepare(e, t);
    if (this.currentMask) {
      let i;
      [r, i] = super.doPrepare(r, this.currentMaskFlags(t)), s = s.aggregate(i);
    }
    return [r, s];
  }
  doPrepareChar(e, t) {
    t === void 0 && (t = {});
    let [r, s] = super.doPrepareChar(e, t);
    if (this.currentMask) {
      let i;
      [r, i] = super.doPrepareChar(r, this.currentMaskFlags(t)), s = s.aggregate(i);
    }
    return [r, s];
  }
  reset() {
    var e;
    (e = this.currentMask) == null || e.reset(), this.compiledMasks.forEach((t) => t.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    this.exposeMask ? (this.exposeMask.value = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = e;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = e;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(e) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = e, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let t = String(e);
    this.currentMask && (this.currentMask.typedValue = e, t = this.currentMask.unmaskedValue), this.unmaskedValue = t;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var e;
    return !!((e = this.currentMask) != null && e.isComplete);
  }
  get isFilled() {
    var e;
    return !!((e = this.currentMask) != null && e.isFilled);
  }
  remove(e, t) {
    const r = new G();
    return this.currentMask && r.aggregate(this.currentMask.remove(e, t)).aggregate(this._applyDispatch()), r;
  }
  get state() {
    var e;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((t) => t.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) == null ? void 0 : e.state
    };
  }
  set state(e) {
    const {
      compiledMasks: t,
      currentMaskRef: r,
      currentMask: s,
      ...i
    } = e;
    t && this.compiledMasks.forEach((a, o) => a.state = t[o]), r != null && (this.currentMask = r, this.currentMask.state = s), super.state = i;
  }
  extractInput(e, t, r) {
    return this.currentMask ? this.currentMask.extractInput(e, t, r) : "";
  }
  extractTail(e, t) {
    return this.currentMask ? this.currentMask.extractTail(e, t) : super.extractTail(e, t);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(e, t) {
    return this.currentMask ? this.currentMask.nearestInputPos(e, t) : super.nearestInputPos(e, t);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(e) {
    this._overwrite = e;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(e) {
    this._eager = e;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(e) {
    this._skipInvalid = e;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(e) {
    this._autofix = e;
  }
  maskEquals(e) {
    return Array.isArray(e) ? this.compiledMasks.every((t, r) => {
      if (!e[r]) return;
      const {
        mask: s,
        ...i
      } = e[r];
      return pr(t, i) && t.maskEquals(s);
    }) : super.maskEquals(e);
  }
  typedValueEquals(e) {
    var t;
    return !!((t = this.currentMask) != null && t.typedValueEquals(e));
  }
}
Nr.DEFAULTS = {
  ...Ve.DEFAULTS,
  dispatch: (n, e, t, r) => {
    if (!e.compiledMasks.length) return;
    const s = e.rawInputValue, i = e.compiledMasks.map((a, o) => {
      const l = e.currentMask === a, u = l ? a.displayValue.length : a.nearestInputPos(a.displayValue.length, V.FORCE_LEFT);
      return a.rawInputValue !== s ? (a.reset(), a.append(s, {
        raw: !0
      })) : l || a.remove(u), a.append(n, e.currentMaskFlags(t)), a.appendTail(r), {
        index: o,
        weight: a.rawInputValue.length,
        totalInputPositions: a.totalInputPositions(0, Math.max(u, a.nearestInputPos(a.displayValue.length, V.FORCE_LEFT)))
      };
    });
    return i.sort((a, o) => o.weight - a.weight || o.totalInputPositions - a.totalInputPositions), e.compiledMasks[i[0].index];
  }
};
W.MaskedDynamic = Nr;
class Or extends Be {
  constructor(e) {
    super({
      ...Or.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      enum: t,
      ...r
    } = e;
    if (t) {
      const s = t.map((o) => o.length), i = Math.min(...s), a = Math.max(...s) - i;
      r.mask = "*".repeat(i), a && (r.mask += "[" + "*".repeat(a) + "]"), this.enum = t;
    }
    super._update(r);
  }
  _appendCharRaw(e, t) {
    t === void 0 && (t = {});
    const r = Math.min(this.nearestInputPos(0, V.FORCE_RIGHT), this.value.length), s = this.enum.filter((i) => this.matchValue(i, this.unmaskedValue + e, r));
    if (s.length) {
      s.length === 1 && this._forEachBlocksInRange(0, this.value.length, (a, o) => {
        const l = s[0][o];
        o >= this.value.length || l === a.value || (a.reset(), a._appendChar(l, t));
      });
      const i = super._appendCharRaw(s[0][this.value.length], t);
      return s.length === 1 && s[0].slice(this.unmaskedValue.length).split("").forEach((a) => i.aggregate(super._appendCharRaw(a))), i;
    }
    return new G({
      skip: !this.isComplete
    });
  }
  extractTail(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), new lt("", e);
  }
  remove(e, t) {
    if (e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), e === t) return new G();
    const r = Math.min(super.nearestInputPos(0, V.FORCE_RIGHT), this.value.length);
    let s;
    for (s = e; s >= 0 && !(this.enum.filter((o) => this.matchValue(o, this.value.slice(r, s), r)).length > 1); --s)
      ;
    const i = super.remove(s, t);
    return i.tailShift += s - e, i;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
Or.DEFAULTS = {
  ...Be.DEFAULTS,
  matchValue: (n, e, t) => n.indexOf(e, t) === t
};
W.MaskedEnum = Or;
class Mb extends Ve {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update({
      ...e,
      validate: e.mask
    });
  }
}
W.MaskedFunction = Mb;
var Ku;
class Ue extends Ve {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super({
      ...Ue.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  _updateRegExps() {
    const e = "^" + (this.allowNegative ? "[+|\\-]?" : ""), t = "\\d*", r = (this.scale ? "(" + ns(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(e + t + r), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(ns).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(ns(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(e) {
    const t = e.split(this.radix);
    return t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), t.join(this.radix);
  }
  doPrepareChar(e, t) {
    t === void 0 && (t = {});
    const [r, s] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (t.input && t.raw || !t.input && !t.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e), t);
    return e && !r && (s.skip = !0), r && !this.allowPositive && !this.value && r !== "-" && s.aggregate(this._appendChar("-")), [r, s];
  }
  _separatorsCount(e, t) {
    t === void 0 && (t = !1);
    let r = 0;
    for (let s = 0; s < e; ++s)
      this._value.indexOf(this.thousandsSeparator, s) === s && (++r, t && (e += this.thousandsSeparator.length));
    return r;
  }
  _separatorsCountFromSlice(e) {
    return e === void 0 && (e = this._value), this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  extractInput(e, t, r) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), [e, t] = this._adjustRangeWithSeparators(e, t), this._removeThousandsSeparators(super.extractInput(e, t, r));
  }
  _appendCharRaw(e, t) {
    t === void 0 && (t = {});
    const r = t.tail && t._beforeTailState ? t._beforeTailState._value : this._value, s = this._separatorsCountFromSlice(r);
    this._value = this._removeThousandsSeparators(this.value);
    const i = this._value;
    this._value += e;
    const a = this.number;
    let o = !isNaN(a), l = !1;
    if (o) {
      let f;
      this.min != null && this.min < 0 && this.number < this.min && (f = this.min), this.max != null && this.max > 0 && this.number > this.max && (f = this.max), f != null && (this.autofix ? (this._value = this.format(f, this).replace(Ue.UNMASKED_RADIX, this.radix), l || (l = i === this._value && !t.tail)) : o = !1), o && (o = !!this._value.match(this._numberRegExp));
    }
    let u;
    o ? u = new G({
      inserted: this._value.slice(i.length),
      rawInserted: l ? "" : e,
      skip: l
    }) : (this._value = i, u = new G()), this._value = this._insertThousandsSeparators(this._value);
    const c = t.tail && t._beforeTailState ? t._beforeTailState._value : this._value, d = this._separatorsCountFromSlice(c);
    return u.tailShift += (d - s) * this.thousandsSeparator.length, u;
  }
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const t = e - this.thousandsSeparator.length + 1, r = this.value.indexOf(this.thousandsSeparator, t);
      if (r <= e) return r;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, t) {
    const r = this._findSeparatorAround(e);
    r >= 0 && (e = r);
    const s = this._findSeparatorAround(t);
    return s >= 0 && (t = s + this.thousandsSeparator.length), [e, t];
  }
  remove(e, t) {
    e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), [e, t] = this._adjustRangeWithSeparators(e, t);
    const r = this.value.slice(0, e), s = this.value.slice(t), i = this._separatorsCount(r.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(r + s));
    const a = this._separatorsCountFromSlice(r);
    return new G({
      tailShift: (a - i) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(e, t) {
    if (!this.thousandsSeparator) return e;
    switch (t) {
      case V.NONE:
      case V.LEFT:
      case V.FORCE_LEFT: {
        const r = this._findSeparatorAround(e - 1);
        if (r >= 0) {
          const s = r + this.thousandsSeparator.length;
          if (e < s || this.value.length <= s || t === V.FORCE_LEFT)
            return r;
        }
        break;
      }
      case V.RIGHT:
      case V.FORCE_RIGHT: {
        const r = this._findSeparatorAround(e);
        if (r >= 0)
          return r + this.thousandsSeparator.length;
      }
    }
    return e;
  }
  doCommit() {
    if (this.value) {
      const e = this.number;
      let t = e;
      this.min != null && (t = Math.max(t, this.min)), this.max != null && (t = Math.min(t, this.max)), t !== e && (this.unmaskedValue = this.format(t, this));
      let r = this.value;
      this.normalizeZeros && (r = this._normalizeZeros(r)), this.padFractionalZeros && this.scale > 0 && (r = this._padFractionalZeros(r)), this._value = r;
    }
    super.doCommit();
  }
  _normalizeZeros(e) {
    const t = this._removeThousandsSeparators(e).split(this.radix);
    return t[0] = t[0].replace(/^(\D*)(0*)(\d*)/, (r, s, i, a) => s + a), e.length && !/\d$/.test(t[0]) && (t[0] = t[0] + "0"), t.length > 1 && (t[1] = t[1].replace(/0*$/, ""), t[1].length || (t.length = 1)), this._insertThousandsSeparators(t.join(this.radix));
  }
  _padFractionalZeros(e) {
    if (!e) return e;
    const t = e.split(this.radix);
    return t.length < 2 && t.push(""), t[1] = t[1].padEnd(this.scale, "0"), t.join(this.radix);
  }
  doSkipInvalid(e, t, r) {
    t === void 0 && (t = {});
    const s = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === Ue.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, t, r) && !s;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, Ue.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(e) {
    this.rawInputValue = this.format(e, this).replace(Ue.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || Ue.EMPTY_VALUES.includes(e) && Ue.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
Ku = Ue;
Ue.UNMASKED_RADIX = ".";
Ue.EMPTY_VALUES = [...Ve.EMPTY_VALUES, 0];
Ue.DEFAULTS = {
  ...Ve.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [Ku.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (n) => n.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
W.MaskedNumber = Ue;
const Ss = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function Xu(n, e, t) {
  e === void 0 && (e = Ss.MASKED), t === void 0 && (t = Ss.MASKED);
  const r = xt(n);
  return (s) => r.runIsolated((i) => (i[e] = s, i[t]));
}
function Db(n, e, t, r) {
  return Xu(e, t, r)(n);
}
W.PIPE_TYPE = Ss;
W.createPipe = Xu;
W.pipe = Db;
class Eb extends Be {
  get repeatFrom() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? e : 0;
  }
  get repeatTo() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? e : 1 / 0;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    var t, r, s;
    const {
      repeat: i,
      ...a
    } = Rn(e);
    this._blockOpts = Object.assign({}, this._blockOpts, a);
    const o = xt(this._blockOpts);
    this.repeat = (t = (r = i ?? o.repeat) != null ? r : this.repeat) != null ? t : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((s = this._blocks) == null ? void 0 : s.length) || 0, this.repeatFrom)),
      blocks: {
        m: o
      },
      eager: o.eager,
      overwrite: o.overwrite,
      skipInvalid: o.skipInvalid,
      lazy: o.lazy,
      placeholderChar: o.placeholderChar,
      displayChar: o.displayChar
    });
  }
  _allocateBlock(e) {
    if (e < this._blocks.length) return this._blocks[e];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo)
      return this._blocks.push(xt(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(e, t) {
    t === void 0 && (t = {});
    const r = new G();
    for (
      let l = (s = (i = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : i.index) != null ? s : Math.max(this._blocks.length - 1, 0), u, c;
      // try to get a block or
      // try to allocate a new block if not allocated already
      u = (a = this._blocks[l]) != null ? a : c = !c && this._allocateBlock(l);
      ++l
    ) {
      var s, i, a, o;
      const d = u._appendChar(e, {
        ...t,
        _beforeTailState: (o = t._beforeTailState) == null || (o = o._blocks) == null ? void 0 : o[l]
      });
      if (d.skip && c) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (r.aggregate(d), d.consumed) break;
    }
    return r;
  }
  _trimEmptyTail(e, t) {
    var r, s;
    e === void 0 && (e = 0);
    const i = Math.max(((r = this._mapPosToBlock(e)) == null ? void 0 : r.index) || 0, this.repeatFrom, 0);
    let a;
    t != null && (a = (s = this._mapPosToBlock(t)) == null ? void 0 : s.index), a == null && (a = this._blocks.length - 1);
    let o = 0;
    for (let l = a; i <= l && !this._blocks[l].unmaskedValue; --l, ++o)
      ;
    o && (this._blocks.splice(a - o + 1, o), this.mask = this.mask.slice(o));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(e, t) {
    e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length);
    const r = super.remove(e, t);
    return this._trimEmptyTail(e, t), r;
  }
  totalInputPositions(e, t) {
    return e === void 0 && (e = 0), t == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(e, t);
  }
  get state() {
    return super.state;
  }
  set state(e) {
    this._blocks.length = e._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = e;
  }
}
W.RepeatBlock = Eb;
try {
  globalThis.IMask = W;
} catch {
}
function Ab(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Ns = { exports: {} }, Qn = { exports: {} }, se = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var To;
function Pb() {
  if (To) return se;
  To = 1;
  var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, s = n ? Symbol.for("react.strict_mode") : 60108, i = n ? Symbol.for("react.profiler") : 60114, a = n ? Symbol.for("react.provider") : 60109, o = n ? Symbol.for("react.context") : 60110, l = n ? Symbol.for("react.async_mode") : 60111, u = n ? Symbol.for("react.concurrent_mode") : 60111, c = n ? Symbol.for("react.forward_ref") : 60112, d = n ? Symbol.for("react.suspense") : 60113, f = n ? Symbol.for("react.suspense_list") : 60120, p = n ? Symbol.for("react.memo") : 60115, g = n ? Symbol.for("react.lazy") : 60116, y = n ? Symbol.for("react.block") : 60121, b = n ? Symbol.for("react.fundamental") : 60117, k = n ? Symbol.for("react.responder") : 60118, w = n ? Symbol.for("react.scope") : 60119;
  function m(v) {
    if (typeof v == "object" && v !== null) {
      var x = v.$$typeof;
      switch (x) {
        case e:
          switch (v = v.type, v) {
            case l:
            case u:
            case r:
            case i:
            case s:
            case d:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case o:
                case c:
                case g:
                case p:
                case a:
                  return v;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  function _(v) {
    return m(v) === u;
  }
  return se.AsyncMode = l, se.ConcurrentMode = u, se.ContextConsumer = o, se.ContextProvider = a, se.Element = e, se.ForwardRef = c, se.Fragment = r, se.Lazy = g, se.Memo = p, se.Portal = t, se.Profiler = i, se.StrictMode = s, se.Suspense = d, se.isAsyncMode = function(v) {
    return _(v) || m(v) === l;
  }, se.isConcurrentMode = _, se.isContextConsumer = function(v) {
    return m(v) === o;
  }, se.isContextProvider = function(v) {
    return m(v) === a;
  }, se.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, se.isForwardRef = function(v) {
    return m(v) === c;
  }, se.isFragment = function(v) {
    return m(v) === r;
  }, se.isLazy = function(v) {
    return m(v) === g;
  }, se.isMemo = function(v) {
    return m(v) === p;
  }, se.isPortal = function(v) {
    return m(v) === t;
  }, se.isProfiler = function(v) {
    return m(v) === i;
  }, se.isStrictMode = function(v) {
    return m(v) === s;
  }, se.isSuspense = function(v) {
    return m(v) === d;
  }, se.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === r || v === u || v === i || v === s || v === d || v === f || typeof v == "object" && v !== null && (v.$$typeof === g || v.$$typeof === p || v.$$typeof === a || v.$$typeof === o || v.$$typeof === c || v.$$typeof === b || v.$$typeof === k || v.$$typeof === w || v.$$typeof === y);
  }, se.typeOf = m, se;
}
var ie = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Co;
function Sb() {
  return Co || (Co = 1, process.env.NODE_ENV !== "production" && function() {
    var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, s = n ? Symbol.for("react.strict_mode") : 60108, i = n ? Symbol.for("react.profiler") : 60114, a = n ? Symbol.for("react.provider") : 60109, o = n ? Symbol.for("react.context") : 60110, l = n ? Symbol.for("react.async_mode") : 60111, u = n ? Symbol.for("react.concurrent_mode") : 60111, c = n ? Symbol.for("react.forward_ref") : 60112, d = n ? Symbol.for("react.suspense") : 60113, f = n ? Symbol.for("react.suspense_list") : 60120, p = n ? Symbol.for("react.memo") : 60115, g = n ? Symbol.for("react.lazy") : 60116, y = n ? Symbol.for("react.block") : 60121, b = n ? Symbol.for("react.fundamental") : 60117, k = n ? Symbol.for("react.responder") : 60118, w = n ? Symbol.for("react.scope") : 60119;
    function m(N) {
      return typeof N == "string" || typeof N == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      N === r || N === u || N === i || N === s || N === d || N === f || typeof N == "object" && N !== null && (N.$$typeof === g || N.$$typeof === p || N.$$typeof === a || N.$$typeof === o || N.$$typeof === c || N.$$typeof === b || N.$$typeof === k || N.$$typeof === w || N.$$typeof === y);
    }
    function _(N) {
      if (typeof N == "object" && N !== null) {
        var Ke = N.$$typeof;
        switch (Ke) {
          case e:
            var ft = N.type;
            switch (ft) {
              case l:
              case u:
              case r:
              case i:
              case s:
              case d:
                return ft;
              default:
                var pt = ft && ft.$$typeof;
                switch (pt) {
                  case o:
                  case c:
                  case g:
                  case p:
                  case a:
                    return pt;
                  default:
                    return Ke;
                }
            }
          case t:
            return Ke;
        }
      }
    }
    var v = l, x = u, P = o, R = a, B = e, ue = c, ae = r, $ = g, Te = p, ke = t, Se = i, we = s, E = d, A = !1;
    function Ee(N) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(N) || _(N) === l;
    }
    function M(N) {
      return _(N) === u;
    }
    function D(N) {
      return _(N) === o;
    }
    function Q(N) {
      return _(N) === a;
    }
    function q(N) {
      return typeof N == "object" && N !== null && N.$$typeof === e;
    }
    function Y(N) {
      return _(N) === c;
    }
    function ee(N) {
      return _(N) === r;
    }
    function U(N) {
      return _(N) === g;
    }
    function z(N) {
      return _(N) === p;
    }
    function X(N) {
      return _(N) === t;
    }
    function te(N) {
      return _(N) === i;
    }
    function J(N) {
      return _(N) === s;
    }
    function me(N) {
      return _(N) === d;
    }
    ie.AsyncMode = v, ie.ConcurrentMode = x, ie.ContextConsumer = P, ie.ContextProvider = R, ie.Element = B, ie.ForwardRef = ue, ie.Fragment = ae, ie.Lazy = $, ie.Memo = Te, ie.Portal = ke, ie.Profiler = Se, ie.StrictMode = we, ie.Suspense = E, ie.isAsyncMode = Ee, ie.isConcurrentMode = M, ie.isContextConsumer = D, ie.isContextProvider = Q, ie.isElement = q, ie.isForwardRef = Y, ie.isFragment = ee, ie.isLazy = U, ie.isMemo = z, ie.isPortal = X, ie.isProfiler = te, ie.isStrictMode = J, ie.isSuspense = me, ie.isValidElementType = m, ie.typeOf = _;
  }()), ie;
}
var Mo;
function Qu() {
  return Mo || (Mo = 1, process.env.NODE_ENV === "production" ? Qn.exports = Pb() : Qn.exports = Sb()), Qn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var rs, Do;
function Nb() {
  if (Do) return rs;
  Do = 1;
  var n = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, o = 0; o < 10; o++)
        a["_" + String.fromCharCode(o)] = o;
      var l = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return rs = s() ? Object.assign : function(i, a) {
    for (var o, l = r(i), u, c = 1; c < arguments.length; c++) {
      o = Object(arguments[c]);
      for (var d in o)
        e.call(o, d) && (l[d] = o[d]);
      if (n) {
        u = n(o);
        for (var f = 0; f < u.length; f++)
          t.call(o, u[f]) && (l[u[f]] = o[u[f]]);
      }
    }
    return l;
  }, rs;
}
var ss, Eo;
function Fi() {
  if (Eo) return ss;
  Eo = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ss = n, ss;
}
var is, Ao;
function Zu() {
  return Ao || (Ao = 1, is = Function.call.bind(Object.prototype.hasOwnProperty)), is;
}
var as, Po;
function Ob() {
  if (Po) return as;
  Po = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Fi(), t = {}, r = Zu();
    n = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function s(i, a, o, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i)
        if (r(i, c)) {
          var d;
          try {
            if (typeof i[c] != "function") {
              var f = Error(
                (l || "React class") + ": " + o + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[c](a, c, l, o, null, e);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && n(
            (l || "React class") + ": type specification of " + o + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var p = u ? u() : "";
            n(
              "Failed " + o + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, as = s, as;
}
var os, So;
function Fb() {
  if (So) return os;
  So = 1;
  var n = Qu(), e = Nb(), t = Fi(), r = Zu(), s = Ob(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(o) {
    var l = "Warning: " + o;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return os = function(o, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(M) {
      var D = M && (u && M[u] || M[c]);
      if (typeof D == "function")
        return D;
    }
    var f = "<<anonymous>>", p = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: w(),
      arrayOf: m,
      element: _(),
      elementType: v(),
      instanceOf: x,
      node: ue(),
      objectOf: R,
      oneOf: P,
      oneOfType: B,
      shape: $,
      exact: Te
    };
    function g(M, D) {
      return M === D ? M !== 0 || 1 / M === 1 / D : M !== M && D !== D;
    }
    function y(M, D) {
      this.message = M, this.data = D && typeof D == "object" ? D : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function b(M) {
      if (process.env.NODE_ENV !== "production")
        var D = {}, Q = 0;
      function q(ee, U, z, X, te, J, me) {
        if (X = X || f, J = J || z, me !== t) {
          if (l) {
            var N = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw N.name = "Invariant Violation", N;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ke = X + ":" + z;
            !D[Ke] && // Avoid spamming the console because they are often not actionable except for lib authors
            Q < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + J + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), D[Ke] = !0, Q++);
          }
        }
        return U[z] == null ? ee ? U[z] === null ? new y("The " + te + " `" + J + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new y("The " + te + " `" + J + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : M(U, z, X, te, J);
      }
      var Y = q.bind(null, !1);
      return Y.isRequired = q.bind(null, !0), Y;
    }
    function k(M) {
      function D(Q, q, Y, ee, U, z) {
        var X = Q[q], te = we(X);
        if (te !== M) {
          var J = E(X);
          return new y(
            "Invalid " + ee + " `" + U + "` of type " + ("`" + J + "` supplied to `" + Y + "`, expected ") + ("`" + M + "`."),
            { expectedType: M }
          );
        }
        return null;
      }
      return b(D);
    }
    function w() {
      return b(a);
    }
    function m(M) {
      function D(Q, q, Y, ee, U) {
        if (typeof M != "function")
          return new y("Property `" + U + "` of component `" + Y + "` has invalid PropType notation inside arrayOf.");
        var z = Q[q];
        if (!Array.isArray(z)) {
          var X = we(z);
          return new y("Invalid " + ee + " `" + U + "` of type " + ("`" + X + "` supplied to `" + Y + "`, expected an array."));
        }
        for (var te = 0; te < z.length; te++) {
          var J = M(z, te, Y, ee, U + "[" + te + "]", t);
          if (J instanceof Error)
            return J;
        }
        return null;
      }
      return b(D);
    }
    function _() {
      function M(D, Q, q, Y, ee) {
        var U = D[Q];
        if (!o(U)) {
          var z = we(U);
          return new y("Invalid " + Y + " `" + ee + "` of type " + ("`" + z + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(M);
    }
    function v() {
      function M(D, Q, q, Y, ee) {
        var U = D[Q];
        if (!n.isValidElementType(U)) {
          var z = we(U);
          return new y("Invalid " + Y + " `" + ee + "` of type " + ("`" + z + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(M);
    }
    function x(M) {
      function D(Q, q, Y, ee, U) {
        if (!(Q[q] instanceof M)) {
          var z = M.name || f, X = Ee(Q[q]);
          return new y("Invalid " + ee + " `" + U + "` of type " + ("`" + X + "` supplied to `" + Y + "`, expected ") + ("instance of `" + z + "`."));
        }
        return null;
      }
      return b(D);
    }
    function P(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function D(Q, q, Y, ee, U) {
        for (var z = Q[q], X = 0; X < M.length; X++)
          if (g(z, M[X]))
            return null;
        var te = JSON.stringify(M, function(me, N) {
          var Ke = E(N);
          return Ke === "symbol" ? String(N) : N;
        });
        return new y("Invalid " + ee + " `" + U + "` of value `" + String(z) + "` " + ("supplied to `" + Y + "`, expected one of " + te + "."));
      }
      return b(D);
    }
    function R(M) {
      function D(Q, q, Y, ee, U) {
        if (typeof M != "function")
          return new y("Property `" + U + "` of component `" + Y + "` has invalid PropType notation inside objectOf.");
        var z = Q[q], X = we(z);
        if (X !== "object")
          return new y("Invalid " + ee + " `" + U + "` of type " + ("`" + X + "` supplied to `" + Y + "`, expected an object."));
        for (var te in z)
          if (r(z, te)) {
            var J = M(z, te, Y, ee, U + "." + te, t);
            if (J instanceof Error)
              return J;
          }
        return null;
      }
      return b(D);
    }
    function B(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var D = 0; D < M.length; D++) {
        var Q = M[D];
        if (typeof Q != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + A(Q) + " at index " + D + "."
          ), a;
      }
      function q(Y, ee, U, z, X) {
        for (var te = [], J = 0; J < M.length; J++) {
          var me = M[J], N = me(Y, ee, U, z, X, t);
          if (N == null)
            return null;
          N.data && r(N.data, "expectedType") && te.push(N.data.expectedType);
        }
        var Ke = te.length > 0 ? ", expected one of type [" + te.join(", ") + "]" : "";
        return new y("Invalid " + z + " `" + X + "` supplied to " + ("`" + U + "`" + Ke + "."));
      }
      return b(q);
    }
    function ue() {
      function M(D, Q, q, Y, ee) {
        return ke(D[Q]) ? null : new y("Invalid " + Y + " `" + ee + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return b(M);
    }
    function ae(M, D, Q, q, Y) {
      return new y(
        (M || "React class") + ": " + D + " type `" + Q + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Y + "`."
      );
    }
    function $(M) {
      function D(Q, q, Y, ee, U) {
        var z = Q[q], X = we(z);
        if (X !== "object")
          return new y("Invalid " + ee + " `" + U + "` of type `" + X + "` " + ("supplied to `" + Y + "`, expected `object`."));
        for (var te in M) {
          var J = M[te];
          if (typeof J != "function")
            return ae(Y, ee, U, te, E(J));
          var me = J(z, te, Y, ee, U + "." + te, t);
          if (me)
            return me;
        }
        return null;
      }
      return b(D);
    }
    function Te(M) {
      function D(Q, q, Y, ee, U) {
        var z = Q[q], X = we(z);
        if (X !== "object")
          return new y("Invalid " + ee + " `" + U + "` of type `" + X + "` " + ("supplied to `" + Y + "`, expected `object`."));
        var te = e({}, Q[q], M);
        for (var J in te) {
          var me = M[J];
          if (r(M, J) && typeof me != "function")
            return ae(Y, ee, U, J, E(me));
          if (!me)
            return new y(
              "Invalid " + ee + " `" + U + "` key `" + J + "` supplied to `" + Y + "`.\nBad object: " + JSON.stringify(Q[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(M), null, "  ")
            );
          var N = me(z, J, Y, ee, U + "." + J, t);
          if (N)
            return N;
        }
        return null;
      }
      return b(D);
    }
    function ke(M) {
      switch (typeof M) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !M;
        case "object":
          if (Array.isArray(M))
            return M.every(ke);
          if (M === null || o(M))
            return !0;
          var D = d(M);
          if (D) {
            var Q = D.call(M), q;
            if (D !== M.entries) {
              for (; !(q = Q.next()).done; )
                if (!ke(q.value))
                  return !1;
            } else
              for (; !(q = Q.next()).done; ) {
                var Y = q.value;
                if (Y && !ke(Y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Se(M, D) {
      return M === "symbol" ? !0 : D ? D["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && D instanceof Symbol : !1;
    }
    function we(M) {
      var D = typeof M;
      return Array.isArray(M) ? "array" : M instanceof RegExp ? "object" : Se(D, M) ? "symbol" : D;
    }
    function E(M) {
      if (typeof M > "u" || M === null)
        return "" + M;
      var D = we(M);
      if (D === "object") {
        if (M instanceof Date)
          return "date";
        if (M instanceof RegExp)
          return "regexp";
      }
      return D;
    }
    function A(M) {
      var D = E(M);
      switch (D) {
        case "array":
        case "object":
          return "an " + D;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + D;
        default:
          return D;
      }
    }
    function Ee(M) {
      return !M.constructor || !M.constructor.name ? f : M.constructor.name;
    }
    return p.checkPropTypes = s, p.resetWarningCache = s.resetWarningCache, p.PropTypes = p, p;
  }, os;
}
var ls, No;
function Rb() {
  if (No) return ls;
  No = 1;
  var n = Fi();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, ls = function() {
    function r(a, o, l, u, c, d) {
      if (d !== n) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function s() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: s,
      element: r,
      elementType: r,
      instanceOf: s,
      node: r,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, ls;
}
if (process.env.NODE_ENV !== "production") {
  var Ib = Qu(), Vb = !0;
  Ns.exports = Fb()(Ib.isElement, Vb);
} else
  Ns.exports = Rb()();
var Bb = Ns.exports;
const I = /* @__PURE__ */ Ab(Bb), Ju = {
  // common
  mask: I.oneOfType([I.array, I.func, I.string, I.instanceOf(RegExp), I.oneOf([Date, Number, W.Masked]), I.instanceOf(W.Masked)]),
  value: I.any,
  unmask: I.oneOfType([I.bool, I.oneOf(["typed"])]),
  prepare: I.func,
  prepareChar: I.func,
  validate: I.func,
  commit: I.func,
  overwrite: I.oneOfType([I.bool, I.oneOf(["shift"])]),
  eager: I.oneOfType([I.bool, I.oneOf(["append", "remove"])]),
  skipInvalid: I.bool,
  // events
  onAccept: I.func,
  onComplete: I.func,
  // pattern
  placeholderChar: I.string,
  displayChar: I.string,
  lazy: I.bool,
  definitions: I.object,
  blocks: I.object,
  // enum
  enum: I.arrayOf(I.string),
  // range
  maxLength: I.number,
  from: I.number,
  to: I.number,
  // date
  pattern: I.string,
  format: I.func,
  parse: I.func,
  autofix: I.oneOfType([I.bool, I.oneOf(["pad"])]),
  // number
  radix: I.string,
  thousandsSeparator: I.string,
  mapToRadix: I.arrayOf(I.string),
  scale: I.number,
  normalizeZeros: I.bool,
  padFractionalZeros: I.bool,
  min: I.oneOfType([I.number, I.instanceOf(Date)]),
  max: I.oneOfType([I.number, I.instanceOf(Date)]),
  // dynamic
  dispatch: I.func,
  // ref
  inputRef: I.oneOfType([I.func, I.shape({
    current: I.object
  })])
}, ec = Object.keys(Ju).filter((n) => n !== "value"), Lb = ["value", "unmask", "onAccept", "onComplete", "inputRef"], jb = ec.filter((n) => Lb.indexOf(n) < 0);
function Wb(n) {
  var e;
  const t = (e = class extends jt.Component {
    constructor(i) {
      super(i), this._inputRef = this._inputRef.bind(this);
    }
    componentDidMount() {
      this.props.mask && this.initMask();
    }
    componentDidUpdate() {
      const i = this.props, a = this._extractMaskOptionsFromProps(i);
      if (a.mask)
        this.maskRef ? (this.maskRef.updateOptions(a), "value" in i && i.value !== void 0 && (this.maskValue = i.value)) : this.initMask(a);
      else if (this.destroyMask(), "value" in i && i.value !== void 0) {
        var o;
        (o = this.element) != null && o.isContentEditable && this.element.tagName !== "INPUT" && this.element.tagName !== "TEXTAREA" ? this.element.textContent = i.value : this.element.value = i.value;
      }
    }
    componentWillUnmount() {
      this.destroyMask();
    }
    _inputRef(i) {
      this.element = i, this.props.inputRef && (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current") ? this.props.inputRef.current = i : this.props.inputRef(i));
    }
    initMask(i) {
      i === void 0 && (i = this._extractMaskOptionsFromProps(this.props)), this.maskRef = W(this.element, i).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this)), "value" in this.props && this.props.value !== void 0 && (this.maskValue = this.props.value);
    }
    destroyMask() {
      this.maskRef && (this.maskRef.destroy(), delete this.maskRef);
    }
    _extractMaskOptionsFromProps(i) {
      const {
        ...a
      } = i;
      return Object.keys(a).filter((o) => jb.indexOf(o) < 0).forEach((o) => {
        delete a[o];
      }), a;
    }
    _extractNonMaskProps(i) {
      const {
        ...a
      } = i;
      return ec.forEach((o) => {
        o !== "maxLength" && delete a[o];
      }), "defaultValue" in a || (a.defaultValue = i.mask ? "" : a.value), delete a.value, a;
    }
    get maskValue() {
      return this.maskRef ? this.props.unmask === "typed" ? this.maskRef.typedValue : this.props.unmask ? this.maskRef.unmaskedValue : this.maskRef.value : "";
    }
    set maskValue(i) {
      this.maskRef && (i = i == null && this.props.unmask !== "typed" ? "" : i, this.props.unmask === "typed" ? this.maskRef.typedValue = i : this.props.unmask ? this.maskRef.unmaskedValue = i : this.maskRef.value = i);
    }
    _onAccept(i) {
      this.props.onAccept && this.maskRef && this.props.onAccept(this.maskValue, this.maskRef, i);
    }
    _onComplete(i) {
      this.props.onComplete && this.maskRef && this.props.onComplete(this.maskValue, this.maskRef, i);
    }
    render() {
      return jt.createElement(n, {
        ...this._extractNonMaskProps(this.props),
        inputRef: this._inputRef
      });
    }
  }, e.displayName = void 0, e.propTypes = void 0, e), r = n.displayName || n.name || "Component";
  return t.displayName = "IMask(" + r + ")", t.propTypes = Ju, jt.forwardRef((s, i) => jt.createElement(t, {
    ...s,
    ref: i
  }));
}
const Yb = Wb((n) => {
  let {
    inputRef: e,
    ...t
  } = n;
  return jt.createElement("input", {
    ...t,
    ref: e
  });
}), $b = (n, e) => jt.createElement(Yb, {
  ...n,
  ref: e
});
jt.forwardRef($b);
function tc(n, e) {
  let {
    onAccept: t,
    onComplete: r,
    ref: s = Ie(null),
    defaultValue: i,
    defaultUnmaskedValue: a,
    defaultTypedValue: o
  } = {};
  const l = Ie(null), [u, c] = Z({}), [d, f] = Z(""), [p, g] = Z(""), [y, b] = Z(), k = Pt(() => {
    var v;
    (v = l.current) == null || v.destroy(), l.current = null;
  }, []), w = Pt(() => {
    const v = l.current;
    v && (c({
      value: v.value,
      unmaskedValue: v.unmaskedValue,
      typedValue: v.typedValue
    }), b(v.typedValue), g(v.unmaskedValue), f(v.value));
  }, []), m = Pt((v) => {
    const x = l.current;
    x && (w(), t == null || t(x.value, x, v));
  }, [t]), _ = Pt((v) => l.current && (r == null ? void 0 : r(l.current.value, l.current, v)), [r]);
  return ve(() => {
    const {
      value: v,
      ...x
    } = u, P = l.current;
    !P || d === void 0 || (v !== d && (P.value = d, P.value !== d && m()), c(x));
  }, [d]), ve(() => {
    const {
      unmaskedValue: v,
      ...x
    } = u, P = l.current;
    !P || p === void 0 || (v !== p && (P.unmaskedValue = p, P.unmaskedValue !== p && m()), c(x));
  }, [p]), ve(() => {
    const {
      typedValue: v,
      ...x
    } = u, P = l.current;
    !P || y === void 0 || (v !== y && (P.typedValue = y, P.masked.typedValueEquals(y) || m()), c(x));
  }, [y]), ve(() => {
    const v = s.current;
    if (!v || !(n != null && n.mask)) return k();
    const x = l.current;
    x ? x == null || x.updateOptions(n) : v && n != null && n.mask && (l.current = W(v, n), w(), i !== void 0 && f(i), a !== void 0 && g(a), o !== void 0 && b(o));
  }, [n, k, m]), ve(() => {
    if (!l.current) return;
    const v = l.current;
    return v.on("accept", m), v.on("complete", _), () => {
      v.off("accept", m), v.off("complete", _);
    };
  }, [m, _]), ve(() => k, [k]), {
    ref: s,
    maskRef: l,
    value: d,
    setValue: f,
    unmaskedValue: p,
    setUnmaskedValue: g,
    typedValue: y,
    setTypedValue: b
  };
}
const zb = {
  cpf: "000.000.000-00",
  cnpj: "00.000.000/0000-00",
  phone: "(00) 00000-0000",
  cep: "00000-000",
  date: "00/00/0000"
}, Ub = le(
  ({ className: n, invalid: e, preset: t, mask: r, value: s, onValueChange: i, ...a }, o) => {
    const l = r ?? (t ? zb[t] : ""), { ref: u, value: c, setValue: d, unmaskedValue: f } = tc({ mask: l });
    ve(() => {
      s !== void 0 && s !== c && d(s);
    }, [s]);
    const p = Ie(s === void 0 || s === "");
    s !== void 0 && s === c && (p.current = !0), ve(() => {
      p.current && (i == null || i(c, f));
    }, [c, f]);
    const g = Dr({
      "aria-describedby": a["aria-describedby"],
      "aria-invalid": a["aria-invalid"],
      id: a.id,
      invalid: e
    });
    return /* @__PURE__ */ h(
      "input",
      {
        ref: (y) => {
          u.current = y, typeof o == "function" ? o(y) : o && (o.current = y);
        },
        className: S("akuna-control akuna-input", n),
        ...a,
        onInput: (y) => {
          var b;
          p.current = !0, (b = a.onInput) == null || b.call(a, y);
        },
        ...g
      }
    );
  }
);
Ub.displayName = "MaskedInput";
const Ri = le(
  ({ className: n, filled: e, inputSize: t, invalid: r, value: s, onValueChange: i, min: a, max: o, scale: l = 0, thousands: u = ".", radix: c = ",", ...d }, f) => {
    const { ref: p, value: g, unmaskedValue: y, setValue: b } = tc({
      mask: Number,
      scale: l,
      // sem isso o imask descarta os zeros finais que completamos ao sair do campo
      normalizeZeros: !1,
      thousandsSeparator: u,
      radix: c,
      min: a,
      max: o,
      mapToRadix: ["."]
    });
    ve(() => {
      const m = s === void 0 || Number.isNaN(s) ? "" : String(s).replace(".", c), _ = y === "" ? void 0 : Number(y.replace(c, "."));
      m !== g && _ !== s && b(m);
    }, [s]), ve(() => {
      i == null || i(y === "" ? null : Number(y.replace(c, ".")));
    }, [y]);
    const k = Dr({
      "aria-describedby": d["aria-describedby"],
      "aria-invalid": d["aria-invalid"],
      id: d.id,
      invalid: r
    }), w = (m) => {
      var _;
      if (l > 0 && y !== "") {
        const v = Number(y.replace(c, "."));
        Number.isFinite(v) && b(v.toFixed(l).replace(".", c));
      }
      (_ = d.onBlur) == null || _.call(d, m);
    };
    return /* @__PURE__ */ h(
      "input",
      {
        ref: (m) => {
          p.current = m, typeof f == "function" ? f(m) : f && (f.current = m);
        },
        inputMode: "decimal",
        className: S("akuna-control akuna-input", n),
        ...d,
        onBlur: w,
        ...k
      }
    );
  }
);
Ri.displayName = "NumberInput";
const Hb = le(
  ({ className: n, currencySymbol: e = "R$", min: t = 0, ...r }, s) => /* @__PURE__ */ T("div", { className: S("akuna-affix-input", n), "data-invalid": r.invalid || void 0, children: [
    /* @__PURE__ */ h("span", { className: "akuna-affix-input__prefix", "aria-hidden": "true", children: e }),
    /* @__PURE__ */ h(Ri, { ref: s, scale: 2, min: t, className: "akuna-affix-input__control", ...r })
  ] })
);
Hb.displayName = "CurrencyInput";
const qb = le(({ className: n, ...e }, t) => /* @__PURE__ */ T("div", { className: S("akuna-affix-input", n), "data-invalid": e.invalid || void 0, children: [
  /* @__PURE__ */ h(Ri, { ref: t, scale: 2, min: 0, max: 100, className: "akuna-affix-input__control akuna-affix-input__control--end", ...e }),
  /* @__PURE__ */ h("span", { className: "akuna-affix-input__suffix", "aria-hidden": "true", children: "%" })
] }));
qb.displayName = "PercentInput";
function Rk({ className: n, label: e, name: t, onValueChange: r, options: s, value: i }) {
  const a = Tt(), [o, l] = Z(i ?? ""), u = i ?? o;
  return /* @__PURE__ */ T("fieldset", { className: S("akuna-radio-group", n), children: [
    /* @__PURE__ */ h("legend", { className: "akuna-field__label", children: e }),
    /* @__PURE__ */ h("div", { className: "akuna-radio-group__options", children: s.map((c) => /* @__PURE__ */ T("label", { className: "akuna-choice", children: [
      /* @__PURE__ */ h(
        "input",
        {
          checked: u === c.value,
          className: "akuna-choice__native",
          disabled: c.disabled,
          name: t ?? a,
          onChange: () => {
            l(c.value), r == null || r(c.value);
          },
          type: "radio",
          value: c.value
        }
      ),
      /* @__PURE__ */ h("span", { "aria-hidden": "true", className: "akuna-choice__radio" }),
      /* @__PURE__ */ h("span", { className: "akuna-choice__label", children: c.label })
    ] }, c.value)) })
  ] });
}
const Gb = le(({ className: n, clearLabel: e, filled: t, inputSize: r, label: s, onClear: i, value: a, ...o }, l) => {
  const u = a != null && String(a).length > 0;
  return /* @__PURE__ */ T("div", { className: S("akuna-search-field", n), children: [
    /* @__PURE__ */ h(zo, { "aria-hidden": "true", className: "akuna-search-field__icon", size: 18 }),
    /* @__PURE__ */ h(
      Er,
      {
        ref: l,
        "aria-label": s,
        className: "akuna-search-field__input",
        value: a,
        ...o
      }
    ),
    u ? /* @__PURE__ */ h(Ni, { className: "akuna-search-field__clear", label: e, onClick: i, size: "sm", type: "button", variant: "ghost", children: /* @__PURE__ */ h(yr, { "aria-hidden": "true", size: 16 }) }) : null
  ] });
});
Gb.displayName = "SearchField";
const Kb = le(({ className: n, label: e, placeholder: t, value: r, ...s }, i) => {
  const a = r != null && r.length > 0;
  return /* @__PURE__ */ T(
    "button",
    {
      ref: i,
      type: "button",
      "aria-label": e,
      className: S("akuna-search-field akuna-search-field--trigger", n),
      ...s,
      children: [
        /* @__PURE__ */ h(zo, { "aria-hidden": "true", className: "akuna-search-field__icon", size: 18 }),
        /* @__PURE__ */ h("span", { className: S("akuna-control akuna-input akuna-search-field__trigger-value", !a && "akuna-search-field__trigger-value--placeholder"), children: a ? r : t })
      ]
    }
  );
});
Kb.displayName = "SearchFieldTrigger";
const Xb = le(
  ({ className: n, id: e, label: t, onValueChange: r, options: s, placeholder: i, forceNative: a, renderOption: o, value: l, defaultValue: u, disabled: c, ...d }, f) => {
    const p = Tt(), g = e ?? `akuna-select-${p}`, y = !!a, [b, k] = Z(() => String(l ?? u ?? "")), w = l != null, m = String(w ? l : b), _ = He(
      () => {
        var v;
        return (v = s.find((x) => x.value === m)) == null ? void 0 : v.label;
      },
      [m, s]
    );
    return ve(() => {
      w && k(String(l ?? ""));
    }, [w, l]), y ? /* @__PURE__ */ T(on, { id: g, children: [
      /* @__PURE__ */ h(ln, { children: t }),
      /* @__PURE__ */ T("div", { className: S("akuna-control akuna-native-select-trigger", n), "data-disabled": c ? "" : void 0, children: [
        /* @__PURE__ */ h("span", { className: S("akuna-native-select-trigger__value", !_ && "akuna-native-select-trigger__placeholder"), children: _ ?? i }),
        /* @__PURE__ */ h(sr, { "aria-hidden": !0, className: "akuna-select-trigger__icon", size: 16 }),
        /* @__PURE__ */ T(
          "select",
          {
            ref: f,
            className: "akuna-native-select",
            id: g,
            value: w ? l : b,
            disabled: c,
            "aria-label": t,
            onChange: (v) => {
              w || k(v.currentTarget.value), r == null || r(v.currentTarget.value);
            },
            ...d,
            children: [
              i ? /* @__PURE__ */ h("option", { value: "", disabled: !0, children: i }) : null,
              s.map((v) => /* @__PURE__ */ h("option", { disabled: v.disabled, value: v.value, children: v.label }, v.value))
            ]
          }
        )
      ] })
    ] }) : /* @__PURE__ */ T(on, { id: g, children: [
      /* @__PURE__ */ h(ln, { children: t }),
      /* @__PURE__ */ T(
        nt.Root,
        {
          value: l,
          defaultValue: u,
          disabled: c,
          onValueChange: r,
          children: [
            /* @__PURE__ */ T(
              nt.Trigger,
              {
                id: g,
                "aria-label": t,
                className: S("akuna-control akuna-select-trigger", n),
                children: [
                  /* @__PURE__ */ h(nt.Value, { placeholder: i }),
                  /* @__PURE__ */ h(nt.Icon, { className: "akuna-select-trigger__icon", children: /* @__PURE__ */ h(sr, { "aria-hidden": !0, size: 16 }) })
                ]
              }
            ),
            /* @__PURE__ */ h(nt.Portal, { children: /* @__PURE__ */ h(nt.Content, { className: "akuna-select-content", position: "popper", sideOffset: 6, collisionPadding: 8, children: /* @__PURE__ */ h(nt.Viewport, { className: "akuna-select-viewport", children: s.map((v) => /* @__PURE__ */ T(
              nt.Item,
              {
                value: v.value,
                disabled: v.disabled,
                className: "akuna-select-item",
                children: [
                  /* @__PURE__ */ h(nt.ItemText, { children: o ? o(v) : v.label }),
                  /* @__PURE__ */ h(nt.ItemIndicator, { className: "akuna-select-item__indicator", children: /* @__PURE__ */ h(vr, { "aria-hidden": !0, size: 16 }) })
                ]
              },
              v.value
            )) }) }) })
          ]
        }
      )
    ] });
  }
);
Xb.displayName = "Select";
function Ik({ className: n, description: e, disabled: t = !1, icon: r, onSelect: s, selected: i = !1, title: a }) {
  const o = [a, e].filter((l) => typeof l == "string").join(" ");
  return /* @__PURE__ */ T(
    "button",
    {
      "aria-checked": i,
      "aria-label": o || void 0,
      className: S("akuna-selectable-card", n),
      "data-selected": i || void 0,
      disabled: t,
      onClick: s,
      role: "radio",
      type: "button",
      children: [
        r ? /* @__PURE__ */ h("span", { className: "akuna-selectable-card__icon", "aria-hidden": "true", children: r }) : null,
        /* @__PURE__ */ T("span", { className: "akuna-selectable-card__content", children: [
          /* @__PURE__ */ h("span", { className: "akuna-selectable-card__title", children: a }),
          e ? /* @__PURE__ */ h("span", { className: "akuna-selectable-card__description", children: e }) : null
        ] })
      ]
    }
  );
}
function Qb({ className: n, label: e, ...t }) {
  return /* @__PURE__ */ h("div", { "aria-busy": "true", "aria-label": e, className: S("akuna-skeleton", n), role: "status", ...t });
}
function Zb({ className: n, collapsed: e = !1, items: t, label: r = "Sidebar", value: s, ...i }) {
  return /* @__PURE__ */ h("nav", { "aria-label": r, className: S("akuna-sidebar", n), "data-collapsed": e || void 0, ...i, children: t.map((a) => /* @__PURE__ */ h("a", { "aria-current": a.value === s ? "page" : void 0, className: "akuna-sidebar__link", href: a.href, children: a.label }, a.value)) });
}
function Vk({ className: n, label: e, trend: t, value: r, ...s }) {
  return /* @__PURE__ */ T(Uo, { className: S("akuna-stat-card", n), ...s, children: [
    /* @__PURE__ */ h("span", { className: "akuna-stat-card__label", children: e }),
    /* @__PURE__ */ h("strong", { className: "akuna-stat-card__value", children: r }),
    t ? /* @__PURE__ */ h("span", { className: "akuna-stat-card__trend", children: t }) : null
  ] });
}
const Jb = le(({ checked: n, className: e, defaultChecked: t, label: r, onCheckedChange: s, ...i }, a) => {
  const [o, l] = Z(t ?? !1), u = n ?? o;
  return /* @__PURE__ */ T("label", { className: S("akuna-switch", e), children: [
    /* @__PURE__ */ h(
      "input",
      {
        ref: a,
        checked: u,
        className: "akuna-switch__native",
        onChange: (c) => {
          l(c.currentTarget.checked), s == null || s(c.currentTarget.checked);
        },
        role: "switch",
        type: "checkbox",
        ...i
      }
    ),
    /* @__PURE__ */ h("span", { "aria-hidden": "true", className: "akuna-switch__track", children: /* @__PURE__ */ h("span", { className: "akuna-switch__thumb" }) }),
    r ? /* @__PURE__ */ h("span", { className: "akuna-choice__label", children: r }) : null
  ] });
});
Jb.displayName = "Switch";
function Bk({ className: n, defaultValue: e, items: t, onValueChange: r, value: s, ...i }) {
  var d, f, p;
  const [a, o] = Z(e ?? ((d = t[0]) == null ? void 0 : d.value)), l = s ?? a, u = Math.max(0, t.findIndex((g) => g.value === l));
  function c(g) {
    o(g), r == null || r(g);
  }
  return /* @__PURE__ */ T("div", { className: S("akuna-tabs", n), ...i, children: [
    /* @__PURE__ */ h("div", { className: "akuna-tabs__list", role: "tablist", children: t.map((g, y) => /* @__PURE__ */ h(
      "button",
      {
        "aria-controls": `akuna-tabpanel-${g.value}`,
        "aria-selected": g.value === l,
        className: "akuna-tabs__trigger",
        id: `akuna-tab-${g.value}`,
        onClick: () => c(g.value),
        onKeyDown: (b) => {
          b.key === "ArrowRight" && (b.preventDefault(), c(t[(y + 1) % t.length].value)), b.key === "ArrowLeft" && (b.preventDefault(), c(t[(y - 1 + t.length) % t.length].value));
        },
        role: "tab",
        tabIndex: g.value === l ? 0 : -1,
        type: "button",
        children: g.label
      },
      g.value
    )) }),
    /* @__PURE__ */ h("div", { "aria-labelledby": `akuna-tab-${(f = t[u]) == null ? void 0 : f.value}`, className: "akuna-tabs__panel", id: `akuna-tabpanel-${l}`, role: "tabpanel", children: (p = t[u]) == null ? void 0 : p.content })
  ] });
}
const ek = le(({ className: n, invalid: e, rows: t = 4, ...r }, s) => {
  const i = Dr({
    "aria-describedby": r["aria-describedby"],
    "aria-invalid": r["aria-invalid"],
    id: r.id,
    invalid: e
  });
  return /* @__PURE__ */ h("textarea", { ref: s, className: S("akuna-control akuna-textarea", n), rows: t, ...r, ...i });
});
ek.displayName = "Textarea";
function tk({ actions: n, className: e, leading: t, title: r, ...s }) {
  return /* @__PURE__ */ T("header", { className: S("akuna-top-bar", e), ...s, children: [
    /* @__PURE__ */ h("div", { className: "akuna-top-bar__leading", children: t }),
    /* @__PURE__ */ h("div", { className: "akuna-top-bar__title", children: r }),
    /* @__PURE__ */ h("div", { className: "akuna-top-bar__actions", children: n })
  ] });
}
function Lk({ actionLabel: n, className: e, description: t, onDismiss: r, title: s, variant: i = "default", ...a }) {
  return /* @__PURE__ */ T("div", { className: S("akuna-toast", e), "data-variant": i, role: "status", ...a, children: [
    /* @__PURE__ */ T("div", { className: "akuna-toast__body", children: [
      /* @__PURE__ */ h("strong", { children: s }),
      t ? /* @__PURE__ */ h("span", { children: t }) : null
    ] }),
    n ? /* @__PURE__ */ h(ht, { onClick: r, size: "sm", variant: "ghost", children: n }) : null
  ] });
}
const nk = 8;
function jk({ children: n, className: e, content: t }) {
  const r = Tt(), [s, i] = Z(!1), [a, o] = Z(null), l = Ie(null);
  if (!In(n))
    return null;
  const u = () => {
    var g;
    const p = (g = l.current) == null ? void 0 : g.getBoundingClientRect();
    p && o({ top: p.top - nk, left: p.left + p.width / 2 });
  }, c = () => {
    u(), i(!0);
  }, d = () => i(!1), f = n.ref;
  return /* @__PURE__ */ T(je, { children: [
    Fo(n, {
      ref: (p) => {
        l.current = p, typeof f == "function" ? f(p) : f && typeof f == "object" && (f.current = p);
      },
      "aria-describedby": s ? r : void 0,
      onBlur: d,
      onFocus: c,
      onMouseEnter: c,
      onMouseLeave: d
    }),
    s && a ? mc(
      /* @__PURE__ */ h(
        "span",
        {
          className: S("akuna-tooltip__content", e),
          id: r,
          role: "tooltip",
          style: { top: a.top, left: a.left },
          children: t
        }
      ),
      document.body
    ) : null
  ] });
}
function Wk({ className: n, label: e, max: t = 100, value: r, ...s }) {
  const i = Math.min(Math.max(r, 0), t), a = t > 0 ? i / t * 100 : 0;
  return /* @__PURE__ */ h(
    "div",
    {
      "aria-label": e,
      "aria-valuemax": t,
      "aria-valuemin": 0,
      "aria-valuenow": i,
      className: S("akuna-progress", n),
      role: "progressbar",
      ...s,
      children: /* @__PURE__ */ h("span", { className: "akuna-progress__bar", style: { inlineSize: `${a}%` } })
    }
  );
}
function Yk({ children: n, className: e, sticky: t = !1, ...r }) {
  return /* @__PURE__ */ h("div", { className: S("akuna-action-bar", t && "akuna-action-bar--sticky akuna-safe-bottom", e), role: "toolbar", ...r, children: n });
}
function $k({ children: n, className: e, closeLabel: t, onClose: r, title: s, ...i }) {
  return /* @__PURE__ */ T("aside", { className: S("akuna-detail-panel", e), ...i, children: [
    /* @__PURE__ */ T("div", { className: "akuna-detail-panel__header", children: [
      /* @__PURE__ */ h("h2", { children: s }),
      /* @__PURE__ */ h(Ni, { label: t, onClick: r, variant: "ghost", children: /* @__PURE__ */ h(yr, { "aria-hidden": "true", size: 18 }) })
    ] }),
    /* @__PURE__ */ h("div", { className: "akuna-detail-panel__body", children: n })
  ] });
}
function zk({ actions: n, activeCount: e = 0, children: t, className: r, summaryLabel: s, ...i }) {
  return /* @__PURE__ */ T("div", { className: S("akuna-filter-bar", r), "data-active-count": e, ...i, children: [
    /* @__PURE__ */ h("div", { "aria-live": "polite", className: "akuna-filter-bar__summary", children: s ?? `${e} filtros ativos` }),
    /* @__PURE__ */ h("div", { className: "akuna-filter-bar__controls", children: t }),
    n ? /* @__PURE__ */ h("div", { className: "akuna-filter-bar__actions", children: n }) : null
  ] });
}
function Uk({ children: n, className: e, description: t, title: r, ...s }) {
  return /* @__PURE__ */ T("fieldset", { className: S("akuna-form-section", e), ...s, children: [
    /* @__PURE__ */ h("legend", { children: r }),
    t ? /* @__PURE__ */ h("p", { children: t }) : null,
    /* @__PURE__ */ h("div", { className: "akuna-form-section__content", children: n })
  ] });
}
function Hk({ actions: n, breadcrumb: e, className: t, description: r, eyebrow: s, title: i, ...a }) {
  return /* @__PURE__ */ T("header", { className: S("akuna-page-header", t), ...a, children: [
    e ? /* @__PURE__ */ h("div", { className: "akuna-page-header__breadcrumb", children: e }) : null,
    /* @__PURE__ */ T("div", { className: "akuna-page-header__content", children: [
      /* @__PURE__ */ T("div", { className: "akuna-page-header__copy", children: [
        s ? /* @__PURE__ */ h("p", { className: "akuna-page-header__eyebrow", children: s }) : null,
        /* @__PURE__ */ h("h1", { children: i }),
        r ? /* @__PURE__ */ h("p", { className: "akuna-page-header__description", children: r }) : null
      ] }),
      n ? /* @__PURE__ */ h("div", { className: "akuna-page-header__actions", children: n }) : null
    ] })
  ] });
}
function qk({
  className: n,
  columns: e,
  emptyContent: t,
  emptyTitle: r = "Nenhum resultado",
  expandLabel: s = "Ver detalhes",
  getItemId: i,
  getItemLabel: a,
  isRowExpandable: o,
  items: l,
  loading: u = !1,
  loadingLabel: c = "Carregando dados",
  renderExpandedRow: d,
  renderMobileActions: f,
  ...p
}) {
  const g = Si("(min-width: 48rem)", !0), [y, b] = Z([]), k = (m) => {
    b((_) => _.includes(m) ? _.filter((v) => v !== m) : [..._, m]);
  }, w = (m) => !!d && (o ? o(m) : !0);
  return u ? /* @__PURE__ */ h(Qb, { label: c }) : l.length === 0 ? /* @__PURE__ */ h(je, { children: t ?? /* @__PURE__ */ h(mb, { title: r }) }) : /* @__PURE__ */ h("div", { className: S("akuna-data-view", n), ...p, children: g ? /* @__PURE__ */ T("table", { className: "akuna-data-view__table", children: [
    /* @__PURE__ */ h("thead", { children: /* @__PURE__ */ T("tr", { children: [
      e.map((m) => /* @__PURE__ */ h("th", { scope: "col", children: m.header }, m.id)),
      /* @__PURE__ */ h("th", { className: "akuna-data-view__expand-cell", scope: "col" })
    ] }) }),
    /* @__PURE__ */ h("tbody", { children: l.map((m) => {
      const _ = i(m), v = w(m), x = v && y.includes(_);
      return /* @__PURE__ */ T(gr, { children: [
        /* @__PURE__ */ T("tr", { children: [
          e.map((P) => /* @__PURE__ */ h("td", { children: P.cell(m) }, P.id)),
          /* @__PURE__ */ h("td", { className: "akuna-data-view__expand-cell", children: v ? /* @__PURE__ */ h(
            "button",
            {
              "aria-expanded": x,
              className: "akuna-data-view__expand-trigger",
              onClick: () => k(_),
              type: "button",
              children: s
            }
          ) : null })
        ] }),
        x ? /* @__PURE__ */ h("tr", { className: "akuna-data-view__expanded-row", children: /* @__PURE__ */ h("td", { colSpan: e.length + 1, children: d == null ? void 0 : d(m) }) }) : null
      ] }, _);
    }) })
  ] }) : /* @__PURE__ */ h("div", { className: "akuna-data-view__cards", role: "list", children: l.map((m) => /* @__PURE__ */ T("article", { "aria-label": a(m), className: "akuna-data-view__card", role: "listitem", children: [
    e.filter((_) => _.priority !== "hidden-mobile").map((_) => /* @__PURE__ */ T("div", { className: "akuna-data-view__mobile-row", "data-priority": _.priority, children: [
      _.mobileLabel ? /* @__PURE__ */ h("span", { children: _.mobileLabel }) : null,
      /* @__PURE__ */ h("strong", { children: _.cell(m) })
    ] }, _.id)),
    w(m) ? /* @__PURE__ */ T("div", { className: "akuna-data-view__expand", children: [
      /* @__PURE__ */ h(
        "button",
        {
          "aria-expanded": y.includes(i(m)),
          className: "akuna-data-view__expand-trigger",
          onClick: () => k(i(m)),
          type: "button",
          children: s
        }
      ),
      y.includes(i(m)) ? /* @__PURE__ */ h("div", { className: "akuna-data-view__expanded-content", children: d == null ? void 0 : d(m) }) : null
    ] }) : null,
    f ? /* @__PURE__ */ h("div", { className: "akuna-data-view__actions", children: f(m) }) : null
  ] }, i(m))) }) });
}
function Gk({
  brand: n,
  children: e,
  className: t,
  desktopNavigationLabel: r = "Navegação principal",
  mobileNavigation: s,
  mobileNavigationLabel: i = "Navegação inferior",
  navigation: a,
  sidebarCollapsed: o,
  skipLabel: l = "Pular para conteúdo",
  topBar: u,
  value: c,
  ...d
}) {
  const f = Si("(min-width: 48rem)", !0);
  return /* @__PURE__ */ T("div", { className: S("akuna-app-shell", t), ...d, children: [
    /* @__PURE__ */ h("a", { className: "akuna-app-shell__skip", href: "#akuna-main", children: l }),
    u ?? /* @__PURE__ */ h(tk, { title: n }),
    /* @__PURE__ */ T("div", { className: "akuna-app-shell__body", children: [
      f && a ? /* @__PURE__ */ h(Zb, { collapsed: o, items: a, label: r, value: c }) : null,
      /* @__PURE__ */ h("main", { className: "akuna-app-shell__main", id: "akuna-main", tabIndex: -1, children: e })
    ] }),
    !f && (s ?? a) ? /* @__PURE__ */ h(md, { items: s ?? a ?? [], label: i, value: c }) : null
  ] });
}
const rk = le(({ className: n, decorative: e = !0, ...t }, r) => /* @__PURE__ */ h("hr", { ref: r, "aria-hidden": e || void 0, className: S("akuna-separator", n), ...t }));
rk.displayName = "Separator";
const sk = le(({ className: n, variant: e = "card", ...t }, r) => /* @__PURE__ */ h("div", { ref: r, className: S("akuna-surface", `akuna-surface--${e}`, n), ...t }));
sk.displayName = "Surface";
const ik = le(
  ({ asChild: n = !1, className: e, variant: t = "body", ...r }, s) => /* @__PURE__ */ h(n ? Ro : "p", { ref: s, className: S("akuna-typography", `akuna-typography--${t}`, e), ...r })
);
ik.displayName = "Typography";
const ak = le(({ className: n, ...e }, t) => /* @__PURE__ */ h("span", { ref: t, className: S("akuna-visually-hidden", n), ...e }));
ak.displayName = "VisuallyHidden";
const Kk = "@akuna/ui";
export {
  Kk as AKUNA_UI_PACKAGE,
  Yk as ActionBar,
  hk as Alert,
  pk as AlertDescription,
  mk as AlertDialog,
  fk as AlertTitle,
  Gk as AppShell,
  gk as Avatar,
  pd as Badge,
  md as BottomNavigation,
  vk as Breadcrumb,
  ht as Button,
  Uo as Card,
  _u as Checkbox,
  Ak as ColorSwatchPicker,
  Pk as Combobox,
  Hb as CurrencyInput,
  yk as DataTable,
  fb as DatePicker,
  Ck as DetailHeader,
  $k as DetailPanel,
  pb as Dialog,
  Sk as Drawer,
  Nk as DropdownMenu,
  mb as EmptyState,
  on as Field,
  Xm as FieldDescription,
  Qm as FieldError,
  ln as FieldLabel,
  zk as FilterBar,
  Ok as FilterMenu,
  Uk as FormSection,
  Mk as GlassBottomNavigation,
  nn as Icon,
  Ni as IconButton,
  Er as Input,
  Ub as MaskedInput,
  Dk as MobileAppHeader,
  Km as MoreSheet,
  Ri as NumberInput,
  Hk as PageHeader,
  gd as Pagination,
  qb as PercentInput,
  vd as Popover,
  Wk as Progress,
  Rk as RadioGroup,
  qk as ResponsiveDataView,
  Gb as SearchField,
  Kb as SearchFieldTrigger,
  Ek as SegmentedTabs,
  Xb as Select,
  Ik as SelectableCard,
  rk as Separator,
  Zb as Sidebar,
  Qb as Skeleton,
  Vk as StatCard,
  sk as Surface,
  Jb as Switch,
  xk as TableAvatar,
  wk as TableChip,
  bk as TablePill,
  kk as TableStatus,
  _k as TableTag,
  Bk as Tabs,
  ek as Textarea,
  Lk as Toast,
  jk as Tooltip,
  tk as TopBar,
  ik as Typography,
  ak as VisuallyHidden,
  fd as buttonVariants,
  hb as useAdaptive,
  Si as useMediaQuery
};
